export default [
  {
    code: 'AD',
    name: 'Andorra',
    code2: 'AD',
    code3: 'AND',
    capital: 'Andorra la Vella',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '07',
        name: 'Andorra la Vella'
      },
      {
        code: '02',
        name: 'Canillo'
      },
      {
        code: '03',
        name: 'Encamp'
      },
      {
        code: '08',
        name: 'Escaldes-Engordany'
      },
      {
        code: '04',
        name: 'La Massana'
      },
      {
        code: '05',
        name: 'Ordino'
      },
      {
        code: '06',
        name: 'Sant Julià de Lòria'
      }
    ]
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    code2: 'AE',
    code3: 'ARE',
    capital: 'Abu Dhabi',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'AJ',
        name: 'Ajman'
      },
      {
        code: 'AZ',
        name: 'Abu Dhabi'
      },
      {
        code: 'DU',
        name: 'Dubai'
      },
      {
        code: 'FU',
        name: 'Al Fujayrah'
      },
      {
        code: 'RK',
        name: 'Ras al Khaymah'
      },
      {
        code: 'SH',
        name: 'Ash Sharjah'
      },
      {
        code: 'UQ',
        name: 'Umm al Qaywayn'
      }
    ]
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    code2: 'AF',
    code3: 'AFG',
    capital: 'Kabul',
    region: 'Asia',
    subregion: 'Southern Asia',
    states: [
      {
        code: 'BDS',
        name: 'Badakhshan'
      },
      {
        code: 'BDG',
        name: 'Badghis'
      },
      {
        code: 'BGL',
        name: 'Baghlan'
      },
      {
        code: 'BAL',
        name: 'Balkh'
      },
      {
        code: 'BAM',
        name: 'Bamyan'
      },
      {
        code: 'DAY',
        name: 'Daykundi'
      },
      {
        code: 'FRA',
        name: 'Farah'
      },
      {
        code: 'FYB',
        name: 'Faryab'
      },
      {
        code: 'GHA',
        name: 'Ghazni'
      },
      {
        code: 'GHO',
        name: 'Ghōr'
      },
      {
        code: 'HEL',
        name: 'Helmand'
      },
      {
        code: 'HER',
        name: 'Herat'
      },
      {
        code: 'JOW',
        name: 'Jowzjan'
      },
      {
        code: 'KAB',
        name: 'Kabul'
      },
      {
        code: 'KAN',
        name: 'Kandahar'
      },
      {
        code: 'KAP',
        name: 'Kapisa'
      },
      {
        code: 'KHO',
        name: 'Khost'
      },
      {
        code: 'KNR',
        name: 'Kunar'
      },
      {
        code: 'KDZ',
        name: 'Kunduz'
      },
      {
        code: 'LAG',
        name: 'Laghman'
      },
      {
        code: 'LOG',
        name: 'Logar'
      },
      {
        code: 'NAN',
        name: 'Nangarhar'
      },
      {
        code: 'NIM',
        name: 'Nimruz'
      },
      {
        code: 'NUR',
        name: 'Nuristan'
      },
      {
        code: 'PKA',
        name: 'Paktika'
      },
      {
        code: 'PIA',
        name: 'Paktia'
      },
      {
        code: 'PAN',
        name: 'Panjshir'
      },
      {
        code: 'PAR',
        name: 'Parwan'
      },
      {
        code: 'SAM',
        name: 'Samangan'
      },
      {
        code: 'SAR',
        name: 'Sar-e Pol'
      },
      {
        code: 'TAK',
        name: 'Takhar'
      },
      {
        code: 'URU',
        name: 'Urozgan'
      },
      {
        code: 'WAR',
        name: 'Maidan Wardak'
      },
      {
        code: 'ZAB',
        name: 'Zabul'
      }
    ]
  },
  {
    code: 'AI',
    name: 'Anguilla',
    code2: 'AI',
    code3: 'AIA',
    capital: 'The Valley',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'AI',
        name: 'Anguilla'
      }
    ]
  },
  {
    code: 'AL',
    name: 'Albania',
    code2: 'AL',
    code3: 'ALB',
    capital: 'Tirana',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '01',
        name: 'Berat'
      },
      {
        code: '02',
        name: 'Durres'
      },
      {
        code: '03',
        name: 'Elbasan'
      },
      {
        code: '04',
        name: 'Fier'
      },
      {
        code: '05',
        name: 'Gjirokaster'
      },
      {
        code: '06',
        name: 'Korce'
      },
      {
        code: '07',
        name: 'Kukes'
      },
      {
        code: '08',
        name: 'Lezhe'
      },
      {
        code: '09',
        name: 'Diber'
      },
      {
        code: '10',
        name: 'Shkoder'
      },
      {
        code: '11',
        name: 'Tirane'
      },
      {
        code: '12',
        name: 'Vlore'
      }
    ]
  },
  {
    code: 'AM',
    name: 'Armenia',
    code2: 'AM',
    code3: 'ARM',
    capital: 'Yerevan',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'AG',
        name: 'Aragatsotn'
      },
      {
        code: 'AR',
        name: 'Ararat'
      },
      {
        code: 'AV',
        name: 'Armavir'
      },
      {
        code: 'ER',
        name: 'Yerevan'
      },
      {
        code: 'GR',
        name: 'Gegharkunik'
      },
      {
        code: 'KT',
        name: 'Kotayk'
      },
      {
        code: 'LO',
        name: 'Lori'
      },
      {
        code: 'SH',
        name: 'Shirak'
      },
      {
        code: 'SU',
        name: 'Syunik'
      },
      {
        code: 'TV',
        name: 'Tavush'
      },
      {
        code: 'VD',
        name: 'Vayots Dzor'
      }
    ]
  },
  {
    code: 'AO',
    name: 'Angola',
    code2: 'AO',
    code3: 'AGO',
    capital: 'Luanda',
    region: 'Africa',
    subregion: 'Middle Africa',
    states: [
      {
        code: 'BGO',
        name: 'Bengo'
      },
      {
        code: 'BGU',
        name: 'Benguela'
      },
      {
        code: 'BIE',
        name: 'Bie'
      },
      {
        code: 'CAB',
        name: 'Cabinda'
      },
      {
        code: 'CCU',
        name: 'Cuando Cubango'
      },
      {
        code: 'CNN',
        name: 'Cunene'
      },
      {
        code: 'CNO',
        name: 'Cuanza Norte'
      },
      {
        code: 'CUS',
        name: 'Cuanza Sul'
      },
      {
        code: 'HUA',
        name: 'Huambo'
      },
      {
        code: 'HUI',
        name: 'Huila'
      },
      {
        code: 'LNO',
        name: 'Lunda Norte'
      },
      {
        code: 'LSU',
        name: 'Lunda Sul'
      },
      {
        code: 'LUA',
        name: 'Luanda'
      },
      {
        code: 'MAL',
        name: 'Malanje'
      },
      {
        code: 'MOX',
        name: 'Moxico'
      },
      {
        code: 'NAM',
        name: 'Namibe'
      },
      {
        code: 'UIG',
        name: 'Uige'
      },
      {
        code: 'ZAI',
        name: 'Zaire'
      }
    ]
  },
  {
    code: 'AR',
    name: 'Argentina',
    code2: 'AR',
    code3: 'ARG',
    capital: 'Buenos Aires',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'B',
        name: 'Buenos Aires'
      },
      {
        code: 'K',
        name: 'Catamarca'
      },
      {
        code: 'H',
        name: 'Chaco'
      },
      {
        code: 'U',
        name: 'Chubut'
      },
      {
        code: 'C',
        name: 'Ciudad Autónoma de Buenos Aires'
      },
      {
        code: 'W',
        name: 'Corrientes'
      },
      {
        code: 'X',
        name: 'Córdoba'
      },
      {
        code: 'E',
        name: 'Entre Ríos'
      },
      {
        code: 'P',
        name: 'Formosa'
      },
      {
        code: 'Y',
        name: 'Jujuy'
      },
      {
        code: 'L',
        name: 'La Pampa'
      },
      {
        code: 'F',
        name: 'La Rioja'
      },
      {
        code: 'M',
        name: 'Mendoza'
      },
      {
        code: 'N',
        name: 'Misiones'
      },
      {
        code: 'Q',
        name: 'Neuquén'
      },
      {
        code: 'R',
        name: 'Río Negro'
      },
      {
        code: 'A',
        name: 'Salta'
      },
      {
        code: 'J',
        name: 'San Juan'
      },
      {
        code: 'D',
        name: 'San Luis'
      },
      {
        code: 'Z',
        name: 'Santa Cruz'
      },
      {
        code: 'S',
        name: 'Santa Fe'
      },
      {
        code: 'G',
        name: 'Santiago del Estero'
      },
      {
        code: 'V',
        name: 'Tierra del Fuego'
      },
      {
        code: 'T',
        name: 'Tucumán'
      }
    ]
  },
  {
    code: 'AS',
    name: 'American Samoa',
    code2: 'AS',
    code3: 'ASM',
    capital: 'Pago Pago',
    region: 'Oceania',
    subregion: 'Polynesia',
    states: [
      {
        code: 'AS',
        name: 'Samoa, America'
      }
    ]
  },
  {
    code: 'AT',
    name: 'Austria',
    code2: 'AT',
    code3: 'AUT',
    capital: 'Vienna',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: '01',
        name: 'Burgenland'
      },
      {
        code: '02',
        name: 'Carinthia'
      },
      {
        code: '03',
        name: 'Lower Austria'
      },
      {
        code: '04',
        name: 'Upper Austria'
      },
      {
        code: '05',
        name: 'Salzburg'
      },
      {
        code: '06',
        name: 'Styria'
      },
      {
        code: '07',
        name: 'Tyrol'
      },
      {
        code: '08',
        name: 'Vorarlberg'
      },
      {
        code: '09',
        name: 'Vienna'
      }
    ]
  },
  {
    code: 'AU',
    name: 'Australia',
    code2: 'AU',
    code3: 'AUS',
    capital: 'Canberra',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
    states: [
      {
        code: 'ACT',
        name: 'Aust Capital Terr'
      },
      {
        code: 'NSW',
        name: 'New South Wales'
      },
      {
        code: 'NT',
        name: 'Northern Territory'
      },
      {
        code: 'QLD',
        name: 'Queensland'
      },
      {
        code: 'SA',
        name: 'South Australia'
      },
      {
        code: 'TAS',
        name: 'Tasmania'
      },
      {
        code: 'VIC',
        name: 'Victoria'
      },
      {
        code: 'WA',
        name: 'Western Australia'
      }
    ]
  },
  {
    code: 'AW',
    name: 'Aruba',
    code2: 'AW',
    code3: 'ABW',
    capital: 'Oranjestad',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'AW',
        name: 'Aruba'
      }
    ]
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    code2: 'AZ',
    code3: 'AZE',
    capital: 'Baku',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'ABS',
        name: 'Absheron'
      },
      {
        code: 'AGC',
        name: 'Aghjabadi'
      },
      {
        code: 'AGM',
        name: 'Aghdam'
      },
      {
        code: 'AGS',
        name: 'Agdash'
      },
      {
        code: 'AGA',
        name: 'Aghstafa'
      },
      {
        code: 'AGU',
        name: 'Aghsu'
      },
      {
        code: 'AST',
        name: 'Astara'
      },
      {
        code: 'BAB',
        name: 'Babek'
      },
      {
        code: 'BA',
        name: 'Baku'
      },
      {
        code: 'BAL',
        name: 'Balakan'
      },
      {
        code: 'BAR',
        name: 'Barda'
      },
      {
        code: 'BEY',
        name: 'Beylagan'
      },
      {
        code: 'BIL',
        name: 'Bilasuvar'
      },
      {
        code: 'CAB',
        name: 'Jabrayil'
      },
      {
        code: 'CAL',
        name: 'Jalilabad'
      },
      {
        code: 'CUL',
        name: 'Julfa'
      },
      {
        code: 'DAS',
        name: 'Dashkasan'
      },
      {
        code: 'FUZ',
        name: 'Fuzuli'
      },
      {
        code: 'GAD',
        name: 'Gadabay'
      },
      {
        code: 'GA',
        name: 'Ganja'
      },
      {
        code: 'GOR',
        name: 'Goranboy'
      },
      {
        code: 'GOY',
        name: 'Goychay'
      },
      {
        code: 'GYG',
        name: 'Goygol'
      },
      {
        code: 'HAC',
        name: 'Hajigabul'
      },
      {
        code: 'IMI',
        name: 'Imishli'
      },
      {
        code: 'ISM',
        name: 'Ismayilli'
      },
      {
        code: 'KAL',
        name: 'Kalbajar'
      },
      {
        code: 'KAN',
        name: 'Kangarli'
      },
      {
        code: 'KUR',
        name: 'Kurdamir'
      },
      {
        code: 'LAC',
        name: 'Lachin'
      },
      {
        code: 'LA',
        name: 'Lankaran City'
      },
      {
        code: 'LAN',
        name: 'Lankaran'
      },
      {
        code: 'LER',
        name: 'Lerik'
      },
      {
        code: 'MAS',
        name: 'Masally'
      },
      {
        code: 'MI',
        name: 'Mingachevir'
      },
      {
        code: 'NA',
        name: 'Naftalan'
      },
      {
        code: 'NV',
        name: 'Nakhchivan City'
      },
      {
        code: 'NEF',
        name: 'Neftchala'
      },
      {
        code: 'OGU',
        name: 'Oghuz'
      },
      {
        code: 'ORD',
        name: 'Ordubad'
      },
      {
        code: 'QAX',
        name: 'Gakh'
      },
      {
        code: 'QAZ',
        name: 'Gazakh'
      },
      {
        code: 'QAB',
        name: 'Gabala'
      },
      {
        code: 'QOB',
        name: 'Gobustan'
      },
      {
        code: 'QBA',
        name: 'Guba'
      },
      {
        code: 'QBI',
        name: 'Gubadlı'
      },
      {
        code: 'QUS',
        name: 'Gusar'
      },
      {
        code: 'SAT',
        name: 'Saatly'
      },
      {
        code: 'SAB',
        name: 'Sabirabad'
      },
      {
        code: 'SBN',
        name: 'Shabran'
      },
      {
        code: 'SAH',
        name: 'Shahbuz'
      },
      {
        code: 'SAL',
        name: 'Salyan'
      },
      {
        code: 'SMI',
        name: 'Shamakhi'
      },
      {
        code: 'SMX',
        name: 'Samukh'
      },
      {
        code: 'SAD',
        name: 'Sadarak'
      },
      {
        code: 'SA',
        name: 'Shaki City'
      },
      {
        code: 'SAK',
        name: 'Shaki'
      },
      {
        code: 'SKR',
        name: 'Shamkir'
      },
      {
        code: 'SAR',
        name: 'Sharur'
      },
      {
        code: 'SR',
        name: 'Shirvan'
      },
      {
        code: 'SIY',
        name: 'Siyazan'
      },
      {
        code: 'SM',
        name: 'Sumgayit'
      },
      {
        code: 'SUS',
        name: 'Shusha'
      },
      {
        code: 'TAR',
        name: 'Tartar'
      },
      {
        code: 'TOV',
        name: 'Tovuz'
      },
      {
        code: 'UCA',
        name: 'Ujar'
      },
      {
        code: 'XAC',
        name: 'Khachmaz'
      },
      {
        code: 'XA',
        name: 'Khankendi'
      },
      {
        code: 'XIZ',
        name: 'Khizi'
      },
      {
        code: 'XCI',
        name: 'Khojaly'
      },
      {
        code: 'XVD',
        name: 'Khojavend'
      },
      {
        code: 'YAR',
        name: 'Yardimli'
      },
      {
        code: 'YE',
        name: 'Yevlakh City'
      },
      {
        code: 'YEV',
        name: 'Yevlakh'
      },
      {
        code: 'ZAQ',
        name: 'Zagatala'
      },
      {
        code: 'ZAN',
        name: 'Zangilan'
      },
      {
        code: 'ZAR',
        name: 'Zardab'
      }
    ]
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    code2: 'BA',
    code3: 'BIH',
    capital: 'Sarajevo',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: 'BIH',
        name: 'Federacija Bosna i H'
      },
      {
        code: 'SRP',
        name: 'Republika Srpska'
      },
      {
        code: 'BRC',
        name: 'Brčko District'
      }
    ]
  },
  {
    code: 'BB',
    name: 'Barbados',
    code2: 'BB',
    code3: 'BRB',
    capital: 'Bridgetown',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: '01',
        name: 'Christ Church'
      },
      {
        code: '02',
        name: 'Saint Andrew'
      },
      {
        code: '03',
        name: 'Saint George'
      },
      {
        code: '04',
        name: 'Saint James'
      },
      {
        code: '05',
        name: 'Saint John'
      },
      {
        code: '06',
        name: 'Saint Joseph'
      },
      {
        code: '07',
        name: 'Saint Lucy'
      },
      {
        code: '08',
        name: 'Saint Michael'
      },
      {
        code: '09',
        name: 'Saint Peter'
      },
      {
        code: '10',
        name: 'Saint Philip'
      },
      {
        code: '11',
        name: 'Saint Thomas'
      }
    ]
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    code2: 'BD',
    code3: 'BGD',
    capital: 'Dhaka',
    region: 'Asia',
    subregion: 'Southern Asia',
    states: [
      {
        code: '01',
        name: 'Bandarban'
      },
      {
        code: '02',
        name: 'Barguna'
      },
      {
        code: '03',
        name: 'Bogura'
      },
      {
        code: '04',
        name: 'Brahmanbaria'
      },
      {
        code: '05',
        name: 'Bagerhat'
      },
      {
        code: '06',
        name: 'Barishal'
      },
      {
        code: '07',
        name: 'Bhola'
      },
      {
        code: '08',
        name: 'Cumilla'
      },
      {
        code: '09',
        name: 'Chandpur'
      },
      {
        code: '10',
        name: 'Chattogram'
      },
      {
        code: '11',
        name: "Cox's Bazar"
      },
      {
        code: '12',
        name: 'Chuadanga'
      },
      {
        code: '13',
        name: 'Dhaka'
      },
      {
        code: '14',
        name: 'Dinajpur'
      },
      {
        code: '15',
        name: 'Faridpur'
      },
      {
        code: '16',
        name: 'Feni'
      },
      {
        code: '17',
        name: 'Gopalganj'
      },
      {
        code: '18',
        name: 'Gazipur'
      },
      {
        code: '19',
        name: 'Gaibandha'
      },
      {
        code: '20',
        name: 'Habiganj'
      },
      {
        code: '21',
        name: 'Jamalpur'
      },
      {
        code: '22',
        name: 'Jashore'
      },
      {
        code: '23',
        name: 'Jhenaidah'
      },
      {
        code: '24',
        name: 'Joypurhat'
      },
      {
        code: '25',
        name: 'Jhalakathi'
      },
      {
        code: '26',
        name: 'Kishoreganj'
      },
      {
        code: '27',
        name: 'Khulna'
      },
      {
        code: '28',
        name: 'Kurigram'
      },
      {
        code: '29',
        name: 'Khagrachhari'
      },
      {
        code: '30',
        name: 'Kushtia'
      },
      {
        code: '31',
        name: 'Lakshmipur'
      },
      {
        code: '32',
        name: 'Lalmonirhat'
      },
      {
        code: '33',
        name: 'Manikganj'
      },
      {
        code: '34',
        name: 'Mymensingh'
      },
      {
        code: '35',
        name: 'Munshiganj'
      },
      {
        code: '36',
        name: 'Madaripur'
      },
      {
        code: '37',
        name: 'Magura'
      },
      {
        code: '38',
        name: 'Moulvibazar'
      },
      {
        code: '39',
        name: 'Meherpur'
      },
      {
        code: '40',
        name: 'Narayanganj'
      },
      {
        code: '41',
        name: 'Netrakona'
      },
      {
        code: '42',
        name: 'Narsingdi'
      },
      {
        code: '43',
        name: 'Narail'
      },
      {
        code: '44',
        name: 'Natore'
      },
      {
        code: '45',
        name: 'Chapai Nawabganj'
      },
      {
        code: '46',
        name: 'Nilphamari'
      },
      {
        code: '47',
        name: 'Noakhali'
      },
      {
        code: '48',
        name: 'Naogaon'
      },
      {
        code: '49',
        name: 'Pabna'
      },
      {
        code: '50',
        name: 'Pirojpur'
      },
      {
        code: '51',
        name: 'Patuakhali'
      },
      {
        code: '52',
        name: 'Panchagarh'
      },
      {
        code: '53',
        name: 'Rajbari'
      },
      {
        code: '54',
        name: 'Rajshahi'
      },
      {
        code: '55',
        name: 'Rangpur'
      },
      {
        code: '56',
        name: 'Rangamati'
      },
      {
        code: '57',
        name: 'Sherpur'
      },
      {
        code: '58',
        name: 'Satkhira'
      },
      {
        code: '59',
        name: 'Sirajganj'
      },
      {
        code: '60',
        name: 'Sylhet'
      },
      {
        code: '61',
        name: 'Sunamganj'
      },
      {
        code: '62',
        name: 'Shariatpur'
      },
      {
        code: '63',
        name: 'Tangail'
      },
      {
        code: '64',
        name: 'Thakurgaon'
      }
    ]
  },
  {
    code: 'BE',
    name: 'Belgium',
    code2: 'BE',
    code3: 'BEL',
    capital: 'Brussels',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'BRU',
        name: 'Brussels (Capital)'
      },
      {
        code: 'VLG',
        name: 'Flanders'
      },
      {
        code: 'WAL',
        name: 'Wallonia'
      }
    ]
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    code2: 'BF',
    code3: 'BFA',
    capital: 'Ouagadougou',
    region: 'Africa',
    subregion: 'Western Africa',
    states: [
      {
        code: 'BAL',
        name: 'Bale'
      },
      {
        code: 'BAM',
        name: 'Bam'
      },
      {
        code: 'BAN',
        name: 'Banwa'
      },
      {
        code: 'BAZ',
        name: 'Bazega'
      },
      {
        code: 'BGR',
        name: 'Bougouriba'
      },
      {
        code: 'BLG',
        name: 'Boulgou'
      },
      {
        code: 'BLK',
        name: 'Boulkiemde'
      },
      {
        code: 'COM',
        name: 'Comoe'
      },
      {
        code: 'GAN',
        name: 'Ganzourgou'
      },
      {
        code: 'GNA',
        name: 'Gnagna'
      },
      {
        code: 'GOU',
        name: 'Gourma'
      },
      {
        code: 'HOU',
        name: 'Houet'
      },
      {
        code: 'IOB',
        name: 'Ioba'
      },
      {
        code: 'KAD',
        name: 'Kadiogo'
      },
      {
        code: 'KEN',
        name: 'Kénedougou'
      },
      {
        code: 'KMD',
        name: 'Komondjari'
      },
      {
        code: 'KMP',
        name: 'Kompienga'
      },
      {
        code: 'KOP',
        name: 'Koulpelogo'
      },
      {
        code: 'KOS',
        name: 'Kossi'
      },
      {
        code: 'KOT',
        name: 'Kouritenga'
      },
      {
        code: 'KOW',
        name: 'Kourweogo'
      },
      {
        code: 'LER',
        name: 'Leraba'
      },
      {
        code: 'LOR',
        name: 'Loroum'
      },
      {
        code: 'MOU',
        name: 'Mouhoun'
      },
      {
        code: 'NAM',
        name: 'Namentenga'
      },
      {
        code: 'NAO',
        name: 'Nahouri'
      },
      {
        code: 'NAY',
        name: 'Nayala'
      },
      {
        code: 'NOU',
        name: 'Noumbiel'
      },
      {
        code: 'OUB',
        name: 'Oubritenga'
      },
      {
        code: 'OUD',
        name: 'Oudalan'
      },
      {
        code: 'PAS',
        name: 'Passore'
      },
      {
        code: 'PON',
        name: 'Poni'
      },
      {
        code: 'SEN',
        name: 'Seno'
      },
      {
        code: 'SIS',
        name: 'Sissili'
      },
      {
        code: 'SMT',
        name: 'Sanmatenga'
      },
      {
        code: 'SNG',
        name: 'Sanguie'
      },
      {
        code: 'SOM',
        name: 'Soum'
      },
      {
        code: 'SOR',
        name: 'Sourou'
      },
      {
        code: 'TAP',
        name: 'Tapoa'
      },
      {
        code: 'TUI',
        name: 'Tuy'
      },
      {
        code: 'YAG',
        name: 'Yagha'
      },
      {
        code: 'YAT',
        name: 'Yatenga'
      },
      {
        code: 'ZIR',
        name: 'Ziro'
      },
      {
        code: 'ZON',
        name: 'Zondoma'
      },
      {
        code: 'ZOU',
        name: 'Zoundweogo'
      }
    ]
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    code2: 'BG',
    code3: 'BGR',
    capital: 'Sofia',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: '01',
        name: 'Blagoevgrad'
      },
      {
        code: '02',
        name: 'Burgas'
      },
      {
        code: '03',
        name: 'Varna'
      },
      {
        code: '04',
        name: 'Veliko Tarnovo'
      },
      {
        code: '05',
        name: 'Vidin'
      },
      {
        code: '06',
        name: 'Vratsa'
      },
      {
        code: '07',
        name: 'Gabrovo'
      },
      {
        code: '08',
        name: 'Dobrich'
      },
      {
        code: '09',
        name: 'Kardzhali'
      },
      {
        code: '10',
        name: 'Kyustendil'
      },
      {
        code: '11',
        name: 'Lovech'
      },
      {
        code: '12',
        name: 'Montana'
      },
      {
        code: '13',
        name: 'Pazardzhik'
      },
      {
        code: '14',
        name: 'Pernik'
      },
      {
        code: '15',
        name: 'Pleven'
      },
      {
        code: '16',
        name: 'Plovdiv'
      },
      {
        code: '17',
        name: 'Razgrad'
      },
      {
        code: '18',
        name: 'Ruse'
      },
      {
        code: '19',
        name: 'Silistra'
      },
      {
        code: '20',
        name: 'Sliven'
      },
      {
        code: '21',
        name: 'Smolyan'
      },
      {
        code: '22',
        name: 'Sofia-Grad'
      },
      {
        code: '23',
        name: 'Sofia'
      },
      {
        code: '24',
        name: 'Stara Zagora'
      },
      {
        code: '25',
        name: 'Targovishte'
      },
      {
        code: '26',
        name: 'Haskovo'
      },
      {
        code: '27',
        name: 'Shumen'
      },
      {
        code: '28',
        name: 'Yambol'
      }
    ]
  },
  {
    code: 'BH',
    name: 'Bahrain',
    code2: 'BH',
    code3: 'BHR',
    capital: 'Manama',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: '13',
        name: 'Capital Governorate'
      },
      {
        code: '14',
        name: 'Southern Governorate'
      },
      {
        code: '15',
        name: 'Muharraq Governorate'
      },
      {
        code: '17',
        name: 'Northern Governorate'
      }
    ]
  },
  {
    code: 'BM',
    name: 'Bermuda',
    code2: 'BM',
    code3: 'BMU',
    capital: 'Hamilton',
    region: 'Americas',
    subregion: 'Northern America',
    states: [
      {
        code: 'BM',
        name: 'Bermuda'
      }
    ]
  },
  {
    code: 'BO',
    name: 'Bolivia',
    code2: 'BO',
    code3: 'BOL',
    capital: 'Sucre',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'B',
        name: 'El Beni'
      },
      {
        code: 'C',
        name: 'Cochabamba'
      },
      {
        code: 'H',
        name: 'Chuquisaca'
      },
      {
        code: 'L',
        name: 'La Paz'
      },
      {
        code: 'N',
        name: 'Pando'
      },
      {
        code: 'O',
        name: 'Oruro'
      },
      {
        code: 'P',
        name: 'Potosi'
      },
      {
        code: 'S',
        name: 'Santa Cruz'
      },
      {
        code: 'T',
        name: 'Tarija'
      }
    ]
  },
  {
    code: 'BR',
    name: 'Brazil',
    code2: 'BR',
    code3: 'BRA',
    capital: 'Brasília',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'AC',
        name: 'Acre'
      },
      {
        code: 'AL',
        name: 'Alagoas'
      },
      {
        code: 'AM',
        name: 'Amazonas'
      },
      {
        code: 'AP',
        name: 'Amapa'
      },
      {
        code: 'BA',
        name: 'Bahia'
      },
      {
        code: 'CE',
        name: 'Ceara'
      },
      {
        code: 'DF',
        name: 'Distrito Federal'
      },
      {
        code: 'ES',
        name: 'Espirito Santo'
      },
      {
        code: 'GO',
        name: 'Goias'
      },
      {
        code: 'MA',
        name: 'Maranhao'
      },
      {
        code: 'MG',
        name: 'Minas Gerais'
      },
      {
        code: 'MS',
        name: 'Mato Grosso do Sul'
      },
      {
        code: 'MT',
        name: 'Mato Grosso'
      },
      {
        code: 'PA',
        name: 'Para'
      },
      {
        code: 'PB',
        name: 'Paraiba'
      },
      {
        code: 'PE',
        name: 'Pernambucco'
      },
      {
        code: 'PI',
        name: 'Piaui'
      },
      {
        code: 'PR',
        name: 'Parana'
      },
      {
        code: 'RJ',
        name: 'Rio de Janeiro'
      },
      {
        code: 'RN',
        name: 'Rio Grande do Norte'
      },
      {
        code: 'RO',
        name: 'Rondonia'
      },
      {
        code: 'RR',
        name: 'Roraima'
      },
      {
        code: 'RS',
        name: 'Rio Dgrande do Sul'
      },
      {
        code: 'SC',
        name: 'Satan Catarina'
      },
      {
        code: 'SE',
        name: 'Sergipe'
      },
      {
        code: 'SP',
        name: 'Sao Paulo'
      },
      {
        code: 'TO',
        name: 'Tocantins'
      }
    ]
  },
  {
    code: 'BS',
    name: 'Bahamas',
    code2: 'BS',
    code3: 'BHS',
    capital: 'Nassau',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'AK',
        name: 'Acklins'
      },
      {
        code: 'BY',
        name: 'Berry Islands'
      },
      {
        code: 'BI',
        name: 'Bimini'
      },
      {
        code: 'BP',
        name: 'Black Point'
      },
      {
        code: 'CI',
        name: 'Cat Island'
      },
      {
        code: 'CO',
        name: 'Central Abaco'
      },
      {
        code: 'CS',
        name: 'Central Andros'
      },
      {
        code: 'CE',
        name: 'Central Eleuthera'
      },
      {
        code: 'FP',
        name: 'City of Freeport'
      },
      {
        code: 'CK',
        name: 'Crooked Island and Long Cay'
      },
      {
        code: 'EG',
        name: 'East Grand Bahama'
      },
      {
        code: 'EX',
        name: 'Exuma'
      },
      {
        code: 'GC',
        name: 'Grand Cay'
      },
      {
        code: 'HI',
        name: 'Harbour Island'
      },
      {
        code: 'HT',
        name: 'Hope Town'
      },
      {
        code: 'IN',
        name: 'Inagua'
      },
      {
        code: 'LI',
        name: 'Long Island'
      },
      {
        code: 'MC',
        name: 'Mangrove Cay'
      },
      {
        code: 'MG',
        name: 'Mayaguana'
      },
      {
        code: 'MI',
        name: "Moore's Island"
      },
      {
        code: 'NP',
        name: 'New Providence'
      },
      {
        code: 'NO',
        name: 'North Abaco'
      },
      {
        code: 'NS',
        name: 'North Andros'
      },
      {
        code: 'NE',
        name: 'North Eleuthera'
      },
      {
        code: 'RI',
        name: 'Ragged Island'
      },
      {
        code: 'RC',
        name: 'Rum Cay'
      },
      {
        code: 'SS',
        name: 'San Salvador'
      },
      {
        code: 'SO',
        name: 'South Abaco'
      },
      {
        code: 'SA',
        name: 'South Andros'
      },
      {
        code: 'SE',
        name: 'South Eleuthera'
      },
      {
        code: 'SW',
        name: 'Spanish Wells'
      },
      {
        code: 'WG',
        name: 'West Grand Bahama'
      }
    ]
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
    code2: 'BV',
    code3: 'BVT',
    states: [
      {
        code: 'BV',
        name: 'Bouvet Islands'
      }
    ]
  },
  {
    code: 'BW',
    name: 'Botswana',
    code2: 'BW',
    code3: 'BWA',
    capital: 'Gaborone',
    region: 'Africa',
    subregion: 'Southern Africa',
    states: [
      {
        code: 'CE',
        name: 'Central'
      },
      {
        code: 'CH',
        name: 'Chobe'
      },
      {
        code: 'FR',
        name: 'Francistown'
      },
      {
        code: 'GA',
        name: 'Gaborone'
      },
      {
        code: 'GH',
        name: 'Ghanzi'
      },
      {
        code: 'JW',
        name: 'Jwaneng'
      },
      {
        code: 'KG',
        name: 'Kgalagadi'
      },
      {
        code: 'KL',
        name: 'Kgatleng'
      },
      {
        code: 'KW',
        name: 'Kweneng'
      },
      {
        code: 'LO',
        name: 'Lobatse'
      },
      {
        code: 'NE',
        name: 'North East'
      },
      {
        code: 'NW',
        name: 'North West'
      },
      {
        code: 'SP',
        name: 'Selibe Phikwe'
      },
      {
        code: 'SE',
        name: 'South East'
      },
      {
        code: 'SO',
        name: 'Southern'
      },
      {
        code: 'ST',
        name: 'Sowa Town'
      }
    ]
  },
  {
    code: 'BY',
    name: 'Belarus',
    code2: 'BY',
    code3: 'BLR',
    capital: 'Minsk',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: 'BR',
        name: 'Brest'
      },
      {
        code: 'HO',
        name: 'Gomel'
      },
      {
        code: 'HM',
        name: 'Minsk City'
      },
      {
        code: 'HR',
        name: 'Grodno'
      },
      {
        code: 'MA',
        name: 'Mogilev'
      },
      {
        code: 'MI',
        name: 'Minsk'
      },
      {
        code: 'VI',
        name: 'Vitebsk'
      }
    ]
  },
  {
    code: 'BZ',
    name: 'Belize',
    code2: 'BZ',
    code3: 'BLZ',
    capital: 'Belmopan',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: 'BZ',
        name: 'Belize'
      },
      {
        code: 'CY',
        name: 'Cayo'
      },
      {
        code: 'CZL',
        name: 'Corozal'
      },
      {
        code: 'OW',
        name: 'Orange Walk'
      },
      {
        code: 'SC',
        name: 'Stann Creek'
      },
      {
        code: 'TOL',
        name: 'Toledo'
      }
    ]
  },
  {
    code: 'CA',
    name: 'Canada',
    code2: 'CA',
    code3: 'CAN',
    capital: 'Ottawa',
    region: 'Americas',
    subregion: 'Northern America',
    states: [
      {
        code: 'AB',
        name: 'Alberta'
      },
      {
        code: 'BC',
        name: 'British Columbia'
      },
      {
        code: 'MB',
        name: 'Manitoba'
      },
      {
        code: 'NB',
        name: 'New Brunswick'
      },
      {
        code: 'NL',
        name: 'Newfoundland and Labrador'
      },
      {
        code: 'NT',
        name: 'Northwest Territories'
      },
      {
        code: 'NS',
        name: 'Nova Scotia'
      },
      {
        code: 'NU',
        name: 'Nunavut'
      },
      {
        code: 'ON',
        name: 'Ontario'
      },
      {
        code: 'PE',
        name: 'Prince Edward Island'
      },
      {
        code: 'QC',
        name: 'Quebec'
      },
      {
        code: 'SK',
        name: 'Saskatchewan'
      },
      {
        code: 'YT',
        name: 'Yukon'
      }
    ]
  },
  {
    code: 'CC',
    name: 'Keeling Islands',
    code2: 'CC',
    code3: 'CCK',
    capital: 'West Island',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
    states: [
      {
        code: 'CC',
        name: 'Keeling Islands'
      }
    ]
  },
  {
    code: 'CH',
    name: 'Switzerland',
    code2: 'CH',
    code3: 'CHE',
    capital: 'Bern',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'AG',
        name: 'Aargau'
      },
      {
        code: 'AR',
        name: 'Ausser-Rhoden'
      },
      {
        code: 'AI',
        name: 'Inner-Rhoden'
      },
      {
        code: 'BL',
        name: 'Basel Land'
      },
      {
        code: 'BS',
        name: 'Basel Stadt'
      },
      {
        code: 'BE',
        name: 'Bern'
      },
      {
        code: 'FR',
        name: 'Fribourg'
      },
      {
        code: 'GE',
        name: 'Genève'
      },
      {
        code: 'GL',
        name: 'Glarus'
      },
      {
        code: 'GR',
        name: 'Graubuenden'
      },
      {
        code: 'JU',
        name: 'Jura'
      },
      {
        code: 'LU',
        name: 'Luzern'
      },
      {
        code: 'NE',
        name: 'Neuchatel'
      },
      {
        code: 'NW',
        name: 'Nidwalden'
      },
      {
        code: 'OW',
        name: 'Obwalden'
      },
      {
        code: 'SG',
        name: 'St. Gallen'
      },
      {
        code: 'SH',
        name: 'Schaffhausen'
      },
      {
        code: 'SZ',
        name: 'Schwyz'
      },
      {
        code: 'SO',
        name: 'Solothurn'
      },
      {
        code: 'TG',
        name: 'Thurgau'
      },
      {
        code: 'TI',
        name: 'Ticino'
      },
      {
        code: 'UR',
        name: 'Uri'
      },
      {
        code: 'VS',
        name: 'Valais'
      },
      {
        code: 'VD',
        name: 'Vaud'
      },
      {
        code: 'ZG',
        name: 'Zug'
      },
      {
        code: 'ZH',
        name: 'Zurich'
      }
    ]
  },
  {
    code: 'CI',
    name: "Côte d'Ivoire",
    code2: 'CI',
    code3: 'CIV',
    capital: 'Yamoussoukro',
    region: 'Africa',
    subregion: 'Western Africa',
    states: [
      {
        code: 'AB',
        name: 'Abidjan'
      },
      {
        code: 'BS',
        name: 'Bas-Sassandra'
      },
      {
        code: 'CM',
        name: 'Comoé'
      },
      {
        code: 'DN',
        name: 'Denguélé'
      },
      {
        code: 'GD',
        name: 'Gôh-Djiboua'
      },
      {
        code: 'LC',
        name: 'Lacs'
      },
      {
        code: 'LG',
        name: 'Lagunes'
      },
      {
        code: 'MG',
        name: 'Montagnes'
      },
      {
        code: 'SM',
        name: 'Sassandra-Marahoué'
      },
      {
        code: 'SV',
        name: 'Savanes'
      },
      {
        code: 'VB',
        name: 'Vallée du Bandama'
      },
      {
        code: 'WR',
        name: 'Woroba'
      },
      {
        code: 'YM',
        name: 'Yamoussoukro'
      },
      {
        code: 'ZZ',
        name: 'Zanzan'
      }
    ]
  },
  {
    code: 'CL',
    name: 'Chile',
    code2: 'CL',
    code3: 'CHL',
    capital: 'Santiago',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'AI',
        name: 'Aisén del General Carlos Ibañez del Campo'
      },
      {
        code: 'AN',
        name: 'Antofagasta'
      },
      {
        code: 'AP',
        name: 'Arica y Parinacota'
      },
      {
        code: 'AT',
        name: 'Atacama'
      },
      {
        code: 'BI',
        name: 'Biobío'
      },
      {
        code: 'CO',
        name: 'Coquimbo'
      },
      {
        code: 'AR',
        name: 'La Araucanía'
      },
      {
        code: 'LI',
        name: "Libertador General Bernardo O'Higgins"
      },
      {
        code: 'LL',
        name: 'Los Lagos'
      },
      {
        code: 'LR',
        name: 'Los Ríos'
      },
      {
        code: 'MA',
        name: 'Magallanes'
      },
      {
        code: 'ML',
        name: 'Maule'
      },
      {
        code: 'NB',
        name: 'Ñuble'
      },
      {
        code: 'RM',
        name: 'Región Metropolitana de Santiago'
      },
      {
        code: 'TA',
        name: 'Tarapacá'
      },
      {
        code: 'VS',
        name: 'Valparaíso'
      }
    ]
  },
  {
    code2: 'CN',
    code3: 'CHN',
    name: 'China',
    nameSimplifiedChinese: '中国',
    nameTraditionalChinese: '中國',
    capital: 'Beijing',
    region: 'Asia',
    subregion: 'Eastern Asia',
    states: [
      {
        code: '010',
        name: 'Beijing',
        nameCN: '北京',
        nameCNTraditional: '北京',
        subdivision: null
      },
      {
        code: '020',
        name: 'Shanghai',
        nameCN: '上海',
        nameCNTraditional: '上海',
        subdivision: null
      },
      {
        code: '030',
        name: 'Tianjin',
        nameCN: '天津',
        nameCNTraditional: '天津',
        subdivision: null
      },
      {
        code: '040',
        name: 'Nei Mongol',
        nameCN: '内蒙古',
        nameCNTraditional: '內蒙古',
        subdivision: null
      },
      {
        code: '050',
        name: 'Shanxi',
        nameCN: '山西',
        nameCNTraditional: '山西',
        subdivision: null
      },
      {
        code: '060',
        name: 'Hebei',
        nameCN: '河北',
        nameCNTraditional: '河北',
        subdivision: null
      },
      {
        code: '070',
        name: 'Liaoning',
        nameCN: '辽宁',
        nameCNTraditional: '遼寧',
        subdivision: null
      },
      {
        code: '080',
        name: 'Jilin',
        nameCN: '吉林',
        nameCNTraditional: '吉林',
        subdivision: null
      },
      {
        code: '090',
        name: 'Heilongjiang',
        nameCN: '黑龙江',
        nameCNTraditional: '黑龍江',
        subdivision: null
      },
      {
        code: '100',
        name: 'Jiangsu',
        nameCN: '江苏',
        nameCNTraditional: '江蘇',
        subdivision: null
      },
      {
        code: '110',
        name: 'Anhui',
        nameCN: '安徽',
        nameCNTraditional: '安徽',
        subdivision: null
      },
      {
        code: '120',
        name: 'Shandong',
        nameCN: '山东',
        nameCNTraditional: '山東',
        subdivision: null
      },
      {
        code: '130',
        name: 'Zhejiang',
        nameCN: '浙江',
        nameCNTraditional: '浙江',
        subdivision: null
      },
      {
        code: '140',
        name: 'Jiangxi',
        nameCN: '江西',
        nameCNTraditional: '江西',
        subdivision: null
      },
      {
        code: '150',
        name: 'Fujian',
        nameCN: '福建',
        nameCNTraditional: '福建',
        subdivision: null
      },
      {
        code: '160',
        name: 'Hunan',
        nameCN: '湖南',
        nameCNTraditional: '湖南',
        subdivision: null
      },
      {
        code: '170',
        name: 'Hubei',
        nameCN: '湖北',
        nameCNTraditional: '湖北',
        subdivision: null
      },
      {
        code: '180',
        name: 'Henan',
        nameCN: '河南',
        nameCNTraditional: '河南',
        subdivision: null
      },
      {
        code: '190',
        name: 'Guangdong',
        nameCN: '广东',
        nameCNTraditional: '廣東',
        subdivision: null
      },
      {
        code: '200',
        name: 'Hainan',
        nameCN: '海南',
        nameCNTraditional: '海南',
        subdivision: null
      },
      {
        code: '210',
        name: 'Guangxi',
        nameCN: '广西',
        nameCNTraditional: '廣西',
        subdivision: null
      },
      {
        code: '220',
        name: 'Guizhou',
        nameCN: '贵州',
        nameCNTraditional: '貴州',
        subdivision: null
      },
      {
        code: '230',
        name: 'Sichuan',
        nameCN: '四川',
        nameCNTraditional: '四川',
        subdivision: null
      },
      {
        code: '240',
        name: 'Yunnan',
        nameCN: '云南',
        nameCNTraditional: '雲南',
        subdivision: null
      },
      {
        code: '250',
        name: 'Shaanxi',
        nameCN: '陕西',
        nameCNTraditional: '陝西',
        subdivision: null
      },
      {
        code: '260',
        name: 'Gansu',
        nameCN: '甘肃',
        nameCNTraditional: '甘肅',
        subdivision: null
      },
      {
        code: '270',
        name: 'Ningxia',
        nameCN: '宁夏',
        nameCNTraditional: '寧夏',
        subdivision: null
      },
      {
        code: '280',
        name: 'Qinghai',
        nameCN: '青海',
        nameCNTraditional: '青海',
        subdivision: null
      },
      {
        code: '290',
        name: 'Xinjiang',
        nameCN: '新疆',
        nameCNTraditional: '新疆',
        subdivision: null
      },
      {
        code: '300',
        name: 'Xizang',
        nameCN: '西藏',
        nameCNTraditional: '西藏',
        subdivision: null
      },
      {
        code: '320',
        name: 'Chongqing',
        nameCN: '重庆',
        nameCNTraditional: '重慶',
        subdivision: null
      }
    ]
  },
  {
    code: 'CM',
    name: 'Cameroon',
    code2: 'CM',
    code3: 'CMR',
    capital: 'Yaoundé',
    region: 'Africa',
    subregion: 'Middle Africa',
    states: [
      {
        code: 'AD',
        name: 'Adamaoua'
      },
      {
        code: 'CE',
        name: 'Centre'
      },
      {
        code: 'ES',
        name: 'East'
      },
      {
        code: 'EN',
        name: 'Far North'
      },
      {
        code: 'LT',
        name: 'Littoral'
      },
      {
        code: 'NO',
        name: 'North'
      },
      {
        code: 'NW',
        name: 'North-West'
      },
      {
        code: 'SU',
        name: 'South'
      },
      {
        code: 'SW',
        name: 'South-West'
      },
      {
        code: 'OU',
        name: 'West'
      }
    ]
  },
  {
    code: 'CO',
    name: 'Colombia',
    code2: 'CO',
    code3: 'COL',
    capital: 'Bogotá',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'AMA',
        name: 'Amazonia'
      },
      {
        code: 'ANT',
        name: 'Antioquia'
      },
      {
        code: 'ARA',
        name: 'Arauca'
      },
      {
        code: 'ATL',
        name: 'Atlantico'
      },
      {
        code: 'BOL',
        name: 'Bolivar'
      },
      {
        code: 'BOY',
        name: 'Boyaca'
      },
      {
        code: 'CAL',
        name: 'Caldas'
      },
      {
        code: 'CAQ',
        name: 'Caqueta'
      },
      {
        code: 'CAS',
        name: 'Casanare'
      },
      {
        code: 'CAU',
        name: 'Cauca'
      },
      {
        code: 'CES',
        name: 'Cesar'
      },
      {
        code: 'COR',
        name: 'Cordoba'
      },
      {
        code: 'CUN',
        name: 'Cundinamarca'
      },
      {
        code: 'CHO',
        name: 'Choco'
      },
      {
        code: 'DC',
        name: 'Bogota'
      },
      {
        code: 'GUA',
        name: 'Guainia'
      },
      {
        code: 'GUV',
        name: 'Guaviare'
      },
      {
        code: 'HUI',
        name: 'Huila'
      },
      {
        code: 'LAG',
        name: 'La Guajira'
      },
      {
        code: 'MAG',
        name: 'Magdalena'
      },
      {
        code: 'MET',
        name: 'Meta'
      },
      {
        code: 'NAR',
        name: 'Narino'
      },
      {
        code: 'NSA',
        name: 'North Santander'
      },
      {
        code: 'PUT',
        name: 'Putumayo'
      },
      {
        code: 'QUI',
        name: 'Quindio'
      },
      {
        code: 'RIS',
        name: 'Risaralda'
      },
      {
        code: 'SAP',
        name: 'San Andres'
      },
      {
        code: 'SAN',
        name: 'Santander'
      },
      {
        code: 'SUC',
        name: 'Sucre'
      },
      {
        code: 'TOL',
        name: 'Tolima'
      },
      {
        code: 'VAC',
        name: 'Cauca Valley'
      },
      {
        code: 'VAU',
        name: 'Vaupes'
      },
      {
        code: 'VID',
        name: 'Vichada'
      }
    ]
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    code2: 'CR',
    code3: 'CRI',
    capital: 'San José',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: 'A',
        name: 'Alajuela'
      },
      {
        code: 'C',
        name: 'Cartago'
      },
      {
        code: 'G',
        name: 'Guanacaste'
      },
      {
        code: 'H',
        name: 'Heredia'
      },
      {
        code: 'L',
        name: 'Limón'
      },
      {
        code: 'P',
        name: 'Puntarenas'
      },
      {
        code: 'SJ',
        name: 'San José'
      }
    ]
  },
  {
    code: 'CY',
    name: 'Cyprus',
    code2: 'CY',
    code3: 'CYP',
    capital: 'Nicosia',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '4',
        name: 'Ammochostos'
      },
      {
        code: '6',
        name: 'Keryneia'
      },
      {
        code: '3',
        name: 'Larnaka'
      },
      {
        code: '1',
        name: 'Lefkosia'
      },
      {
        code: '2',
        name: 'Lemesos'
      },
      {
        code: '5',
        name: 'Pafos'
      }
    ]
  },
  {
    code: 'CZ',
    name: 'Czechia',
    code2: 'CZ',
    code3: 'CZE',
    capital: 'Prague',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: '31',
        name: 'South Bohemia'
      },
      {
        code: '64',
        name: 'South Moravia'
      },
      {
        code: '41',
        name: 'Karlovy Vary'
      },
      {
        code: '52',
        name: 'Hradec Králové'
      },
      {
        code: '51',
        name: 'Liberec'
      },
      {
        code: '80',
        name: 'Moravia-Silesia'
      },
      {
        code: '71',
        name: 'Olomouc'
      },
      {
        code: '53',
        name: 'Pardubice'
      },
      {
        code: '32',
        name: 'Plzeň'
      },
      {
        code: '10',
        name: 'Prague'
      },
      {
        code: '20',
        name: 'Central Bohemia'
      },
      {
        code: '42',
        name: 'Ústí nad Labem'
      },
      {
        code: '63',
        name: 'Vysočina'
      },
      {
        code: '72',
        name: 'Zlín'
      }
    ]
  },
  {
    code: 'DE',
    name: 'Germany',
    code2: 'DE',
    code3: 'DEU',
    capital: 'Berlin',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'BW',
        name: 'Baden-Württemberg'
      },
      {
        code: 'BY',
        name: 'Bavaria'
      },
      {
        code: 'BE',
        name: 'Berlin'
      },
      {
        code: 'BB',
        name: 'Brandenburg'
      },
      {
        code: 'HB',
        name: 'Bremen'
      },
      {
        code: 'HH',
        name: 'Hamburg'
      },
      {
        code: 'HE',
        name: 'Hesse'
      },
      {
        code: 'MV',
        name: 'Mecklenburg-Western Pomerania'
      },
      {
        code: 'NI',
        name: 'Lower Saxony'
      },
      {
        code: 'NW',
        name: 'North Rhine-Westphalia'
      },
      {
        code: 'RP',
        name: 'Rhineland-Palatinate'
      },
      {
        code: 'SL',
        name: 'Saarland'
      },
      {
        code: 'SN',
        name: 'Saxony'
      },
      {
        code: 'ST',
        name: 'Saxony-Anhalt'
      },
      {
        code: 'SH',
        name: 'Schleswig-Holstein'
      },
      {
        code: 'TH',
        name: 'Thuringia'
      }
    ]
  },
  {
    code: 'DK',
    name: 'Denmark',
    code2: 'DK',
    code3: 'DNK',
    capital: 'Copenhagen',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: '84',
        name: 'Capital Region'
      },
      {
        code: '82',
        name: 'Central Denmark'
      },
      {
        code: '81',
        name: 'North Denmark'
      },
      {
        code: '85',
        name: 'Zealand'
      },
      {
        code: '83',
        name: 'Southern Denmark'
      }
    ]
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    code2: 'DO',
    code3: 'DOM',
    capital: 'Santo Domingo',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: '02',
        name: 'Azua'
      },
      {
        code: '03',
        name: 'Baoruco'
      },
      {
        code: '04',
        name: 'Barahona'
      },
      {
        code: '05',
        name: 'Dajabon'
      },
      {
        code: '01',
        name: 'Santo Domingo City'
      },
      {
        code: '06',
        name: 'Duarte'
      },
      {
        code: '08',
        name: 'El Seibo'
      },
      {
        code: '07',
        name: 'Elias Pina'
      },
      {
        code: '09',
        name: 'Espaillat'
      },
      {
        code: '30',
        name: 'Great Herd'
      },
      {
        code: '19',
        name: 'Mirabal Sisters'
      },
      {
        code: '10',
        name: 'Independence'
      },
      {
        code: '11',
        name: 'La Altagracia'
      },
      {
        code: '12',
        name: 'La Romana'
      },
      {
        code: '13',
        name: 'La Vega'
      },
      {
        code: '14',
        name: 'Maria Trinidad Sanchez'
      },
      {
        code: '28',
        name: 'Monsignor Nouel'
      },
      {
        code: '15',
        name: 'Christ Mountain'
      },
      {
        code: '29',
        name: 'Silver Mountain'
      },
      {
        code: '16',
        name: 'Pedernales'
      },
      {
        code: '17',
        name: 'Peravia'
      },
      {
        code: '18',
        name: 'Silver Port'
      },
      {
        code: '20',
        name: 'Samana'
      },
      {
        code: '21',
        name: 'Saint Christopher'
      },
      {
        code: '31',
        name: 'Saint Joseph'
      },
      {
        code: '22',
        name: 'Saint John'
      },
      {
        code: '23',
        name: 'Saint Peter'
      },
      {
        code: '24',
        name: 'Sanchez Ramirez'
      },
      {
        code: '25',
        name: 'Santiago'
      },
      {
        code: '26',
        name: 'Santiago Rodriguez'
      },
      {
        code: '32',
        name: 'Santo Domingo'
      },
      {
        code: '27',
        name: 'Valverde'
      }
    ]
  },
  {
    code: 'DZ',
    name: 'Algeria',
    code2: 'DZ',
    code3: 'DZA',
    capital: 'Algiers',
    region: 'Africa',
    subregion: 'Northern Africa',
    states: [
      {
        code: '01',
        name: 'Adrar'
      },
      {
        code: '44',
        name: 'Aïn Defla'
      },
      {
        code: '46',
        name: 'Aïn Témouchent'
      },
      {
        code: '16',
        name: 'Alger'
      },
      {
        code: '23',
        name: 'Annaba'
      },
      {
        code: '05',
        name: 'Batna'
      },
      {
        code: '08',
        name: 'Béchar'
      },
      {
        code: '06',
        name: 'Béjaïa'
      },
      {
        code: '52',
        name: 'Béni Abbès'
      },
      {
        code: '07',
        name: 'Biskra'
      },
      {
        code: '09',
        name: 'Blida'
      },
      {
        code: '50',
        name: 'Bordj Badji Mokhtar'
      },
      {
        code: '34',
        name: 'Bordj Bou Arréridj'
      },
      {
        code: '10',
        name: 'Bouira'
      },
      {
        code: '35',
        name: 'Boumerdès'
      },
      {
        code: '02',
        name: 'Chlef'
      },
      {
        code: '25',
        name: 'Constantine'
      },
      {
        code: '56',
        name: 'Djanet'
      },
      {
        code: '17',
        name: 'Djelfa'
      },
      {
        code: '32',
        name: 'El Bayadh'
      },
      {
        code: '57',
        name: 'El Meghaier'
      },
      {
        code: '58',
        name: 'El Meniaa'
      },
      {
        code: '39',
        name: 'El Oued'
      },
      {
        code: '36',
        name: 'El Tarf'
      },
      {
        code: '47',
        name: 'Ghardaïa'
      },
      {
        code: '24',
        name: 'Guelma'
      },
      {
        code: '33',
        name: 'Illizi'
      },
      {
        code: '54',
        name: 'In Guezzam'
      },
      {
        code: '53',
        name: 'In Salah'
      },
      {
        code: '18',
        name: 'Jijel'
      },
      {
        code: '40',
        name: 'Khenchela'
      },
      {
        code: '03',
        name: 'Laghouat'
      },
      {
        code: '28',
        name: "M'sila"
      },
      {
        code: '29',
        name: 'Mascara'
      },
      {
        code: '26',
        name: 'Médéa'
      },
      {
        code: '43',
        name: 'Mila'
      },
      {
        code: '27',
        name: 'Mostaganem'
      },
      {
        code: '45',
        name: 'Naama'
      },
      {
        code: '31',
        name: 'Oran'
      },
      {
        code: '30',
        name: 'Ouargla'
      },
      {
        code: '51',
        name: 'Ouled Djellal'
      },
      {
        code: '04',
        name: 'Oum el Bouaghi'
      },
      {
        code: '48',
        name: 'Relizane'
      },
      {
        code: '20',
        name: 'Saïda'
      },
      {
        code: '19',
        name: 'Sétif'
      },
      {
        code: '22',
        name: 'Sidi Bel Abbès'
      },
      {
        code: '21',
        name: 'Skikda'
      },
      {
        code: '41',
        name: 'Souk Ahras'
      },
      {
        code: '11',
        name: 'Tamanrasset'
      },
      {
        code: '12',
        name: 'Tébessa'
      },
      {
        code: '14',
        name: 'Tiaret'
      },
      {
        code: '49',
        name: 'Timimoun'
      },
      {
        code: '37',
        name: 'Tindouf'
      },
      {
        code: '42',
        name: 'Tipaza'
      },
      {
        code: '38',
        name: 'Tissemsilt'
      },
      {
        code: '15',
        name: 'Tizi Ouzou'
      },
      {
        code: '13',
        name: 'Tlemcen'
      },
      {
        code: '55',
        name: 'Touggourt'
      }
    ]
  },
  {
    code: 'EC',
    name: 'Ecuador',
    code2: 'EC',
    code3: 'ECU',
    capital: 'Quito',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'A',
        name: 'Azuay'
      },
      {
        code: 'B',
        name: 'Bolivar'
      },
      {
        code: 'F',
        name: 'Canar'
      },
      {
        code: 'C',
        name: 'Carchi'
      },
      {
        code: 'H',
        name: 'Chimborazo'
      },
      {
        code: 'X',
        name: 'Cotopaxi'
      },
      {
        code: 'O',
        name: 'The Gold'
      },
      {
        code: 'E',
        name: 'Esmeraldas'
      },
      {
        code: 'W',
        name: 'Galapagos'
      },
      {
        code: 'G',
        name: 'Guayas'
      },
      {
        code: 'I',
        name: 'Imbabura'
      },
      {
        code: 'L',
        name: 'Loja'
      },
      {
        code: 'R',
        name: 'The Rivers'
      },
      {
        code: 'M',
        name: 'Manabi'
      },
      {
        code: 'S',
        name: 'Morona Santiago'
      },
      {
        code: 'N',
        name: 'Napo'
      },
      {
        code: 'D',
        name: 'Orellana'
      },
      {
        code: 'Y',
        name: 'Pastaza'
      },
      {
        code: 'P',
        name: 'Pichincha'
      },
      {
        code: 'SE',
        name: 'Saint Helen'
      },
      {
        code: 'SD',
        name: 'Saint Dominic'
      },
      {
        code: 'U',
        name: 'Sucumbios'
      },
      {
        code: 'T',
        name: 'Tungurahua'
      },
      {
        code: 'Z',
        name: 'Zamora Chinchipe'
      }
    ]
  },
  {
    code: 'EE',
    name: 'Estonia',
    code2: 'EE',
    code3: 'EST',
    capital: 'Tallinn',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: '37',
        name: 'Harju'
      },
      {
        code: '39',
        name: 'Hiiu'
      },
      {
        code: '45',
        name: 'Ida-Viru'
      },
      {
        code: '50',
        name: 'Jõgeva'
      },
      {
        code: '52',
        name: 'Järva'
      },
      {
        code: '60',
        name: 'Lääne-Viru'
      },
      {
        code: '56',
        name: 'Lääne'
      },
      {
        code: '64',
        name: 'Põlva'
      },
      {
        code: '68',
        name: 'Pärnu'
      },
      {
        code: '71',
        name: 'Rapla'
      },
      {
        code: '74',
        name: 'Saare'
      },
      {
        code: '79',
        name: 'Tartu'
      },
      {
        code: '81',
        name: 'Valga'
      },
      {
        code: '84',
        name: 'Viljandi'
      },
      {
        code: '87',
        name: 'Võru'
      }
    ]
  },
  {
    code: 'EG',
    name: 'Egypt',
    code2: 'EG',
    code3: 'EGY',
    capital: 'Cairo',
    region: 'Africa',
    subregion: 'Northern Africa',
    states: [
      {
        code: 'DK',
        name: 'Dakahlia'
      },
      {
        code: 'BA',
        name: 'Red Sea'
      },
      {
        code: 'BH',
        name: 'Beheira'
      },
      {
        code: 'FYM',
        name: 'Faiyum'
      },
      {
        code: 'GH',
        name: 'Gharbia'
      },
      {
        code: 'ALX',
        name: 'Alexandria'
      },
      {
        code: 'IS',
        name: 'Ismailia'
      },
      {
        code: 'GZ',
        name: 'Giza'
      },
      {
        code: 'MNF',
        name: 'Monufia'
      },
      {
        code: 'MN',
        name: 'Minya'
      },
      {
        code: 'C',
        name: 'Cairo'
      },
      {
        code: 'KB',
        name: 'Qalyubia'
      },
      {
        code: 'LX',
        name: 'Luxor'
      },
      {
        code: 'WAD',
        name: 'New Valley'
      },
      {
        code: 'SUZ',
        name: 'Suez'
      },
      {
        code: 'SHR',
        name: 'Al Sharqia'
      },
      {
        code: 'ASN',
        name: 'Aswan'
      },
      {
        code: 'AST',
        name: 'Asyut'
      },
      {
        code: 'BNS',
        name: 'Beni Suef'
      },
      {
        code: 'PTS',
        name: 'Port Said'
      },
      {
        code: 'DT',
        name: 'Damietta'
      },
      {
        code: 'JS',
        name: 'South Sinai'
      },
      {
        code: 'KFS',
        name: 'Kafr el-Sheikh'
      },
      {
        code: 'MT',
        name: 'Matrouh'
      },
      {
        code: 'KN',
        name: 'Qena'
      },
      {
        code: 'SIN',
        name: 'North Sinai'
      },
      {
        code: 'SHG',
        name: 'Sohag'
      }
    ]
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    code2: 'EH',
    code3: 'ESH',
    capital: 'El Aaiún',
    region: 'Africa',
    subregion: 'Northern Africa',
    states: [
      {
        code: 'EH',
        name: 'West Sahara'
      }
    ]
  },
  {
    code: 'ER',
    name: 'Eritrea',
    code2: 'ER',
    code3: 'ERI',
    capital: 'Asmara',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: 'ER-MA',
        name: 'Central'
      },
      {
        code: 'ER-DU',
        name: 'Southern'
      },
      {
        code: 'ER-AN',
        name: 'Anseba'
      },
      {
        code: 'ER-DK',
        name: 'Southern Red Sea'
      },
      {
        code: 'ER-GB',
        name: 'Gash-Barka'
      },
      {
        code: 'ER-SK',
        name: 'Northern Red Sea'
      }
    ]
  },
  {
    code: 'ES',
    name: 'Spain',
    code2: 'ES',
    code3: 'ESP',
    capital: 'Madrid',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: 'AN',
        name: 'Andalusia'
      },
      {
        code: 'AR',
        name: 'Aragon'
      },
      {
        code: 'AS',
        name: 'Principality of Asturias'
      },
      {
        code: 'CN',
        name: 'Canary Islands'
      },
      {
        code: 'CB',
        name: 'Cantabria'
      },
      {
        code: 'CL',
        name: 'Castile and León'
      },
      {
        code: 'CM',
        name: 'Castile-La Mancha'
      },
      {
        code: 'CT',
        name: 'Catalonia'
      },
      {
        code: 'CE',
        name: 'Ceuta'
      },
      {
        code: 'EX',
        name: 'Extremadura'
      },
      {
        code: 'GA',
        name: 'Galicia'
      },
      {
        code: 'IB',
        name: 'Balearic Islands'
      },
      {
        code: 'RI',
        name: 'La Rioja'
      },
      {
        code: 'MD',
        name: 'Community of Madrid'
      },
      {
        code: 'ML',
        name: 'Melilla'
      },
      {
        code: 'MC',
        name: 'Region of Murcia'
      },
      {
        code: 'NC',
        name: 'Chartered Community of Navarre'
      },
      {
        code: 'PV',
        name: 'Basque Country'
      },
      {
        code: 'VC',
        name: 'Valencian Community'
      }
    ]
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    code2: 'ET',
    code3: 'ETH',
    capital: 'Addis Ababa',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: 'AA',
        name: 'Addis Ababa'
      },
      {
        code: 'AF',
        name: 'Afar'
      },
      {
        code: 'AM',
        name: 'Amara'
      },
      {
        code: 'BE',
        name: 'Benshangul-Gumaz'
      },
      {
        code: 'DD',
        name: 'Dire Dawa'
      },
      {
        code: 'GA',
        name: 'Gambela Peoples'
      },
      {
        code: 'HA',
        name: 'Harari People'
      },
      {
        code: 'OR',
        name: 'Oromia'
      },
      {
        code: 'SI',
        name: 'Sidama'
      },
      {
        code: 'SO',
        name: 'Somali'
      },
      {
        code: 'TI',
        name: 'Tigrai'
      },
      {
        code: 'SN',
        name: 'Southern Nations'
      },
      {
        code: 'SW',
        name: 'SW Ethiopia Peoples'
      }
    ]
  },
  {
    code: 'FI',
    name: 'Finland',
    code2: 'FI',
    code3: 'FIN',
    capital: 'Helsinki',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: '01',
        name: 'Aland'
      },
      {
        code: '02',
        name: 'South Karelia'
      },
      {
        code: '03',
        name: 'Southern Ostrobothni'
      },
      {
        code: '04',
        name: 'Southern Savonia'
      },
      {
        code: '05',
        name: 'Kainuu'
      },
      {
        code: '06',
        name: 'Tavastia Proper'
      },
      {
        code: '07',
        name: 'Central Ostrobothnia'
      },
      {
        code: '08',
        name: 'Central Finland'
      },
      {
        code: '09',
        name: 'Kymenlaakso'
      },
      {
        code: '10',
        name: 'Lapland'
      },
      {
        code: '11',
        name: 'Pirkanmaa'
      },
      {
        code: '12',
        name: 'Ostrobothnia'
      },
      {
        code: '13',
        name: 'North Karelia'
      },
      {
        code: '14',
        name: 'North. Ostrobothnia'
      },
      {
        code: '15',
        name: 'Northern Savonia'
      },
      {
        code: '16',
        name: 'Paijanne Tavastia'
      },
      {
        code: '17',
        name: 'Satakunta'
      },
      {
        code: '18',
        name: 'Uusimaa'
      },
      {
        code: '19',
        name: 'Finland Proper'
      }
    ]
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    code2: 'FO',
    code3: 'FRO',
    capital: 'Tórshavn',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'FO',
        name: 'Faroe Islands'
      }
    ]
  },
  {
    code: 'FR',
    name: 'France',
    code2: 'FR',
    code3: 'FRA',
    capital: 'Paris',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'ARA',
        name: 'Auvergne-Rhône-Alps'
      },
      {
        code: 'BFC',
        name: 'Burgundy-Franche-Comté'
      },
      {
        code: 'BRE',
        name: 'Brittany'
      },
      {
        code: 'CVL',
        name: 'Centre-Loire Valley'
      },
      {
        code: '20R',
        name: 'Corsica'
      },
      {
        code: 'GES',
        name: 'Great East'
      },
      {
        code: 'HDF',
        name: 'Upper France'
      },
      {
        code: 'IDF',
        name: 'Paris'
      },
      {
        code: 'NOR',
        name: 'Normandy'
      },
      {
        code: 'NAQ',
        name: 'New Aquitaine'
      },
      {
        code: 'OCC',
        name: 'Occitania'
      },
      {
        code: 'PDL',
        name: 'Loire Country'
      },
      {
        code: 'PAC',
        name: 'Provence-Alps-French Riviera'
      },
      {
        code: '971',
        name: 'Guadeloupe'
      },
      {
        code: '973',
        name: 'French Guiana'
      },
      {
        code: '974',
        name: 'Réunion'
      },
      {
        code: '972',
        name: 'Martinique'
      },
      {
        code: '976',
        name: 'Mayotte'
      },
      {
        code: 'NC',
        name: 'New Caledonia'
      },
      {
        code: 'PF',
        name: 'French Polynesia'
      },
      {
        code: 'BL',
        name: 'Saint Barthélemy'
      },
      {
        code: 'MF',
        name: 'Saint Martin (French part)'
      },
      {
        code: 'PM',
        name: 'Saint Pierre and Miquelon'
      },
      {
        code: 'TF',
        name: 'French Southern Territories'
      },
      {
        code: 'WF',
        name: 'Wallis and Futuna'
      }
    ]
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    code2: 'GB',
    code3: 'GBR',
    capital: 'London',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'GB',
        name: 'GB Default'
      },
      {
        code: 'CAM',
        name: 'Cambridgeshire'
      },
      {
        code: 'CMA',
        name: 'Cumbria'
      },
      {
        code: 'DBY',
        name: 'Derbyshire'
      },
      {
        code: 'DEV',
        name: 'Devon'
      },
      {
        code: 'DOR',
        name: 'Dorset'
      },
      {
        code: 'ESX',
        name: 'East Sussex'
      },
      {
        code: 'ESS',
        name: 'Essex'
      },
      {
        code: 'GLS',
        name: 'Gloucestershire'
      },
      {
        code: 'HAM',
        name: 'Hampshire'
      },
      {
        code: 'HRT',
        name: 'Hertfordshire'
      },
      {
        code: 'KEN',
        name: 'Kent'
      },
      {
        code: 'LAN',
        name: 'Lancashire'
      },
      {
        code: 'LEC',
        name: 'Leicestershire'
      },
      {
        code: 'LIN',
        name: 'Lincolnshire'
      },
      {
        code: 'NFK',
        name: 'Norfolk'
      },
      {
        code: 'NYK',
        name: 'North Yorkshire'
      },
      {
        code: 'NTT',
        name: 'Nottinghamshire'
      },
      {
        code: 'OXF',
        name: 'Oxfordshire'
      },
      {
        code: 'SOM',
        name: 'Somerset'
      },
      {
        code: 'STS',
        name: 'Staffordshire'
      },
      {
        code: 'SFK',
        name: 'Suffolk'
      },
      {
        code: 'SRY',
        name: 'Surrey'
      },
      {
        code: 'WAR',
        name: 'Warwickshire'
      },
      {
        code: 'WSX',
        name: 'West Sussex'
      },
      {
        code: 'WOR',
        name: 'Worcestershire'
      },
      {
        code: 'LND',
        name: 'London, City of'
      },
      {
        code: 'BDG',
        name: 'Barking and Dagenham'
      },
      {
        code: 'BNE',
        name: 'Barnet'
      },
      {
        code: 'BEX',
        name: 'Bexley'
      },
      {
        code: 'BEN',
        name: 'Brent'
      },
      {
        code: 'BRY',
        name: 'Bromley'
      },
      {
        code: 'CMD',
        name: 'Camden'
      },
      {
        code: 'CRY',
        name: 'Croydon'
      },
      {
        code: 'EAL',
        name: 'Ealing'
      },
      {
        code: 'ENF',
        name: 'Enfield'
      },
      {
        code: 'GRE',
        name: 'Greenwich'
      },
      {
        code: 'HCK',
        name: 'Hackney'
      },
      {
        code: 'HMF',
        name: 'Hammersmith and Fulham'
      },
      {
        code: 'HRY',
        name: 'Haringey'
      },
      {
        code: 'HRW',
        name: 'Harrow'
      },
      {
        code: 'HAV',
        name: 'Havering'
      },
      {
        code: 'HIL',
        name: 'Hillingdon'
      },
      {
        code: 'HNS',
        name: 'Hounslow'
      },
      {
        code: 'ISL',
        name: 'Islington'
      },
      {
        code: 'KEC',
        name: 'Kensington and Chelsea'
      },
      {
        code: 'KTT',
        name: 'Kingston upon Thames'
      },
      {
        code: 'LBH',
        name: 'Lambeth'
      },
      {
        code: 'LEW',
        name: 'Lewisham'
      },
      {
        code: 'MRT',
        name: 'Merton'
      },
      {
        code: 'NWM',
        name: 'Newham'
      },
      {
        code: 'RDB',
        name: 'Redbridge'
      },
      {
        code: 'RIC',
        name: 'Richmond upon Thames'
      },
      {
        code: 'SWK',
        name: 'Southwark'
      },
      {
        code: 'STN',
        name: 'Sutton'
      },
      {
        code: 'TWH',
        name: 'Tower Hamlets'
      },
      {
        code: 'WFT',
        name: 'Waltham Forest'
      },
      {
        code: 'WND',
        name: 'Wandsworth'
      },
      {
        code: 'WSM',
        name: 'Westminster'
      },
      {
        code: 'BNS',
        name: 'Barnsley'
      },
      {
        code: 'BIR',
        name: 'Birmingham'
      },
      {
        code: 'BOL',
        name: 'Bolton'
      },
      {
        code: 'BRD',
        name: 'Bradford'
      },
      {
        code: 'BUR',
        name: 'Bury'
      },
      {
        code: 'CLD',
        name: 'Calderdale'
      },
      {
        code: 'COV',
        name: 'Coventry'
      },
      {
        code: 'DNC',
        name: 'Doncaster'
      },
      {
        code: 'DUD',
        name: 'Dudley'
      },
      {
        code: 'GAT',
        name: 'Gateshead'
      },
      {
        code: 'KIR',
        name: 'Kirklees'
      },
      {
        code: 'KWL',
        name: 'Knowsley'
      },
      {
        code: 'LDS',
        name: 'Leeds'
      },
      {
        code: 'LIV',
        name: 'Liverpool'
      },
      {
        code: 'MAN',
        name: 'Manchester'
      },
      {
        code: 'NET',
        name: 'Newcastle upon Tyne'
      },
      {
        code: 'NTY',
        name: 'North Tyneside'
      },
      {
        code: 'OLD',
        name: 'Oldham'
      },
      {
        code: 'RCH',
        name: 'Rochdale'
      },
      {
        code: 'ROT',
        name: 'Rotherham'
      },
      {
        code: 'SHN',
        name: 'St. Helens'
      },
      {
        code: 'SLF',
        name: 'Salford'
      },
      {
        code: 'SAW',
        name: 'Sandwell'
      },
      {
        code: 'SFT',
        name: 'Sefton'
      },
      {
        code: 'SHF',
        name: 'Sheffield'
      },
      {
        code: 'SOL',
        name: 'Solihull'
      },
      {
        code: 'STY',
        name: 'South Tyneside'
      },
      {
        code: 'SKP',
        name: 'Stockport'
      },
      {
        code: 'SND',
        name: 'Sunderland'
      },
      {
        code: 'TAM',
        name: 'Tameside'
      },
      {
        code: 'TRF',
        name: 'Trafford'
      },
      {
        code: 'WKF',
        name: 'Wakefield'
      },
      {
        code: 'WLL',
        name: 'Walsall'
      },
      {
        code: 'WGN',
        name: 'Wigan'
      },
      {
        code: 'WRL',
        name: 'Wirral'
      },
      {
        code: 'WLV',
        name: 'Wolverhampton'
      },
      {
        code: 'BAS',
        name: 'Bath and North East Somerset'
      },
      {
        code: 'BDF',
        name: 'Bedford'
      },
      {
        code: 'BBD',
        name: 'Blackburn with Darwen'
      },
      {
        code: 'BPL',
        name: 'Blackpool'
      },
      {
        code: 'BCP',
        name: 'Bournemouth, Christchurch and Poole'
      },
      {
        code: 'BRC',
        name: 'Bracknell Forest'
      },
      {
        code: 'BNH',
        name: 'Brighton and Hove'
      },
      {
        code: 'BST',
        name: 'Bristol, City of'
      },
      {
        code: 'BKM',
        name: 'Buckinghamshire'
      },
      {
        code: 'CBF',
        name: 'Central Bedfordshire'
      },
      {
        code: 'CHE',
        name: 'Cheshire East'
      },
      {
        code: 'CHW',
        name: 'Cheshire West and Chester'
      },
      {
        code: 'CON',
        name: 'Cornwall'
      },
      {
        code: 'DAL',
        name: 'Darlington'
      },
      {
        code: 'DER',
        name: 'Derby'
      },
      {
        code: 'DUR',
        name: 'Durham, County'
      },
      {
        code: 'ERY',
        name: 'East Riding of Yorkshire'
      },
      {
        code: 'HAL',
        name: 'Halton'
      },
      {
        code: 'HPL',
        name: 'Hartlepool'
      },
      {
        code: 'HEF',
        name: 'Herefordshire'
      },
      {
        code: 'IOW',
        name: 'Isle of Wight'
      },
      {
        code: 'IOS',
        name: 'Isles of Scilly'
      },
      {
        code: 'KHL',
        name: 'Kingston upon Hull'
      },
      {
        code: 'LCE',
        name: 'Leicester'
      },
      {
        code: 'LUT',
        name: 'Luton'
      },
      {
        code: 'MDW',
        name: 'Medway'
      },
      {
        code: 'MDB',
        name: 'Middlesbrough'
      },
      {
        code: 'MIK',
        name: 'Milton Keynes'
      },
      {
        code: 'NEL',
        name: 'North East Lincolnshire'
      },
      {
        code: 'NLN',
        name: 'North Lincolnshire'
      },
      {
        code: 'NNH',
        name: 'North Northamptonshire'
      },
      {
        code: 'NSM',
        name: 'North Somerset'
      },
      {
        code: 'NBL',
        name: 'Northumberland'
      },
      {
        code: 'NGM',
        name: 'Nottingham'
      },
      {
        code: 'PTE',
        name: 'Peterborough'
      },
      {
        code: 'PLY',
        name: 'Plymouth'
      },
      {
        code: 'POR',
        name: 'Portsmouth'
      },
      {
        code: 'RDG',
        name: 'Reading'
      },
      {
        code: 'RCC',
        name: 'Redcar and Cleveland'
      },
      {
        code: 'RUT',
        name: 'Rutland'
      },
      {
        code: 'SHR',
        name: 'Shropshire'
      },
      {
        code: 'SLG',
        name: 'Slough'
      },
      {
        code: 'SGC',
        name: 'South Gloucestershire'
      },
      {
        code: 'STH',
        name: 'Southampton'
      },
      {
        code: 'SOS',
        name: 'Southend-on-Sea'
      },
      {
        code: 'STT',
        name: 'Stockton-on-Tees'
      },
      {
        code: 'STE',
        name: 'Stoke-on-Trent'
      },
      {
        code: 'SWD',
        name: 'Swindon'
      },
      {
        code: 'TFW',
        name: 'Telford and Wrekin'
      },
      {
        code: 'THR',
        name: 'Thurrock'
      },
      {
        code: 'TOB',
        name: 'Torbay'
      },
      {
        code: 'WRT',
        name: 'Warrington'
      },
      {
        code: 'WBK',
        name: 'West Berkshire'
      },
      {
        code: 'WNH',
        name: 'West Northamptonshire'
      },
      {
        code: 'WIL',
        name: 'Wiltshire'
      },
      {
        code: 'WNM',
        name: 'Windsor and Maidenhead'
      },
      {
        code: 'WOK',
        name: 'Wokingham'
      },
      {
        code: 'YOR',
        name: 'York'
      },
      {
        code: 'ANN',
        name: 'Antrim and Newtownabbey'
      },
      {
        code: 'AND',
        name: 'Ards and North Down'
      },
      {
        code: 'ABC',
        name: 'Armagh City, Banbridge and Craigavon'
      },
      {
        code: 'BFS',
        name: 'Belfast City'
      },
      {
        code: 'CCG',
        name: 'Causeway Coast and Glens'
      },
      {
        code: 'DRS',
        name: 'Derry and Strabane'
      },
      {
        code: 'FMO',
        name: 'Fermanagh and Omagh'
      },
      {
        code: 'LBC',
        name: 'Lisburn and Castlereagh'
      },
      {
        code: 'MEA',
        name: 'Mid and East Antrim'
      },
      {
        code: 'MUL',
        name: 'Mid-Ulster'
      },
      {
        code: 'NMD',
        name: 'Newry, Mourne and Down'
      },
      {
        code: 'ABE',
        name: 'Aberdeen City'
      },
      {
        code: 'ABD',
        name: 'Aberdeenshire'
      },
      {
        code: 'ANS',
        name: 'Angus'
      },
      {
        code: 'AGB',
        name: 'Argyll and Bute'
      },
      {
        code: 'CLK',
        name: 'Clackmannanshire'
      },
      {
        code: 'DGY',
        name: 'Dumfries and Galloway'
      },
      {
        code: 'DND',
        name: 'Dundee City'
      },
      {
        code: 'EAY',
        name: 'East Ayrshire'
      },
      {
        code: 'EDU',
        name: 'East Dunbartonshire'
      },
      {
        code: 'ELN',
        name: 'East Lothian'
      },
      {
        code: 'ERW',
        name: 'East Renfrewshire'
      },
      {
        code: 'EDH',
        name: 'Edinburgh, City of'
      },
      {
        code: 'ELS',
        name: 'Eilean Siar'
      },
      {
        code: 'FAL',
        name: 'Falkirk'
      },
      {
        code: 'FIF',
        name: 'Fife'
      },
      {
        code: 'GLG',
        name: 'Glasgow City'
      },
      {
        code: 'HLD',
        name: 'Highland'
      },
      {
        code: 'IVC',
        name: 'Inverclyde'
      },
      {
        code: 'MLN',
        name: 'Midlothian'
      },
      {
        code: 'MRY',
        name: 'Moray'
      },
      {
        code: 'NAY',
        name: 'North Ayrshire'
      },
      {
        code: 'NLK',
        name: 'North Lanarkshire'
      },
      {
        code: 'ORK',
        name: 'Orkney Islands'
      },
      {
        code: 'PKN',
        name: 'Perth and Kinross'
      },
      {
        code: 'RFW',
        name: 'Renfrewshire'
      },
      {
        code: 'SCB',
        name: 'Scottish Borders'
      },
      {
        code: 'ZET',
        name: 'Shetland Islands'
      },
      {
        code: 'SAY',
        name: 'South Ayrshire'
      },
      {
        code: 'SLK',
        name: 'South Lanarkshire'
      },
      {
        code: 'STG',
        name: 'Stirling'
      },
      {
        code: 'WDU',
        name: 'West Dunbartonshire'
      },
      {
        code: 'WLN',
        name: 'West Lothian'
      },
      {
        code: 'BGW',
        name: 'Blaenau Gwent'
      },
      {
        code: 'BGE',
        name: 'Bridgend'
      },
      {
        code: 'CAY',
        name: 'Caerphilly'
      },
      {
        code: 'CRF',
        name: 'Cardiff'
      },
      {
        code: 'CMN',
        name: 'Carmarthenshire'
      },
      {
        code: 'CGN',
        name: 'Ceredigion'
      },
      {
        code: 'CWY',
        name: 'Conwy'
      },
      {
        code: 'DEN',
        name: 'Denbighshire'
      },
      {
        code: 'FLN',
        name: 'Flintshire'
      },
      {
        code: 'GWN',
        name: 'Gwynedd'
      },
      {
        code: 'AGY',
        name: 'Isle of Anglesey'
      },
      {
        code: 'MTY',
        name: 'Merthyr Tydfil'
      },
      {
        code: 'MON',
        name: 'Monmouthshire'
      },
      {
        code: 'NTL',
        name: 'Neath Port Talbot'
      },
      {
        code: 'NWP',
        name: 'Newport'
      },
      {
        code: 'PEM',
        name: 'Pembrokeshire'
      },
      {
        code: 'POW',
        name: 'Powys'
      },
      {
        code: 'RCT',
        name: 'Rhondda Cynon Taff'
      },
      {
        code: 'SWA',
        name: 'Swansea'
      },
      {
        code: 'TOF',
        name: 'Torfaen'
      },
      {
        code: 'VGL',
        name: 'Vale of Glamorgan, The'
      },
      {
        code: 'WRX',
        name: 'Wrexham'
      },
      {
        code: 'IOM',
        name: 'Isle of Man'
      }
    ]
  },
  {
    code: 'GE',
    name: 'Georgia',
    code2: 'GE',
    code3: 'GEO',
    capital: 'Tbilisi',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'AB',
        name: 'Abkhazia'
      },
      {
        code: 'AJ',
        name: 'Adjara'
      },
      {
        code: 'GU',
        name: 'Guria'
      },
      {
        code: 'IM',
        name: 'Imereti'
      },
      {
        code: 'KA',
        name: "K'akheti"
      },
      {
        code: 'KK',
        name: 'Kvemo Kartli'
      },
      {
        code: 'MM',
        name: 'Mtskheta-Mtianeti'
      },
      {
        code: 'RL',
        name: "Rach'a-Lechkhumi-Kvemo Svaneti"
      },
      {
        code: 'SZ',
        name: 'Samegrelo-Zemo Svaneti'
      },
      {
        code: 'SJ',
        name: 'Samtskhe-Javakheti'
      },
      {
        code: 'SK',
        name: 'Shida Kartli'
      },
      {
        code: 'TB',
        name: 'Tbilisi'
      }
    ]
  },
  {
    code: 'GG',
    name: 'Guernsey',
    code2: 'GG',
    code3: 'GGY',
    capital: 'St. Peter Port',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'GG',
        name: 'Guernsey'
      }
    ]
  },
  {
    code: 'GH',
    name: 'Ghana',
    code2: 'GH',
    code3: 'GHA',
    capital: 'Accra',
    region: 'Africa',
    subregion: 'Western Africa',
    states: [
      {
        code: 'AF',
        name: 'Ahafo'
      },
      {
        code: 'AH',
        name: 'Ashanti'
      },
      {
        code: 'BO',
        name: 'Bono'
      },
      {
        code: 'BE',
        name: 'Bono East'
      },
      {
        code: 'CP',
        name: 'Central'
      },
      {
        code: 'EP',
        name: 'Eastern'
      },
      {
        code: 'AA',
        name: 'Greater Accra'
      },
      {
        code: 'NE',
        name: 'North East'
      },
      {
        code: 'NP',
        name: 'Northern'
      },
      {
        code: 'OT',
        name: 'Oti'
      },
      {
        code: 'SV',
        name: 'Savannah'
      },
      {
        code: 'UE',
        name: 'Upper East'
      },
      {
        code: 'UW',
        name: 'Upper West'
      },
      {
        code: 'TV',
        name: 'Volta'
      },
      {
        code: 'WP',
        name: 'Western'
      },
      {
        code: 'WN',
        name: 'Western North'
      }
    ]
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    code2: 'GI',
    code3: 'GIB',
    capital: 'Gibraltar',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: 'GI',
        name: 'Gibraltar'
      }
    ]
  },
  {
    code: 'GL',
    name: 'Greenland',
    code2: 'GL',
    code3: 'GRL',
    capital: 'Nuuk',
    region: 'Americas',
    subregion: 'Northern America',
    states: [
      {
        code: 'AV',
        name: 'Avannaata'
      },
      {
        code: 'KU',
        name: 'Kujalleq'
      },
      {
        code: 'QT',
        name: 'Qeqertalik'
      },
      {
        code: 'SM',
        name: 'Sermersooq'
      },
      {
        code: 'QE',
        name: 'Qeqqata'
      }
    ]
  },
  {
    code: 'GR',
    name: 'Greece',
    code2: 'GR',
    code3: 'GRC',
    capital: 'Athens',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '69',
        name: 'Mount Athos'
      },
      {
        code: 'A',
        name: 'Eastern Macedonia and Thrace'
      },
      {
        code: 'I',
        name: 'Attica'
      },
      {
        code: 'G',
        name: 'Western Greece'
      },
      {
        code: 'C',
        name: 'Western Macedonia'
      },
      {
        code: 'F',
        name: 'Ionian Islands'
      },
      {
        code: 'D',
        name: 'Epirus'
      },
      {
        code: 'B',
        name: 'Central Macedonia'
      },
      {
        code: 'M',
        name: 'Crete'
      },
      {
        code: 'L',
        name: 'Southern Aegean'
      },
      {
        code: 'J',
        name: 'Peloponnese'
      },
      {
        code: 'H',
        name: 'Central Greece'
      },
      {
        code: 'E',
        name: 'Thessaly'
      },
      {
        code: 'K',
        name: 'Northern Aegean'
      }
    ]
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    code2: 'HK',
    code3: 'HKG',
    capital: 'City of Victoria',
    region: 'Asia',
    subregion: 'Eastern Asia',
    states: [
      {
        code: 'HK',
        name: 'Hong Kong'
      }
    ]
  },
  {
    code: 'GT',
    name: 'Guatemala',
    code2: 'GT',
    code3: 'GTM',
    capital: 'Guatemala City',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: '16',
        name: 'Upper Verapaz'
      },
      {
        code: '15',
        name: 'Lower Verapaz'
      },
      {
        code: '04',
        name: 'Chimaltenango'
      },
      {
        code: '20',
        name: 'Chiquimula'
      },
      {
        code: '02',
        name: 'El Progreso'
      },
      {
        code: '05',
        name: 'Escuintla'
      },
      {
        code: '01',
        name: 'Guatemala'
      },
      {
        code: '13',
        name: 'Huehuetenango'
      },
      {
        code: '18',
        name: 'Izabal'
      },
      {
        code: '21',
        name: 'Jalapa'
      },
      {
        code: '22',
        name: 'Jutiapa'
      },
      {
        code: '17',
        name: 'Petén'
      },
      {
        code: '09',
        name: 'Quetzaltenango'
      },
      {
        code: '14',
        name: 'Quiché'
      },
      {
        code: '11',
        name: 'Retalhuleu'
      },
      {
        code: '03',
        name: 'Sacatepéquez'
      },
      {
        code: '12',
        name: 'Saint Mark'
      },
      {
        code: '06',
        name: 'Saint Rose'
      },
      {
        code: '07',
        name: 'Sololá'
      },
      {
        code: '10',
        name: 'Suchitepéquez'
      },
      {
        code: '08',
        name: 'Totonicapán'
      },
      {
        code: '19',
        name: 'Zacapa'
      }
    ]
  },
  {
    code: 'HN',
    name: 'Honduras',
    code2: 'HN',
    code3: 'HND',
    capital: 'Tegucigalpa',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: 'AT',
        name: 'Atlántida'
      },
      {
        code: 'CH',
        name: 'Choluteca'
      },
      {
        code: 'CL',
        name: 'Colón'
      },
      {
        code: 'CM',
        name: 'Comayagua'
      },
      {
        code: 'CP',
        name: 'Copán'
      },
      {
        code: 'CR',
        name: 'Cortés'
      },
      {
        code: 'EP',
        name: 'El Paraíso'
      },
      {
        code: 'FM',
        name: 'Francisco Morazán'
      },
      {
        code: 'GD',
        name: 'Gracias a Dios'
      },
      {
        code: 'IN',
        name: 'Intibucá'
      },
      {
        code: 'IB',
        name: 'Islas de la Bahía'
      },
      {
        code: 'LP',
        name: 'La Paz'
      },
      {
        code: 'LE',
        name: 'Lempira'
      },
      {
        code: 'OC',
        name: 'Ocotepeque'
      },
      {
        code: 'OL',
        name: 'Olancho'
      },
      {
        code: 'SB',
        name: 'Santa Bárbara'
      },
      {
        code: 'VA',
        name: 'Valle'
      },
      {
        code: 'YO',
        name: 'Yoro'
      }
    ]
  },
  {
    code: 'HR',
    name: 'Croatia',
    code2: 'HR',
    code3: 'HRV',
    capital: 'Zagreb',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '07',
        name: 'Bjelovar-Bilogora'
      },
      {
        code: '12',
        name: 'Brod-Posavina'
      },
      {
        code: '19',
        name: 'Dubrovnik-Neretva'
      },
      {
        code: '21',
        name: 'Zagreb City'
      },
      {
        code: '18',
        name: 'Istria'
      },
      {
        code: '04',
        name: 'Karlovac'
      },
      {
        code: '06',
        name: 'Koprivnica-Križevci'
      },
      {
        code: '02',
        name: 'Krapina-Zagorje'
      },
      {
        code: '09',
        name: 'Lika-Senj'
      },
      {
        code: '20',
        name: 'Međimurje'
      },
      {
        code: '14',
        name: 'Osijek-Baranja'
      },
      {
        code: '11',
        name: 'Požega-Slavonia'
      },
      {
        code: '08',
        name: 'Primorje-Gorski Kotar'
      },
      {
        code: '03',
        name: 'Sisak-Moslavina'
      },
      {
        code: '17',
        name: 'Split-Dalmatia'
      },
      {
        code: '15',
        name: 'Šibenik-Knin'
      },
      {
        code: '05',
        name: 'Varaždin'
      },
      {
        code: '10',
        name: 'Virovitica-Podravina'
      },
      {
        code: '16',
        name: 'Vukovar-Srijem'
      },
      {
        code: '13',
        name: 'Zadar'
      },
      {
        code: '01',
        name: 'Zagreb County'
      }
    ]
  },
  {
    code: 'HU',
    name: 'Hungary',
    code2: 'HU',
    code3: 'HUN',
    capital: 'Budapest',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: 'BK',
        name: 'Bács-Kiskun'
      },
      {
        code: 'BA',
        name: 'Baranya'
      },
      {
        code: 'BE',
        name: 'Békés'
      },
      {
        code: 'BC',
        name: 'Békéscsaba'
      },
      {
        code: 'BZ',
        name: 'Borsod-Abaúj-Zemplén'
      },
      {
        code: 'BU',
        name: 'Budapest'
      },
      {
        code: 'CS',
        name: 'Csongrád-Csanád'
      },
      {
        code: 'DE',
        name: 'Debrecen'
      },
      {
        code: 'DU',
        name: 'Dunaújváros'
      },
      {
        code: 'EG',
        name: 'Eger'
      },
      {
        code: 'ER',
        name: 'Érd'
      },
      {
        code: 'FE',
        name: 'Fejér'
      },
      {
        code: 'GY',
        name: 'Győr'
      },
      {
        code: 'GS',
        name: 'Győr-Moson-Sopron'
      },
      {
        code: 'HB',
        name: 'Hajdú-Bihar'
      },
      {
        code: 'HE',
        name: 'Heves'
      },
      {
        code: 'HV',
        name: 'Hódmezővásárhely'
      },
      {
        code: 'JN',
        name: 'Jász-Nagykun-Szolnok'
      },
      {
        code: 'KV',
        name: 'Kaposvár'
      },
      {
        code: 'KM',
        name: 'Kecskemét'
      },
      {
        code: 'KE',
        name: 'Komárom-Esztergom'
      },
      {
        code: 'MI',
        name: 'Miskolc'
      },
      {
        code: 'NK',
        name: 'Nagykanizsa'
      },
      {
        code: 'NO',
        name: 'Nógrád'
      },
      {
        code: 'NY',
        name: 'Nyíregyháza'
      },
      {
        code: 'PS',
        name: 'Pécs'
      },
      {
        code: 'PE',
        name: 'Pest'
      },
      {
        code: 'ST',
        name: 'Salgótarján'
      },
      {
        code: 'SO',
        name: 'Somogy'
      },
      {
        code: 'SN',
        name: 'Sopron'
      },
      {
        code: 'SZ',
        name: 'Szabolcs-Szatmár-Bereg'
      },
      {
        code: 'SD',
        name: 'Szeged'
      },
      {
        code: 'SF',
        name: 'Székesfehérvár'
      },
      {
        code: 'SS',
        name: 'Szekszárd'
      },
      {
        code: 'SK',
        name: 'Szolnok'
      },
      {
        code: 'SH',
        name: 'Szombathely'
      },
      {
        code: 'TB',
        name: 'Tatabánya'
      },
      {
        code: 'TO',
        name: 'Tolna'
      },
      {
        code: 'VA',
        name: 'Vas'
      },
      {
        code: 'VM',
        name: 'Veszprém'
      },
      {
        code: 'VE',
        name: 'Veszprém'
      },
      {
        code: 'ZA',
        name: 'Zala'
      },
      {
        code: 'ZE',
        name: 'Zalaegerszeg'
      }
    ]
  },
  {
    code: 'ID',
    name: 'Indonesia',
    code2: 'ID',
    code3: 'IDN',
    capital: 'Jakarta',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: 'AC',
        name: 'Aceh'
      },
      {
        code: 'BA',
        name: 'Bali'
      },
      {
        code: 'BT',
        name: 'Banten'
      },
      {
        code: 'BE',
        name: 'Bengkulu'
      },
      {
        code: 'GO',
        name: 'Gorontalo'
      },
      {
        code: 'JK',
        name: 'Jakarta'
      },
      {
        code: 'JA',
        name: 'Jambi'
      },
      {
        code: 'JB',
        name: 'West Java'
      },
      {
        code: 'JT',
        name: 'Central Java'
      },
      {
        code: 'JI',
        name: 'East Java'
      },
      {
        code: 'KB',
        name: 'West Kalimantan'
      },
      {
        code: 'KS',
        name: 'South Kalimantan'
      },
      {
        code: 'KT',
        name: 'Central Kalimantan'
      },
      {
        code: 'KI',
        name: 'East Kalimantan'
      },
      {
        code: 'KU',
        name: 'North Kalimantan'
      },
      {
        code: 'BB',
        name: 'Bangka Belitung Islands'
      },
      {
        code: 'KR',
        name: 'Riau Islands'
      },
      {
        code: 'LA',
        name: 'Lampung'
      },
      {
        code: 'MA',
        name: 'Maluku'
      },
      {
        code: 'MU',
        name: 'North Maluku'
      },
      {
        code: 'NB',
        name: 'West Nusa Tenggara'
      },
      {
        code: 'NT',
        name: 'East Nusa Tenggara'
      },
      {
        code: 'PA',
        name: 'Papua'
      },
      {
        code: 'PB',
        name: 'West Papua'
      },
      {
        code: 'PD',
        name: 'Southwest Papua'
      },
      {
        code: 'PE',
        name: 'Highland Papua'
      },
      {
        code: 'PS',
        name: 'South Papua'
      },
      {
        code: 'PT',
        name: 'Central Papua'
      },
      {
        code: 'RI',
        name: 'Riau'
      },
      {
        code: 'SR',
        name: 'West Sulawesi'
      },
      {
        code: 'SN',
        name: 'South Sulawesi'
      },
      {
        code: 'ST',
        name: 'Central Sulawesi'
      },
      {
        code: 'SG',
        name: 'Southeast Sulawesi'
      },
      {
        code: 'SA',
        name: 'North Sulawesi'
      },
      {
        code: 'SB',
        name: 'West Sumatra'
      },
      {
        code: 'SS',
        name: 'South Sumatra'
      },
      {
        code: 'SU',
        name: 'North Sumatra'
      },
      {
        code: 'YO',
        name: 'Yogyakarta'
      }
    ]
  },
  {
    code: 'IE',
    name: 'Ireland',
    code2: 'IE',
    code3: 'IRL',
    capital: 'Dublin',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'CW',
        name: 'Carlow'
      },
      {
        code: 'CN',
        name: 'Cavan'
      },
      {
        code: 'CE',
        name: 'Clare'
      },
      {
        code: 'CO',
        name: 'Cork'
      },
      {
        code: 'DL',
        name: 'Donegal'
      },
      {
        code: 'D',
        name: 'Dublin'
      },
      {
        code: 'G',
        name: 'Galway'
      },
      {
        code: 'KY',
        name: 'Kerry'
      },
      {
        code: 'KE',
        name: 'Kildare'
      },
      {
        code: 'KK',
        name: 'Kilkenny'
      },
      {
        code: 'LS',
        name: 'Laois'
      },
      {
        code: 'LM',
        name: 'Leitrim'
      },
      {
        code: 'LK',
        name: 'Limerick'
      },
      {
        code: 'LD',
        name: 'Longford'
      },
      {
        code: 'LH',
        name: 'Louth'
      },
      {
        code: 'MO',
        name: 'Mayo'
      },
      {
        code: 'MH',
        name: 'Meath'
      },
      {
        code: 'MN',
        name: 'Monaghan'
      },
      {
        code: 'OY',
        name: 'Offaly'
      },
      {
        code: 'RN',
        name: 'Roscommon'
      },
      {
        code: 'SO',
        name: 'Sligo'
      },
      {
        code: 'TA',
        name: 'Tipperary'
      },
      {
        code: 'WD',
        name: 'Waterford'
      },
      {
        code: 'WH',
        name: 'Westmeath'
      },
      {
        code: 'WX',
        name: 'Wexford'
      },
      {
        code: 'WW',
        name: 'Wicklow'
      }
    ]
  },
  {
    code: 'IL',
    name: 'Israel',
    code2: 'IL',
    code3: 'ISR',
    capital: 'Jerusalem',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'M',
        name: 'Central'
      },
      {
        code: 'HA',
        name: 'Haifa'
      },
      {
        code: 'JM',
        name: 'Jerusalem'
      },
      {
        code: 'Z',
        name: 'Northern'
      },
      {
        code: 'D',
        name: 'Southern'
      },
      {
        code: 'TA',
        name: 'Tel Aviv'
      }
    ]
  },
  {
    code: 'IN',
    name: 'India',
    code2: 'IN',
    code3: 'IND',
    capital: 'New Delhi',
    region: 'Asia',
    subregion: 'Southern Asia',
    states: [
      {
        code: 'AN',
        name: 'Andaman and Nicobar Islands'
      },
      {
        code: 'AP',
        name: 'Andhra Pradesh'
      },
      {
        code: 'AR',
        name: 'Arunāchal Pradesh'
      },
      {
        code: 'AS',
        name: 'Assam'
      },
      {
        code: 'BR',
        name: 'Bihār'
      },
      {
        code: 'CH',
        name: 'Chandigarh'
      },
      {
        code: 'CG',
        name: 'Chhattīsgarh'
      },
      {
        code: 'DH',
        name: 'Dādra and Nagar Haveli and Damān and Diu'
      },
      {
        code: 'DL',
        name: 'Delhi'
      },
      {
        code: 'GA',
        name: 'Goa'
      },
      {
        code: 'GJ',
        name: 'Gujarāt'
      },
      {
        code: 'HR',
        name: 'Haryāna'
      },
      {
        code: 'HP',
        name: 'Himāchal Pradesh'
      },
      {
        code: 'JK',
        name: 'Jammu and Kashmīr'
      },
      {
        code: 'JH',
        name: 'Jhārkhand'
      },
      {
        code: 'KA',
        name: 'Karnātaka'
      },
      {
        code: 'KL',
        name: 'Kerala'
      },
      {
        code: 'LA',
        name: 'Ladākh'
      },
      {
        code: 'LD',
        name: 'Lakshadweep'
      },
      {
        code: 'MP',
        name: 'Madhya Pradesh'
      },
      {
        code: 'MH',
        name: 'Mahārāshtra'
      },
      {
        code: 'MN',
        name: 'Manipur'
      },
      {
        code: 'ML',
        name: 'Meghālaya'
      },
      {
        code: 'MZ',
        name: 'Mizoram'
      },
      {
        code: 'NL',
        name: 'Nāgāland'
      },
      {
        code: 'OD',
        name: 'Odisha'
      },
      {
        code: 'PY',
        name: 'Puducherry (Pondicherry)'
      },
      {
        code: 'PB',
        name: 'Punjab'
      },
      {
        code: 'RJ',
        name: 'Rājasthān'
      },
      {
        code: 'SK',
        name: 'Sikkim'
      },
      {
        code: 'TN',
        name: 'Tamil Nādu'
      },
      {
        code: 'TS',
        name: 'Telangāna'
      },
      {
        code: 'TR',
        name: 'Tripura'
      },
      {
        code: 'UP',
        name: 'Uttar Pradesh'
      },
      {
        code: 'UK',
        name: 'Uttarākhand'
      },
      {
        code: 'WB',
        name: 'West Bengal'
      }
    ]
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    code2: 'IO',
    code3: 'IOT',
    capital: 'Diego Garcia',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: 'IO',
        name: 'Brit.Ind.Oc.Ter'
      }
    ]
  },
  {
    code: 'IS',
    name: 'Iceland',
    code2: 'IS',
    code3: 'ISL',
    capital: 'Reykjavík',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: '1',
        name: 'Capital Region'
      },
      {
        code: '2',
        name: 'Southern Peninsula'
      },
      {
        code: '3',
        name: 'Western Region'
      },
      {
        code: '4',
        name: 'Westfjords'
      },
      {
        code: '5',
        name: 'Northwestern Region'
      },
      {
        code: '6',
        name: 'Northeastern Region'
      },
      {
        code: '7',
        name: 'Eastern Region'
      },
      {
        code: '8',
        name: 'Southern Region'
      }
    ]
  },
  {
    code: 'IT',
    name: 'Italy',
    code2: 'IT',
    code3: 'ITA',
    capital: 'Rome',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '65',
        name: 'Abruzzo'
      },
      {
        code: '77',
        name: 'Basilicata'
      },
      {
        code: '78',
        name: 'Calabria'
      },
      {
        code: '72',
        name: 'Campania'
      },
      {
        code: '45',
        name: 'Emilia-Romagna'
      },
      {
        code: '36',
        name: 'Friuli Venezia Giulia'
      },
      {
        code: '62',
        name: 'Lazio'
      },
      {
        code: '42',
        name: 'Liguria'
      },
      {
        code: '25',
        name: 'Lombardy'
      },
      {
        code: '57',
        name: 'Marche'
      },
      {
        code: '67',
        name: 'Molise'
      },
      {
        code: '21',
        name: 'Piedmont'
      },
      {
        code: '75',
        name: 'Apulia'
      },
      {
        code: '88',
        name: 'Sardinia'
      },
      {
        code: '82',
        name: 'Sicily'
      },
      {
        code: '52',
        name: 'Tuscany'
      },
      {
        code: '32',
        name: 'Trentino-South Tyrol'
      },
      {
        code: '55',
        name: 'Umbria'
      },
      {
        code: '23',
        name: 'Aosta Valley'
      },
      {
        code: '34',
        name: 'Veneto'
      }
    ]
  },
  {
    code: 'JE',
    name: 'Jersey',
    code2: 'JE',
    code3: 'JEY',
    capital: 'Saint Helier',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'JE',
        name: 'Jersey'
      }
    ]
  },
  {
    code: 'JM',
    name: 'Jamaica',
    code2: 'JM',
    code3: 'JAM',
    capital: 'Kingston',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: '01',
        name: 'Kingston'
      },
      {
        code: '02',
        name: 'Saint Andrew'
      },
      {
        code: '03',
        name: 'Saint Thomas'
      },
      {
        code: '04',
        name: 'Portland'
      },
      {
        code: '05',
        name: 'Saint Mary'
      },
      {
        code: '06',
        name: 'Saint Anne'
      },
      {
        code: '07',
        name: 'Trelawny'
      },
      {
        code: '08',
        name: 'Saint James'
      },
      {
        code: '09',
        name: 'Hanover'
      },
      {
        code: '10',
        name: 'Westmoreland'
      },
      {
        code: '11',
        name: 'Saint Elizabeth'
      },
      {
        code: '12',
        name: 'Manchester'
      },
      {
        code: '13',
        name: 'Clarendon'
      },
      {
        code: '14',
        name: 'Saint Catherine'
      }
    ]
  },
  {
    code: 'JO',
    name: 'Jordan',
    code2: 'JO',
    code3: 'JOR',
    capital: 'Amman',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'AJ',
        name: 'Ajloun'
      },
      {
        code: 'AM',
        name: 'Amman'
      },
      {
        code: 'AQ',
        name: 'Aqaba'
      },
      {
        code: 'AT',
        name: 'Tafilah'
      },
      {
        code: 'AZ',
        name: 'Zarqa'
      },
      {
        code: 'BA',
        name: 'Balqa'
      },
      {
        code: 'IR',
        name: 'Irbid'
      },
      {
        code: 'JA',
        name: 'Jerash'
      },
      {
        code: 'KA',
        name: 'Karak'
      },
      {
        code: 'MA',
        name: 'Mafraq'
      },
      {
        code: 'MD',
        name: 'Madaba'
      },
      {
        code: 'MN',
        name: "Ma'an"
      }
    ]
  },
  {
    code: 'JP',
    name: 'Japan',
    code2: 'JP',
    code3: 'JPN',
    capital: 'Tokyo',
    region: 'Asia',
    subregion: 'Eastern Asia',
    states: [
      {
        code: '01',
        name: 'Hokkaido'
      },
      {
        code: '02',
        name: 'Aomori'
      },
      {
        code: '03',
        name: 'Iwate'
      },
      {
        code: '04',
        name: 'Miyagi'
      },
      {
        code: '05',
        name: 'Akita'
      },
      {
        code: '06',
        name: 'Yamagata'
      },
      {
        code: '07',
        name: 'Fukushima'
      },
      {
        code: '08',
        name: 'Ibaraki'
      },
      {
        code: '09',
        name: 'Tochigi'
      },
      {
        code: '10',
        name: 'Gunma'
      },
      {
        code: '11',
        name: 'Saitama'
      },
      {
        code: '12',
        name: 'Chiba'
      },
      {
        code: '13',
        name: 'Tokyo'
      },
      {
        code: '14',
        name: 'Kanagawa'
      },
      {
        code: '15',
        name: 'Niigata'
      },
      {
        code: '16',
        name: 'Toyama'
      },
      {
        code: '17',
        name: 'Ishikawa'
      },
      {
        code: '18',
        name: 'Fukui'
      },
      {
        code: '19',
        name: 'Yamanashi'
      },
      {
        code: '20',
        name: 'Nagano'
      },
      {
        code: '21',
        name: 'Gifu'
      },
      {
        code: '22',
        name: 'Shizuoka'
      },
      {
        code: '23',
        name: 'Aichi'
      },
      {
        code: '24',
        name: 'Mie'
      },
      {
        code: '25',
        name: 'Shiga'
      },
      {
        code: '26',
        name: 'Kyoto'
      },
      {
        code: '27',
        name: 'Osaka'
      },
      {
        code: '28',
        name: 'Hyogo'
      },
      {
        code: '29',
        name: 'Nara'
      },
      {
        code: '30',
        name: 'Wakayama'
      },
      {
        code: '31',
        name: 'Tottori'
      },
      {
        code: '32',
        name: 'Shimane'
      },
      {
        code: '33',
        name: 'Okayama'
      },
      {
        code: '34',
        name: 'Hiroshima'
      },
      {
        code: '35',
        name: 'Yamaguchi'
      },
      {
        code: '36',
        name: 'Tokushima'
      },
      {
        code: '37',
        name: 'Kagawa'
      },
      {
        code: '38',
        name: 'Ehime'
      },
      {
        code: '39',
        name: 'Kochi'
      },
      {
        code: '40',
        name: 'Fukuoka'
      },
      {
        code: '41',
        name: 'Saga'
      },
      {
        code: '42',
        name: 'Nagasaki'
      },
      {
        code: '43',
        name: 'Kumamoto'
      },
      {
        code: '44',
        name: 'Oita'
      },
      {
        code: '45',
        name: 'Miyazaki'
      },
      {
        code: '46',
        name: 'Kagoshima'
      },
      {
        code: '47',
        name: 'Okinawa'
      }
    ]
  },
  {
    code: 'KE',
    name: 'Kenya',
    code2: 'KE',
    code3: 'KEN',
    capital: 'Nairobi',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: '01',
        name: 'Baringo'
      },
      {
        code: '02',
        name: 'Bomet'
      },
      {
        code: '03',
        name: 'Bungoma'
      },
      {
        code: '04',
        name: 'Busia'
      },
      {
        code: '05',
        name: 'Elgeyo-Marakwet'
      },
      {
        code: '06',
        name: 'Embu'
      },
      {
        code: '07',
        name: 'Garissa'
      },
      {
        code: '08',
        name: 'Homa Bay'
      },
      {
        code: '09',
        name: 'Isiolo'
      },
      {
        code: '10',
        name: 'Kajiado'
      },
      {
        code: '11',
        name: 'Kakamega'
      },
      {
        code: '12',
        name: 'Kericho'
      },
      {
        code: '13',
        name: 'Kiambu'
      },
      {
        code: '14',
        name: 'Kilifi'
      },
      {
        code: '15',
        name: 'Kirinyaga'
      },
      {
        code: '16',
        name: 'Kisii'
      },
      {
        code: '17',
        name: 'Kisumu'
      },
      {
        code: '18',
        name: 'Kitui'
      },
      {
        code: '19',
        name: 'Kwale'
      },
      {
        code: '20',
        name: 'Laikipia'
      },
      {
        code: '21',
        name: 'Lamu'
      },
      {
        code: '22',
        name: 'Machakos'
      },
      {
        code: '23',
        name: 'Makueni'
      },
      {
        code: '24',
        name: 'Mandera'
      },
      {
        code: '25',
        name: 'Marsabit'
      },
      {
        code: '26',
        name: 'Meru'
      },
      {
        code: '27',
        name: 'Migori'
      },
      {
        code: '28',
        name: 'Mombasa'
      },
      {
        code: '29',
        name: "Murang'a"
      },
      {
        code: '30',
        name: 'Nairobi City'
      },
      {
        code: '31',
        name: 'Nakuru'
      },
      {
        code: '32',
        name: 'Nandi'
      },
      {
        code: '33',
        name: 'Narok'
      },
      {
        code: '34',
        name: 'Nyamira'
      },
      {
        code: '35',
        name: 'Nyandarua'
      },
      {
        code: '36',
        name: 'Nyeri'
      },
      {
        code: '37',
        name: 'Samburu'
      },
      {
        code: '38',
        name: 'Siaya'
      },
      {
        code: '39',
        name: 'Taita-Taveta'
      },
      {
        code: '40',
        name: 'Tana River'
      },
      {
        code: '41',
        name: 'Tharaka-Nithi'
      },
      {
        code: '42',
        name: 'Trans-Nzoia'
      },
      {
        code: '43',
        name: 'Turkana'
      },
      {
        code: '44',
        name: 'Uasin Gishu'
      },
      {
        code: '45',
        name: 'Vihiga'
      },
      {
        code: '46',
        name: 'Wajir'
      },
      {
        code: '47',
        name: 'West Pokot'
      }
    ]
  },
  {
    code: 'KH',
    name: 'Cambodia',
    code2: 'KH',
    code3: 'KHM',
    capital: 'Phnom Penh',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: '1',
        name: 'Banteay Meanchey'
      },
      {
        code: '2',
        name: 'Battambang'
      },
      {
        code: '3',
        name: 'Kampong Chaam'
      },
      {
        code: '4',
        name: 'Kampong Chhnang'
      },
      {
        code: '5',
        name: 'Kampong Spueu'
      },
      {
        code: '6',
        name: 'Kampong Thum'
      },
      {
        code: '7',
        name: 'Kampot'
      },
      {
        code: '8',
        name: 'Kandaal'
      },
      {
        code: '9',
        name: 'Kaoh Kong'
      },
      {
        code: '10',
        name: 'Kracheh'
      },
      {
        code: '11',
        name: 'Mondol Kiri'
      },
      {
        code: '12',
        name: 'Phnom Penh'
      },
      {
        code: '13',
        name: 'Preah Vihear'
      },
      {
        code: '14',
        name: 'Prey Veaeng'
      },
      {
        code: '15',
        name: 'Pousaat'
      },
      {
        code: '16',
        name: 'Rotanak Kiri'
      },
      {
        code: '17',
        name: 'Siem Reab'
      },
      {
        code: '18',
        name: 'Preah Sihanouk'
      },
      {
        code: '19',
        name: 'Stueng Traeng'
      },
      {
        code: '20',
        name: 'Svaay Rieng'
      },
      {
        code: '21',
        name: 'Taakaev'
      },
      {
        code: '33',
        name: 'Otdar Mean Chey'
      },
      {
        code: '23',
        name: 'Kaeb'
      },
      {
        code: '24',
        name: 'Pailin'
      },
      {
        code: '25',
        name: 'Tbong Khmum'
      }
    ]
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    code2: 'KN',
    code3: 'KNA',
    capital: 'Basseterre',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: '01',
        name: 'Christ Church Nichola Town'
      },
      {
        code: '02',
        name: 'Saint Anne Sandy Point'
      },
      {
        code: '03',
        name: 'Saint George Basseterre'
      },
      {
        code: '04',
        name: 'Saint George Gingerland'
      },
      {
        code: '05',
        name: 'Saint James Windward'
      },
      {
        code: '06',
        name: 'Saint John Capisterre'
      },
      {
        code: '07',
        name: 'Saint John Figtree'
      },
      {
        code: '08',
        name: 'Saint Mary Cayon'
      },
      {
        code: '09',
        name: 'Saint Paul Capisterre'
      },
      {
        code: '10',
        name: 'Saint Paul Charlestown'
      },
      {
        code: '11',
        name: 'Saint Peter Basseterre'
      },
      {
        code: '12',
        name: 'Saint Thomas Lowland'
      },
      {
        code: '13',
        name: 'Saint Thomas Middle Island'
      },
      {
        code: '15',
        name: 'Trinity Palmetto Point'
      }
    ]
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
    code2: 'KR',
    code3: 'KOR',
    capital: 'Seoul',
    region: 'Asia',
    subregion: 'Eastern Asia',
    states: [
      {
        code: '26',
        name: 'Busan'
      },
      {
        code: '43',
        name: 'North Chungcheong'
      },
      {
        code: '44',
        name: 'South Chungcheong'
      },
      {
        code: '27',
        name: 'Daegu'
      },
      {
        code: '30',
        name: 'Daejeon'
      },
      {
        code: '42',
        name: 'Gangwon'
      },
      {
        code: '29',
        name: 'Gwangju'
      },
      {
        code: '41',
        name: 'Gyeonggi'
      },
      {
        code: '47',
        name: 'North Gyeongsang'
      },
      {
        code: '48',
        name: 'South Gyeongsang'
      },
      {
        code: '28',
        name: 'Incheon'
      },
      {
        code: '49',
        name: 'Jeju'
      },
      {
        code: '45',
        name: 'North Jeolla'
      },
      {
        code: '46',
        name: 'South Jeolla'
      },
      {
        code: '50',
        name: 'Sejong'
      },
      {
        code: '11',
        name: 'Seoul'
      },
      {
        code: '31',
        name: 'Ulsan'
      }
    ]
  },
  {
    code: 'KW',
    name: 'Kuwait',
    code2: 'KW',
    code3: 'KWT',
    capital: 'Kuwait City',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'AH',
        name: 'Ahmadi'
      },
      {
        code: 'FA',
        name: 'Farwaniya'
      },
      {
        code: 'HA',
        name: 'Hawalli'
      },
      {
        code: 'JA',
        name: 'Jahra'
      },
      {
        code: 'KU',
        name: 'Capital'
      },
      {
        code: 'MU',
        name: 'Mubarak Al-Krabeer'
      }
    ]
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    code2: 'KY',
    code3: 'CYM',
    capital: 'George Town',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'KY',
        name: 'Cayman Islands'
      }
    ]
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    code2: 'KZ',
    code3: 'KAZ',
    capital: 'Astana',
    region: 'Asia',
    subregion: 'Central Asia',
    states: [
      {
        code: '10',
        name: 'Abai'
      },
      {
        code: '75',
        name: 'Almaty City'
      },
      {
        code: '19',
        name: 'Almaty'
      },
      {
        code: '11',
        name: 'Akmola'
      },
      {
        code: '15',
        name: 'Aktobe'
      },
      {
        code: '71',
        name: 'Astana'
      },
      {
        code: '23',
        name: 'Atyrau'
      },
      {
        code: '27',
        name: 'West Kazakhstan'
      },
      {
        code: '47',
        name: 'Mangystau'
      },
      {
        code: '55',
        name: 'Pavlodar'
      },
      {
        code: '35',
        name: 'Karaganda'
      },
      {
        code: '39',
        name: 'Kostanay'
      },
      {
        code: '43',
        name: 'Kyzylorda'
      },
      {
        code: '63',
        name: 'East Kazakhstan'
      },
      {
        code: '79',
        name: 'Shymkent'
      },
      {
        code: '59',
        name: 'North Kazakhstan'
      },
      {
        code: '61',
        name: 'Turkistan'
      },
      {
        code: '62',
        name: 'Ulytau'
      },
      {
        code: '31',
        name: 'Jambyl'
      },
      {
        code: '33',
        name: 'Jetisu'
      }
    ]
  },
  {
    code: 'LA',
    name: 'Laos',
    code2: 'LA',
    code3: 'LAO',
    capital: 'Vientiane',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: 'AT',
        name: 'Attapu'
      },
      {
        code: 'BK',
        name: 'Bokeo'
      },
      {
        code: 'BL',
        name: 'Bolikhamxai'
      },
      {
        code: 'CH',
        name: 'Champasak'
      },
      {
        code: 'HO',
        name: 'Houaphan'
      },
      {
        code: 'KH',
        name: 'Khammouan'
      },
      {
        code: 'LM',
        name: 'Louang Namtha'
      },
      {
        code: 'LP',
        name: 'Louangphabang'
      },
      {
        code: 'OU',
        name: 'Oudomxai'
      },
      {
        code: 'PH',
        name: 'Phongsali'
      },
      {
        code: 'SL',
        name: 'Salavan'
      },
      {
        code: 'SV',
        name: 'Savannakhet'
      },
      {
        code: 'VI',
        name: 'Viangchan'
      },
      {
        code: 'VT',
        name: 'Viangchan'
      },
      {
        code: 'XA',
        name: 'Xaignabouli'
      },
      {
        code: 'XE',
        name: 'Xekong'
      },
      {
        code: 'XI',
        name: 'Xiangkhouang'
      },
      {
        code: 'XS',
        name: 'Xaisomboun'
      }
    ]
  },
  {
    code: 'LB',
    name: 'Lebanon',
    code2: 'LB',
    code3: 'LBN',
    capital: 'Beirut',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'AK',
        name: 'Akkar'
      },
      {
        code: 'AS',
        name: 'North Lebanon'
      },
      {
        code: 'BA',
        name: 'Beirut'
      },
      {
        code: 'BH',
        name: 'Baalbek-Hermel'
      },
      {
        code: 'BI',
        name: 'Beqaa'
      },
      {
        code: 'JA',
        name: 'South Lebanon'
      },
      {
        code: 'JL',
        name: 'Mount Lebanon'
      },
      {
        code: 'NA',
        name: 'Nabatieh'
      }
    ]
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    code2: 'LC',
    code3: 'LCA',
    capital: 'Castries',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: '01',
        name: 'Anse la Raye'
      },
      {
        code: '02',
        name: 'Castries'
      },
      {
        code: '03',
        name: 'Choiseul'
      },
      {
        code: '05',
        name: 'Dennery'
      },
      {
        code: '06',
        name: 'Gros Islet'
      },
      {
        code: '07',
        name: 'Laborie'
      },
      {
        code: '08',
        name: 'Micoud'
      },
      {
        code: '10',
        name: 'Soufriere'
      },
      {
        code: '11',
        name: 'Vieux Fort'
      },
      {
        code: '12',
        name: 'Canaries'
      }
    ]
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    code2: 'LI',
    code3: 'LIE',
    capital: 'Vaduz',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: '01',
        name: 'Balzers'
      },
      {
        code: '02',
        name: 'Eschen'
      },
      {
        code: '03',
        name: 'Gamprin'
      },
      {
        code: '04',
        name: 'Mauren'
      },
      {
        code: '05',
        name: 'Planken'
      },
      {
        code: '06',
        name: 'Ruggell'
      },
      {
        code: '07',
        name: 'Schaan'
      },
      {
        code: '08',
        name: 'Schellenberg'
      },
      {
        code: '09',
        name: 'Triesen'
      },
      {
        code: '10',
        name: 'Triesenberg'
      },
      {
        code: '11',
        name: 'Vaduz'
      }
    ]
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    code2: 'LK',
    code3: 'LKA',
    capital: 'Colombo',
    region: 'Asia',
    subregion: 'Southern Asia',
    states: [
      {
        code: '52',
        name: 'Ampara'
      },
      {
        code: '71',
        name: 'Anuradhapura'
      },
      {
        code: '81',
        name: 'Badulla'
      },
      {
        code: '31',
        name: 'Galle'
      },
      {
        code: '12',
        name: 'Gampaha'
      },
      {
        code: '33',
        name: 'Hambantota'
      },
      {
        code: '92',
        name: 'Kegalla'
      },
      {
        code: '13',
        name: 'Kalutara'
      },
      {
        code: '42',
        name: 'Kilinochchi'
      },
      {
        code: '11',
        name: 'Colombo'
      },
      {
        code: '61',
        name: 'Kurunegala'
      },
      {
        code: '51',
        name: 'Batticaloa'
      },
      {
        code: '21',
        name: 'Kandy'
      },
      {
        code: '43',
        name: 'Mannar'
      },
      {
        code: '22',
        name: 'Matale'
      },
      {
        code: '32',
        name: 'Matara'
      },
      {
        code: '82',
        name: 'Monaragala'
      },
      {
        code: '45',
        name: 'Mullaittivu'
      },
      {
        code: '23',
        name: 'Nuwara Eliya'
      },
      {
        code: '72',
        name: 'Polonnaruwa'
      },
      {
        code: '62',
        name: 'Puttalam'
      },
      {
        code: '91',
        name: 'Ratnapura'
      },
      {
        code: '53',
        name: 'Trincomalee'
      },
      {
        code: '44',
        name: 'Vavuniya'
      },
      {
        code: '41',
        name: 'Jaffna'
      }
    ]
  },
  {
    code: 'LT',
    name: 'Lithuania',
    code2: 'LT',
    code3: 'LTU',
    capital: 'Vilnius',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'AL',
        name: 'Alytus County'
      },
      {
        code: 'KL',
        name: 'Klaipeda County'
      },
      {
        code: 'KU',
        name: 'Kaunas County'
      },
      {
        code: 'MR',
        name: 'Marijampole County'
      },
      {
        code: 'PN',
        name: 'Panevezys County'
      },
      {
        code: 'SA',
        name: 'Siauliai County'
      },
      {
        code: 'TA',
        name: 'Taurage County'
      },
      {
        code: 'TE',
        name: 'Telsiai County'
      },
      {
        code: 'UT',
        name: 'Utena County'
      },
      {
        code: 'VL',
        name: 'Vilnius County'
      }
    ]
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    code2: 'LU',
    code3: 'LUX',
    capital: 'Luxembourg',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'CA',
        name: 'Capellen'
      },
      {
        code: 'CL',
        name: 'Clervaux'
      },
      {
        code: 'DI',
        name: 'Diekirch'
      },
      {
        code: 'EC',
        name: 'Echternach'
      },
      {
        code: 'ES',
        name: 'Esch-sur-Alzette'
      },
      {
        code: 'GR',
        name: 'Grevenmacher'
      },
      {
        code: 'LU',
        name: 'Luxembourg'
      },
      {
        code: 'ME',
        name: 'Mersch'
      },
      {
        code: 'RD',
        name: 'Redange'
      },
      {
        code: 'RM',
        name: 'Remich'
      },
      {
        code: 'VD',
        name: 'Vianden'
      },
      {
        code: 'WI',
        name: 'Wiltz'
      }
    ]
  },
  {
    code: 'LV',
    name: 'Latvia',
    code2: 'LV',
    code3: 'LVA',
    capital: 'Riga',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: '002',
        name: 'Aizkraukle'
      },
      {
        code: '007',
        name: 'Aluksne'
      },
      {
        code: '011',
        name: 'Adazi'
      },
      {
        code: '015',
        name: 'Balvi'
      },
      {
        code: '016',
        name: 'Bauska'
      },
      {
        code: '022',
        name: 'Cesis'
      },
      {
        code: '026',
        name: 'Dobele'
      },
      {
        code: '033',
        name: 'Gulbene'
      },
      {
        code: '041',
        name: 'Jelgava'
      },
      {
        code: '042',
        name: 'Jekabpils'
      },
      {
        code: '047',
        name: 'Kraslava'
      },
      {
        code: '050',
        name: 'Kuldiga'
      },
      {
        code: '052',
        name: 'Kekava'
      },
      {
        code: '054',
        name: 'Limbazi'
      },
      {
        code: '056',
        name: 'Livani'
      },
      {
        code: '058',
        name: 'Ludza'
      },
      {
        code: '059',
        name: 'Madona'
      },
      {
        code: '062',
        name: 'Marupe'
      },
      {
        code: '067',
        name: 'Ogre'
      },
      {
        code: '068',
        name: 'Olaine'
      },
      {
        code: '073',
        name: 'Preili'
      },
      {
        code: '077',
        name: 'Rezekne'
      },
      {
        code: '080',
        name: 'Rapazi'
      },
      {
        code: '087',
        name: 'Salaspils'
      },
      {
        code: '088',
        name: 'Saldus'
      },
      {
        code: '089',
        name: 'Saulkrasti'
      },
      {
        code: '091',
        name: 'Sigulda'
      },
      {
        code: '094',
        name: 'Smiltene'
      },
      {
        code: '097',
        name: 'Talsi'
      },
      {
        code: '099',
        name: 'Tukums'
      },
      {
        code: '101',
        name: 'Valka'
      },
      {
        code: '102',
        name: 'Varaklani'
      },
      {
        code: '106',
        name: 'Ventsplis'
      },
      {
        code: '111',
        name: 'Augsdaugava'
      },
      {
        code: '112',
        name: 'Dienvidkurzeme'
      },
      {
        code: '113',
        name: 'Valmiera'
      },
      {
        code: 'DGV',
        name: 'Daugavpils'
      },
      {
        code: 'JEL',
        name: 'Jelgava'
      },
      {
        code: 'JUR',
        name: 'Jurmala'
      },
      {
        code: 'LPX',
        name: 'Liepaja'
      },
      {
        code: 'REZ',
        name: 'Rezekne'
      },
      {
        code: 'RIX',
        name: 'Riga'
      },
      {
        code: 'VEN',
        name: 'Ventsplis'
      }
    ]
  },
  {
    code: 'MA',
    name: 'Morocco',
    code2: 'MA',
    code3: 'MAR',
    capital: 'Rabat',
    region: 'Africa',
    subregion: 'Northern Africa',
    states: [
      {
        code: '01',
        name: 'TangerTetouanAlHocei'
      },
      {
        code: '02',
        name: 'Oriental'
      },
      {
        code: '03',
        name: 'Fes-Meknes'
      },
      {
        code: '04',
        name: 'Rabat-Sale-Kenitra'
      },
      {
        code: '05',
        name: 'Beni Mellal-Khenifra'
      },
      {
        code: '06',
        name: 'Casablanca-Settat'
      },
      {
        code: '07',
        name: 'Marrakesh-Safi'
      },
      {
        code: '08',
        name: 'Draa-Tafilalet'
      },
      {
        code: '09',
        name: 'Souss-Massa'
      },
      {
        code: '10',
        name: 'Guelmim-Oued Noun'
      },
      {
        code: '11',
        name: 'LaayouneSakiaElHamra'
      },
      {
        code: '12',
        name: 'Dakhla-Oued Ed-Dahab'
      }
    ]
  },
  {
    code: 'MC',
    name: 'Monaco',
    code2: 'MC',
    code3: 'MCO',
    capital: 'Monaco',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'MC',
        name: 'Monaco'
      }
    ]
  },
  {
    code: 'MD',
    name: 'Moldova',
    code2: 'MD',
    code3: 'MDA',
    capital: 'Chișinău',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: 'AN',
        name: 'Anenii Noi'
      },
      {
        code: 'BS',
        name: 'Basarabeasca'
      },
      {
        code: 'BA',
        name: 'Bălți'
      },
      {
        code: 'BD',
        name: 'Bender'
      },
      {
        code: 'BR',
        name: 'Briceni'
      },
      {
        code: 'CA',
        name: 'Cahul'
      },
      {
        code: 'CT',
        name: 'Cantemir'
      },
      {
        code: 'CL',
        name: 'Călărași'
      },
      {
        code: 'CS',
        name: 'Căușeni'
      },
      {
        code: 'CU',
        name: 'Chișinău'
      },
      {
        code: 'CM',
        name: 'Cimișlia'
      },
      {
        code: 'CR',
        name: 'Criuleni'
      },
      {
        code: 'DO',
        name: 'Dondușeni'
      },
      {
        code: 'DR',
        name: 'Drochia'
      },
      {
        code: 'DU',
        name: 'Dubăsari'
      },
      {
        code: 'ED',
        name: 'Edineț'
      },
      {
        code: 'FA',
        name: 'Fălești'
      },
      {
        code: 'FL',
        name: 'Florești'
      },
      {
        code: 'GA',
        name: 'Gagauzia'
      },
      {
        code: 'GL',
        name: 'Glodeni'
      },
      {
        code: 'HI',
        name: 'Hîncești'
      },
      {
        code: 'IA',
        name: 'Ialoveni'
      },
      {
        code: 'LE',
        name: 'Leova'
      },
      {
        code: 'NI',
        name: 'Nisporeni'
      },
      {
        code: 'OC',
        name: 'Ocnița'
      },
      {
        code: 'OR',
        name: 'Orhei'
      },
      {
        code: 'RE',
        name: 'Rezina'
      },
      {
        code: 'RI',
        name: 'Rîșcani'
      },
      {
        code: 'SI',
        name: 'Sîngerei'
      },
      {
        code: 'SO',
        name: 'Soroca'
      },
      {
        code: 'SN',
        name: 'Stinga Nistrului'
      },
      {
        code: 'ST',
        name: 'Straseni'
      },
      {
        code: 'SD',
        name: 'Șoldănești'
      },
      {
        code: 'SV',
        name: 'Ștefan Vodă'
      },
      {
        code: 'TA',
        name: 'Taraclia'
      },
      {
        code: 'TE',
        name: 'Telenești'
      },
      {
        code: 'UN',
        name: 'Ungheni'
      }
    ]
  },
  {
    code: 'ME',
    name: 'Montenegro',
    code2: 'ME',
    code3: 'MNE',
    capital: 'Podgorica',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '01',
        name: 'Andrijevica'
      },
      {
        code: '02',
        name: 'Bar'
      },
      {
        code: '03',
        name: 'Berane'
      },
      {
        code: '04',
        name: 'Bijelo Polje'
      },
      {
        code: '05',
        name: 'Budva'
      },
      {
        code: '06',
        name: 'Cetinje'
      },
      {
        code: '07',
        name: 'Danilovgrad'
      },
      {
        code: '22',
        name: 'Gusinje'
      },
      {
        code: '08',
        name: 'Herceg-Novi'
      },
      {
        code: '09',
        name: 'Kolašin'
      },
      {
        code: '10',
        name: 'Kotor'
      },
      {
        code: '11',
        name: 'Mojkovac'
      },
      {
        code: '12',
        name: 'Nikšić'
      },
      {
        code: '23',
        name: 'Petnjica'
      },
      {
        code: '13',
        name: 'Plav'
      },
      {
        code: '14',
        name: 'Pljevlja'
      },
      {
        code: '15',
        name: 'Plužine'
      },
      {
        code: '16',
        name: 'Podgorica'
      },
      {
        code: '17',
        name: 'Rožaje'
      },
      {
        code: '18',
        name: 'Šavnik'
      },
      {
        code: '19',
        name: 'Tivat'
      },
      {
        code: '24',
        name: 'Tuzi'
      },
      {
        code: '20',
        name: 'Ulcinj'
      },
      {
        code: '21',
        name: 'Žabljak'
      },
      {
        code: '25',
        name: 'Zeta'
      }
    ]
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    code2: 'MH',
    code3: 'MHL',
    capital: 'Majuro',
    region: 'Oceania',
    subregion: 'Micronesia',
    states: [
      {
        code: 'ALL',
        name: 'Ailinglaplap'
      },
      {
        code: 'ALK',
        name: 'Ailuk'
      },
      {
        code: 'ARN',
        name: 'Arno'
      },
      {
        code: 'AUR',
        name: 'Aur'
      },
      {
        code: 'KIL',
        name: 'Bikini & Kili'
      },
      {
        code: 'EBO',
        name: 'Ebon'
      },
      {
        code: 'ENI',
        name: 'Enewetak & Ujelang'
      },
      {
        code: 'JAB',
        name: 'Jabat'
      },
      {
        code: 'JAL',
        name: 'Jaluit'
      },
      {
        code: 'KWA',
        name: 'Kwajalein'
      },
      {
        code: 'LAE',
        name: 'Lae'
      },
      {
        code: 'LIB',
        name: 'Lib'
      },
      {
        code: 'LIK',
        name: 'Likiep'
      },
      {
        code: 'MAJ',
        name: 'Majuro'
      },
      {
        code: 'MAL',
        name: 'Maloelap'
      },
      {
        code: 'MEJ',
        name: 'Mejit'
      },
      {
        code: 'MIL',
        name: 'Mili'
      },
      {
        code: 'NMK',
        name: 'Namdrik'
      },
      {
        code: 'NMU',
        name: 'Namu'
      },
      {
        code: 'RON',
        name: 'Rongelap'
      },
      {
        code: 'UJA',
        name: 'Ujae'
      },
      {
        code: 'UTI',
        name: 'Utrik'
      },
      {
        code: 'WTH',
        name: 'Wotho'
      },
      {
        code: 'WTJ',
        name: 'Wotje'
      }
    ]
  },
  {
    code: 'MK',
    name: 'North Macedonia',
    code2: 'MK',
    code3: 'MKD',
    capital: 'Skopje',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '801',
        name: 'Aerodrom'
      },
      {
        code: '802',
        name: 'Aračinovo'
      },
      {
        code: '201',
        name: 'Berovo'
      },
      {
        code: '501',
        name: 'Bitola'
      },
      {
        code: '401',
        name: 'Bogdanci'
      },
      {
        code: '601',
        name: 'Bogovinje'
      },
      {
        code: '402',
        name: 'Bosilovo'
      },
      {
        code: '602',
        name: 'Brvenica'
      },
      {
        code: '803',
        name: 'Butel'
      },
      {
        code: '814',
        name: 'Centar'
      },
      {
        code: '313',
        name: 'Centar Župa'
      },
      {
        code: '815',
        name: 'Čair'
      },
      {
        code: '109',
        name: 'Čaška'
      },
      {
        code: '210',
        name: 'Češinovo-Obleševo'
      },
      {
        code: '816',
        name: 'Čučer-Sandevo'
      },
      {
        code: '303',
        name: 'Debar'
      },
      {
        code: '304',
        name: 'Debrca'
      },
      {
        code: '203',
        name: 'Delčevo'
      },
      {
        code: '502',
        name: 'Demir Hisar'
      },
      {
        code: '103',
        name: 'Demir Kapija'
      },
      {
        code: '406',
        name: 'Dojran'
      },
      {
        code: '503',
        name: 'Dolneni'
      },
      {
        code: '804',
        name: 'Gazi Baba'
      },
      {
        code: '405',
        name: 'Gevgelija'
      },
      {
        code: '805',
        name: 'Gjorče Petrov'
      },
      {
        code: '604',
        name: 'Gostivar'
      },
      {
        code: '102',
        name: 'Gradsko'
      },
      {
        code: '807',
        name: 'Ilinden'
      },
      {
        code: '606',
        name: 'Jegunovce'
      },
      {
        code: '205',
        name: 'Karbinci'
      },
      {
        code: '808',
        name: 'Karpoš'
      },
      {
        code: '104',
        name: 'Kavadarci'
      },
      {
        code: '307',
        name: 'Kičevo'
      },
      {
        code: '809',
        name: 'Kisela Voda'
      },
      {
        code: '206',
        name: 'Kočani'
      },
      {
        code: '407',
        name: 'Konče'
      },
      {
        code: '701',
        name: 'Kratovo'
      },
      {
        code: '702',
        name: 'Kriva Palanka'
      },
      {
        code: '504',
        name: 'Krivogaštani'
      },
      {
        code: '505',
        name: 'Kruševo'
      },
      {
        code: '703',
        name: 'Kumanovo'
      },
      {
        code: '704',
        name: 'Lipkovo'
      },
      {
        code: '105',
        name: 'Lozovo'
      },
      {
        code: '207',
        name: 'Makedonska Kamenica'
      },
      {
        code: '308',
        name: 'Makedonski Brod'
      },
      {
        code: '607',
        name: 'Mavrovo i Rostuše'
      },
      {
        code: '506',
        name: 'Mogila'
      },
      {
        code: '106',
        name: 'Negotino'
      },
      {
        code: '507',
        name: 'Novaci'
      },
      {
        code: '408',
        name: 'Novo Selo'
      },
      {
        code: '310',
        name: 'Ohrid'
      },
      {
        code: '208',
        name: 'Pehčevo'
      },
      {
        code: '810',
        name: 'Petrovec'
      },
      {
        code: '311',
        name: 'Plasnica'
      },
      {
        code: '508',
        name: 'Prilep'
      },
      {
        code: '209',
        name: 'Probištip'
      },
      {
        code: '409',
        name: 'Radoviš'
      },
      {
        code: '705',
        name: 'Rankovce'
      },
      {
        code: '509',
        name: 'Resen'
      },
      {
        code: '107',
        name: 'Rosoman'
      },
      {
        code: '811',
        name: 'Saraj'
      },
      {
        code: '812',
        name: 'Sopište'
      },
      {
        code: '706',
        name: 'Staro Nagoričane'
      },
      {
        code: '312',
        name: 'Struga'
      },
      {
        code: '410',
        name: 'Strumica'
      },
      {
        code: '813',
        name: 'Studeničani'
      },
      {
        code: '108',
        name: 'Sveti Nikole'
      },
      {
        code: '211',
        name: 'Štip'
      },
      {
        code: '817',
        name: 'Šuto Orizari'
      },
      {
        code: '608',
        name: 'Tearce'
      },
      {
        code: '609',
        name: 'Tetovo'
      },
      {
        code: '403',
        name: 'Valandovo'
      },
      {
        code: '404',
        name: 'Vasilevo'
      },
      {
        code: '101',
        name: 'Veles'
      },
      {
        code: '301',
        name: 'Vevčani'
      },
      {
        code: '202',
        name: 'Vinica'
      },
      {
        code: '603',
        name: 'Vrapčište'
      },
      {
        code: '806',
        name: 'Zelenikovo'
      },
      {
        code: '204',
        name: 'Zrnovci'
      },
      {
        code: '605',
        name: 'Želino'
      }
    ]
  },
  {
    code: 'ML',
    name: 'Mali',
    code2: 'ML',
    code3: 'MLI',
    capital: 'Bamako',
    region: 'Africa',
    subregion: 'Western Africa',
    states: [
      {
        code: '1',
        name: 'Kayes'
      },
      {
        code: '2',
        name: 'Koulikoro'
      },
      {
        code: '3',
        name: 'Sikasso'
      },
      {
        code: '4',
        name: 'Segou'
      },
      {
        code: '5',
        name: 'Mopti'
      },
      {
        code: '6',
        name: 'Tombouctou'
      },
      {
        code: '7',
        name: 'Gao'
      },
      {
        code: '8',
        name: 'Kidal'
      },
      {
        code: '9',
        name: 'Menaka'
      },
      {
        code: '10',
        name: 'Taoudenit'
      },
      {
        code: 'BKO',
        name: 'Bamako'
      }
    ]
  },
  {
    code: 'MO',
    name: 'Macao',
    code2: 'MO',
    code3: 'MAC',
    region: 'Asia',
    subregion: 'Eastern Asia',
    states: [
      {
        code: 'MO',
        name: 'Macao'
      }
    ]
  },
  {
    code: 'MQ',
    name: 'Martinique',
    code2: 'MQ',
    code3: 'MTQ',
    capital: 'Fort-de-France',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'MQ',
        name: 'Martinique'
      }
    ]
  },
  {
    code: 'MT',
    name: 'Malta',
    code2: 'MT',
    code3: 'MLT',
    capital: 'Valletta',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '01',
        name: 'Attard'
      },
      {
        code: '02',
        name: 'Balzan'
      },
      {
        code: '03',
        name: 'Birgu'
      },
      {
        code: '04',
        name: 'Birkirkara'
      },
      {
        code: '05',
        name: 'Birżebbuġa'
      },
      {
        code: '06',
        name: 'Bormla'
      },
      {
        code: '07',
        name: 'Dingli'
      },
      {
        code: '08',
        name: 'Fgura'
      },
      {
        code: '09',
        name: 'Floriana'
      },
      {
        code: '10',
        name: 'Fontana'
      },
      {
        code: '11',
        name: 'Gudja'
      },
      {
        code: '12',
        name: 'Gżira'
      },
      {
        code: '13',
        name: 'Għajnsielem'
      },
      {
        code: '14',
        name: 'Għarb'
      },
      {
        code: '15',
        name: 'Għargħur'
      },
      {
        code: '16',
        name: 'Għasri'
      },
      {
        code: '17',
        name: 'Għaxaq'
      },
      {
        code: '18',
        name: 'Ħamrun'
      },
      {
        code: '19',
        name: 'Iklin'
      },
      {
        code: '20',
        name: 'Isla'
      },
      {
        code: '21',
        name: 'Kalkara'
      },
      {
        code: '22',
        name: 'Kerċem'
      },
      {
        code: '23',
        name: 'Kirkop'
      },
      {
        code: '24',
        name: 'Lija'
      },
      {
        code: '25',
        name: 'Luqa'
      },
      {
        code: '26',
        name: 'Marsa'
      },
      {
        code: '27',
        name: 'Marsaskala'
      },
      {
        code: '28',
        name: 'Marsaxlokk'
      },
      {
        code: '29',
        name: 'Mdina'
      },
      {
        code: '30',
        name: 'Mellieħa'
      },
      {
        code: '31',
        name: 'Mġarr'
      },
      {
        code: '32',
        name: 'Mosta'
      },
      {
        code: '33',
        name: 'Mqabba'
      },
      {
        code: '34',
        name: 'Msida'
      },
      {
        code: '35',
        name: 'Mtarfa'
      },
      {
        code: '36',
        name: 'Munxar'
      },
      {
        code: '37',
        name: 'Nadur'
      },
      {
        code: '38',
        name: 'Naxxar'
      },
      {
        code: '39',
        name: 'Paola'
      },
      {
        code: '40',
        name: 'Pembroke'
      },
      {
        code: '41',
        name: 'Pietà'
      },
      {
        code: '42',
        name: 'Qala'
      },
      {
        code: '43',
        name: 'Qormi'
      },
      {
        code: '44',
        name: 'Qrendi'
      },
      {
        code: '45',
        name: 'Rabat Għawdex'
      },
      {
        code: '46',
        name: 'Rabat Malta'
      },
      {
        code: '47',
        name: 'Safi'
      },
      {
        code: '48',
        name: 'San Ġiljan'
      },
      {
        code: '49',
        name: 'San Ġwann'
      },
      {
        code: '50',
        name: 'San Lawrenz'
      },
      {
        code: '51',
        name: 'San Pawl il-Baħar'
      },
      {
        code: '52',
        name: 'Sannat'
      },
      {
        code: '53',
        name: 'Santa Luċija'
      },
      {
        code: '54',
        name: 'Santa Venera'
      },
      {
        code: '55',
        name: 'Siġġiewi'
      },
      {
        code: '56',
        name: 'Sliema'
      },
      {
        code: '57',
        name: 'Swieqi'
      },
      {
        code: '58',
        name: "Ta' Xbiex"
      },
      {
        code: '59',
        name: 'Tarxien'
      },
      {
        code: '60',
        name: 'Valletta'
      },
      {
        code: '61',
        name: 'Xagħra'
      },
      {
        code: '62',
        name: 'Xewkija'
      },
      {
        code: '63',
        name: 'Xgħajra'
      },
      {
        code: '64',
        name: 'Żabbar'
      },
      {
        code: '65',
        name: 'Żebbuġ Għawdex'
      },
      {
        code: '66',
        name: 'Żebbuġ Malta'
      },
      {
        code: '67',
        name: 'Żejtun'
      },
      {
        code: '68',
        name: 'Żurrieq'
      }
    ]
  },
  {
    code: 'MU',
    name: 'Mauritius',
    code2: 'MU',
    code3: 'MUS',
    capital: 'Port Louis',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: 'AG',
        name: 'Agalega Islands'
      },
      {
        code: 'BL',
        name: 'Black River'
      },
      {
        code: 'CC',
        name: 'St. Brandon Islands'
      },
      {
        code: 'FL',
        name: 'Flacq'
      },
      {
        code: 'GP',
        name: 'Grand Port'
      },
      {
        code: 'MO',
        name: 'Moka'
      },
      {
        code: 'PA',
        name: 'Pamplemousses'
      },
      {
        code: 'PL',
        name: 'Port Louis'
      },
      {
        code: 'PW',
        name: 'Plaines Wilhems'
      },
      {
        code: 'RO',
        name: 'Rodrigues Island'
      },
      {
        code: 'RR',
        name: 'Riviere du Rempart'
      },
      {
        code: 'SA',
        name: 'Savanne'
      }
    ]
  },
  {
    code: 'MX',
    name: 'Mexico',
    code2: 'MX',
    code3: 'MEX',
    capital: 'Mexico City',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: 'AGU',
        name: 'Aguascalientes'
      },
      {
        code: 'BCN',
        name: 'Baja California'
      },
      {
        code: 'BCS',
        name: 'Baja California Sur'
      },
      {
        code: 'CAM',
        name: 'Campeche'
      },
      {
        code: 'CHH',
        name: 'Chihuahua'
      },
      {
        code: 'CHP',
        name: 'Chiapas'
      },
      {
        code: 'CMX',
        name: 'Ciudad de Mexico'
      },
      {
        code: 'COA',
        name: 'Coahuila de Zaragoza'
      },
      {
        code: 'COL',
        name: 'Colima'
      },
      {
        code: 'DUR',
        name: 'Durango'
      },
      {
        code: 'GRO',
        name: 'Guerrero'
      },
      {
        code: 'GUA',
        name: 'Guanajuato'
      },
      {
        code: 'HID',
        name: 'Hidalgo'
      },
      {
        code: 'JAL',
        name: 'Jalisco'
      },
      {
        code: 'MEX',
        name: 'Mexico'
      },
      {
        code: 'MIC',
        name: 'Michoacan'
      },
      {
        code: 'MOR',
        name: 'Morelos'
      },
      {
        code: 'NAY',
        name: 'Nayarit'
      },
      {
        code: 'NLE',
        name: 'Nuevo Leon'
      },
      {
        code: 'OAX',
        name: 'Oaxaca'
      },
      {
        code: 'PUE',
        name: 'Puebla'
      },
      {
        code: 'QUE',
        name: 'Queretaro'
      },
      {
        code: 'ROO',
        name: 'Quintana Roo'
      },
      {
        code: 'SIN',
        name: 'Sinaloa'
      },
      {
        code: 'SLP',
        name: 'San Luis Potosi'
      },
      {
        code: 'SON',
        name: 'Sonora'
      },
      {
        code: 'TAB',
        name: 'Tabasco'
      },
      {
        code: 'TAM',
        name: 'Tamaulipas'
      },
      {
        code: 'TLA',
        name: 'Tlaxcala'
      },
      {
        code: 'VER',
        name: 'Veracruz'
      },
      {
        code: 'YUC',
        name: 'Yucatan'
      },
      {
        code: 'ZAC',
        name: 'Zacatecas'
      }
    ]
  },
  {
    code: 'MY',
    name: 'Malaysia',
    code2: 'MY',
    code3: 'MYS',
    capital: 'Kuala Lumpur',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: '01',
        name: 'Johor'
      },
      {
        code: '02',
        name: 'Kedah'
      },
      {
        code: '03',
        name: 'Kelantan'
      },
      {
        code: '04',
        name: 'Melaka'
      },
      {
        code: '05',
        name: 'Negeri Sembilan'
      },
      {
        code: '06',
        name: 'Pahang'
      },
      {
        code: '07',
        name: 'Pulau Pinang'
      },
      {
        code: '08',
        name: 'Perak'
      },
      {
        code: '09',
        name: 'Perlis'
      },
      {
        code: '10',
        name: 'Selangor'
      },
      {
        code: '11',
        name: 'Trengganu'
      },
      {
        code: '12',
        name: 'Sabah'
      },
      {
        code: '13',
        name: 'Sarawak'
      },
      {
        code: '14',
        name: 'Wilayah Persekutuan Kuala Lumpur'
      },
      {
        code: '15',
        name: 'Wilayah Persekutuan Labuan'
      },
      {
        code: '16',
        name: 'Wilayah Persekutuan Putrajaya'
      }
    ]
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    code2: 'MZ',
    code3: 'MOZ',
    capital: 'Maputo',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: 'A',
        name: 'Niassa'
      },
      {
        code: 'B',
        name: 'Manica'
      },
      {
        code: 'G',
        name: 'Gaza'
      },
      {
        code: 'I',
        name: 'Inhambane'
      },
      {
        code: 'L',
        name: 'Maputo'
      },
      {
        code: 'MPM',
        name: 'Maputo City'
      },
      {
        code: 'N',
        name: 'Nampula'
      },
      {
        code: 'P',
        name: 'Cabo Delgado'
      },
      {
        code: 'Q',
        name: 'Zambezia'
      },
      {
        code: 'S',
        name: 'Sofala'
      },
      {
        code: 'T',
        name: 'Tete'
      }
    ]
  },
  {
    code: 'NA',
    name: 'Namibia',
    code2: 'NA',
    code3: 'NAM',
    capital: 'Windhoek',
    region: 'Africa',
    subregion: 'Southern Africa',
    states: [
      {
        code: 'CA',
        name: 'Zambezi'
      },
      {
        code: 'ER',
        name: 'Erongo'
      },
      {
        code: 'HA',
        name: 'Hardap'
      },
      {
        code: 'KA',
        name: 'Karas'
      },
      {
        code: 'KE',
        name: 'Kavango East'
      },
      {
        code: 'KH',
        name: 'Khomas'
      },
      {
        code: 'KU',
        name: 'Kunene'
      },
      {
        code: 'KW',
        name: 'Kavango West'
      },
      {
        code: 'OD',
        name: 'Otjozondjupa'
      },
      {
        code: 'OH',
        name: 'Omaheke'
      },
      {
        code: 'ON',
        name: 'Oshana'
      },
      {
        code: 'OS',
        name: 'Omusati'
      },
      {
        code: 'OT',
        name: 'Oshikoto'
      },
      {
        code: 'OW',
        name: 'Ohangwena'
      }
    ]
  },
  {
    code: 'NG',
    name: 'Nigeria',
    code2: 'NG',
    code3: 'NGA',
    capital: 'Abuja',
    region: 'Africa',
    subregion: 'Western Africa',
    states: [
      {
        code: 'AB',
        name: 'Abia'
      },
      {
        code: 'FC',
        name: 'Abuja Federal Capital Territory'
      },
      {
        code: 'AD',
        name: 'Adamawa'
      },
      {
        code: 'AK',
        name: 'Akwa Ibom'
      },
      {
        code: 'AN',
        name: 'Anambra'
      },
      {
        code: 'BA',
        name: 'Bauchi'
      },
      {
        code: 'BY',
        name: 'Bayelsa'
      },
      {
        code: 'BE',
        name: 'Benue'
      },
      {
        code: 'BO',
        name: 'Borno'
      },
      {
        code: 'CR',
        name: 'Cross River'
      },
      {
        code: 'DE',
        name: 'Delta'
      },
      {
        code: 'EB',
        name: 'Ebonyi'
      },
      {
        code: 'ED',
        name: 'Edo'
      },
      {
        code: 'EK',
        name: 'Ekiti'
      },
      {
        code: 'EN',
        name: 'Enugu'
      },
      {
        code: 'GO',
        name: 'Gombe'
      },
      {
        code: 'IM',
        name: 'Imo'
      },
      {
        code: 'JI',
        name: 'Jigawa'
      },
      {
        code: 'KD',
        name: 'Kaduna'
      },
      {
        code: 'KN',
        name: 'Kano'
      },
      {
        code: 'KT',
        name: 'Katsina'
      },
      {
        code: 'KE',
        name: 'Kebbi'
      },
      {
        code: 'KO',
        name: 'Kogi'
      },
      {
        code: 'KW',
        name: 'Kwara'
      },
      {
        code: 'LA',
        name: 'Lagos'
      },
      {
        code: 'NA',
        name: 'Nasarawa'
      },
      {
        code: 'NI',
        name: 'Niger'
      },
      {
        code: 'OG',
        name: 'Ogun'
      },
      {
        code: 'ON',
        name: 'Ondo'
      },
      {
        code: 'OS',
        name: 'Osun'
      },
      {
        code: 'OY',
        name: 'Oyo'
      },
      {
        code: 'PL',
        name: 'Plateau'
      },
      {
        code: 'RI',
        name: 'Rivers'
      },
      {
        code: 'SO',
        name: 'Sokoto'
      },
      {
        code: 'TA',
        name: 'Taraba'
      },
      {
        code: 'YO',
        name: 'Yobe'
      },
      {
        code: 'ZA',
        name: 'Zamfara'
      }
    ]
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    code2: 'NI',
    code3: 'NIC',
    capital: 'Managua',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: 'BO',
        name: 'Boaco'
      },
      {
        code: 'CA',
        name: 'Carazo'
      },
      {
        code: 'CI',
        name: 'Chinandega'
      },
      {
        code: 'CO',
        name: 'Chontales'
      },
      {
        code: 'AN',
        name: 'North Caribbean Coast'
      },
      {
        code: 'AS',
        name: 'South Caribbean Coast'
      },
      {
        code: 'ES',
        name: 'Estelí'
      },
      {
        code: 'GR',
        name: 'Granada'
      },
      {
        code: 'JI',
        name: 'Jinotega'
      },
      {
        code: 'LE',
        name: 'León'
      },
      {
        code: 'MD',
        name: 'Madriz'
      },
      {
        code: 'MN',
        name: 'Managua'
      },
      {
        code: 'MS',
        name: 'Masaya'
      },
      {
        code: 'MT',
        name: 'Matagalpa'
      },
      {
        code: 'NS',
        name: 'New Segovia'
      },
      {
        code: 'SJ',
        name: 'Saint John River'
      },
      {
        code: 'RI',
        name: 'Rivas'
      }
    ]
  },
  {
    code: 'NL',
    name: 'Netherlands',
    code2: 'NL',
    code3: 'NLD',
    capital: 'Amsterdam',
    region: 'Europe',
    subregion: 'Western Europe',
    states: [
      {
        code: 'DR',
        name: 'Drenthe'
      },
      {
        code: 'FL',
        name: 'Flevoland'
      },
      {
        code: 'FR',
        name: 'Friesland'
      },
      {
        code: 'GE',
        name: 'Gelderland'
      },
      {
        code: 'GR',
        name: 'Groningen'
      },
      {
        code: 'LI',
        name: 'Limburg'
      },
      {
        code: 'NB',
        name: 'North Brabant'
      },
      {
        code: 'NH',
        name: 'North Holland'
      },
      {
        code: 'OV',
        name: 'Overijssel'
      },
      {
        code: 'UT',
        name: 'Utrecht'
      },
      {
        code: 'ZE',
        name: 'Zeeland'
      },
      {
        code: 'ZH',
        name: 'South Holland'
      }
    ]
  },
  {
    code: 'NO',
    name: 'Norway',
    code2: 'NO',
    code3: 'NOR',
    capital: 'Oslo',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: '42',
        name: 'Agder'
      },
      {
        code: '34',
        name: 'Innlandet'
      },
      {
        code: '22',
        name: 'Jan Mayen'
      },
      {
        code: '15',
        name: 'Møre og Romsdal'
      },
      {
        code: '18',
        name: 'Nordland'
      },
      {
        code: '03',
        name: 'Oslo'
      },
      {
        code: '11',
        name: 'Rogaland'
      },
      {
        code: '21',
        name: 'Svalbard'
      },
      {
        code: '38',
        name: 'Vestfold og Telemark'
      },
      {
        code: '46',
        name: 'Vestland'
      },
      {
        code: '30',
        name: 'Viken'
      },
      {
        code: '54',
        name: 'Troms and Finnmark'
      },
      {
        code: '50',
        name: 'Trondelag'
      }
    ]
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    code2: 'NZ',
    code3: 'NZL',
    capital: 'Wellington',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
    states: [
      {
        code: 'AUK',
        name: 'Auckland'
      },
      {
        code: 'BOP',
        name: 'Bay of Plenty'
      },
      {
        code: 'CAN',
        name: 'Canterbury'
      },
      {
        code: 'CIT',
        name: 'Chatham Islands Territory'
      },
      {
        code: 'GIS',
        name: 'Gisborne'
      },
      {
        code: 'WGN',
        name: 'Greater Wellington'
      },
      {
        code: 'HKB',
        name: "Hawke's Bay"
      },
      {
        code: 'MWT',
        name: 'Manawatū-Whanganui'
      },
      {
        code: 'MBH',
        name: 'Marlborough'
      },
      {
        code: 'NSN',
        name: 'Nelson'
      },
      {
        code: 'NTL',
        name: 'Northland'
      },
      {
        code: 'OTA',
        name: 'Otago'
      },
      {
        code: 'STL',
        name: 'Southland'
      },
      {
        code: 'TKI',
        name: 'Taranaki'
      },
      {
        code: 'TAS',
        name: 'Tasman'
      },
      {
        code: 'WKO',
        name: 'Waikato'
      },
      {
        code: 'WTC',
        name: 'West Coast'
      }
    ]
  },
  {
    code: 'OM',
    name: 'Oman',
    code2: 'OM',
    code3: 'OMN',
    capital: 'Muscat',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'OM-DA',
        name: 'Interior'
      },
      {
        code: 'OM-BU',
        name: 'Buraymi'
      },
      {
        code: 'OM-WU',
        name: 'Central'
      },
      {
        code: 'OM-ZA',
        name: 'Dhahira'
      },
      {
        code: 'OM-BJ',
        name: 'South Batina'
      },
      {
        code: 'OM-SJ',
        name: 'Southeastern'
      },
      {
        code: 'OM-MA',
        name: 'Muscat'
      },
      {
        code: 'OM-MU',
        name: 'Musandam'
      },
      {
        code: 'OM-BS',
        name: 'North Batina'
      },
      {
        code: 'OM-SS',
        name: 'Northeastern'
      },
      {
        code: 'OM-ZU',
        name: 'Dhofar'
      }
    ]
  },
  {
    code: 'PA',
    name: 'Panama',
    code2: 'PA',
    code3: 'PAN',
    capital: 'Panama City',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: '1',
        name: 'Bocas del Toro'
      },
      {
        code: '2',
        name: 'Cocle'
      },
      {
        code: '3',
        name: 'Colon'
      },
      {
        code: '4',
        name: 'Chiriqui'
      },
      {
        code: '5',
        name: 'Darien'
      },
      {
        code: '6',
        name: 'Herrera'
      },
      {
        code: '7',
        name: 'Los Santos'
      },
      {
        code: '8',
        name: 'Panama'
      },
      {
        code: '9',
        name: 'Veraguas'
      },
      {
        code: '10',
        name: 'West Panama'
      },
      {
        code: 'EM',
        name: 'Embera'
      },
      {
        code: 'KY',
        name: 'Guna Yala'
      },
      {
        code: 'NB',
        name: 'Ngabe-Bugle'
      },
      {
        code: 'NT',
        name: 'Naso Tjer Di'
      }
    ]
  },
  {
    code: 'PE',
    name: 'Peru',
    code2: 'PE',
    code3: 'PER',
    capital: 'Lima',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'AMA',
        name: 'Amazonas'
      },
      {
        code: 'ANC',
        name: 'Ancash'
      },
      {
        code: 'APU',
        name: 'Apurímac'
      },
      {
        code: 'ARE',
        name: 'Arequipa'
      },
      {
        code: 'AYA',
        name: 'Ayacucho'
      },
      {
        code: 'CAJ',
        name: 'Cajamarca'
      },
      {
        code: 'CUS',
        name: 'Cusco (local variant: Cuzco)'
      },
      {
        code: 'CAL',
        name: 'El Callao'
      },
      {
        code: 'HUV',
        name: 'Huancavelica'
      },
      {
        code: 'HUC',
        name: 'Huánuco'
      },
      {
        code: 'ICA',
        name: 'Ica'
      },
      {
        code: 'JUN',
        name: 'Junín'
      },
      {
        code: 'LAL',
        name: 'La Libertad'
      },
      {
        code: 'LAM',
        name: 'Lambayeque'
      },
      {
        code: 'LIM',
        name: 'Lima'
      },
      {
        code: 'LOR',
        name: 'Loreto'
      },
      {
        code: 'MDD',
        name: 'Madre de Dios'
      },
      {
        code: 'MOQ',
        name: 'Moquegua'
      },
      {
        code: 'LMA',
        name: 'Municipalidad Metropolitana de Lima'
      },
      {
        code: 'PAS',
        name: 'Pasco'
      },
      {
        code: 'PIU',
        name: 'Piura'
      },
      {
        code: 'PUN',
        name: 'Puno'
      },
      {
        code: 'SAM',
        name: 'San Martín'
      },
      {
        code: 'TAC',
        name: 'Tacna'
      },
      {
        code: 'TUM',
        name: 'Tumbes'
      },
      {
        code: 'UCA',
        name: 'Ucayali'
      }
    ]
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    code2: 'PF',
    code3: 'PYF',
    capital: 'Papeetē',
    region: 'Oceania',
    subregion: 'Polynesia',
    states: [
      {
        code: 'PF',
        name: 'French Polynesia'
      }
    ]
  },
  {
    code: 'PH',
    name: 'Philippines',
    code2: 'PH',
    code3: 'PHL',
    capital: 'Manila',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: '01',
        name: 'Ilocos'
      },
      {
        code: '02',
        name: 'Cagayan Valley'
      },
      {
        code: '03',
        name: 'Central Luzon'
      },
      {
        code: '05',
        name: 'Bicol'
      },
      {
        code: '06',
        name: 'West Visayas'
      },
      {
        code: '07',
        name: 'Central Visayas'
      },
      {
        code: '08',
        name: 'Eastern Visayas'
      },
      {
        code: '09',
        name: 'Zamboanga Peninsula'
      },
      {
        code: '10',
        name: 'Northern Mindanao'
      },
      {
        code: '11',
        name: 'Davao'
      },
      {
        code: '12',
        name: 'Soccsksargen'
      },
      {
        code: '13',
        name: 'Caraga'
      },
      {
        code: '14',
        name: 'Autonomous Region in Muslim Mindanao'
      },
      {
        code: '15',
        name: 'Cordillera Administrative Region'
      },
      {
        code: '40',
        name: 'Calabarzon'
      },
      {
        code: '41',
        name: 'Mimaropa'
      }
    ]
  },
  {
    code: 'PK',
    name: 'Pakistan',
    code2: 'PK',
    code3: 'PAK',
    capital: 'Islamabad',
    region: 'Asia',
    subregion: 'Southern Asia',
    states: [
      {
        code: 'JK',
        name: 'Azad Jammu, Kashmir'
      },
      {
        code: 'BA',
        name: 'Balochistan'
      },
      {
        code: 'GB',
        name: 'Gilgit-Baltistan'
      },
      {
        code: 'IS',
        name: 'Islamabad'
      },
      {
        code: 'KP',
        name: 'Khyber Pakhtunkhwa'
      },
      {
        code: 'PB',
        name: 'Punjab'
      },
      {
        code: 'SD',
        name: 'Sindh'
      }
    ]
  },
  {
    code: 'PL',
    name: 'Poland',
    code2: 'PL',
    code3: 'POL',
    capital: 'Warsaw',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: '02',
        name: 'Lower Silesia'
      },
      {
        code: '04',
        name: 'Kuyavia-Pomerania'
      },
      {
        code: '06',
        name: 'Lublin'
      },
      {
        code: '08',
        name: 'Lubusz'
      },
      {
        code: '10',
        name: 'Lodz'
      },
      {
        code: '12',
        name: 'Lesser Poland'
      },
      {
        code: '14',
        name: 'Mazovia'
      },
      {
        code: '16',
        name: 'Upper Silesia'
      },
      {
        code: '18',
        name: 'Subcarpathia'
      },
      {
        code: '20',
        name: 'Podlaskie'
      },
      {
        code: '22',
        name: 'Pomerania'
      },
      {
        code: '24',
        name: 'Silesia'
      },
      {
        code: '26',
        name: 'Holy Cross'
      },
      {
        code: '28',
        name: 'Warmia-Masuria'
      },
      {
        code: '30',
        name: 'Greater Poland'
      },
      {
        code: '32',
        name: 'West Pomerania'
      }
    ]
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    code2: 'PR',
    code3: 'PRI',
    capital: 'San Juan',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'PR',
        name: 'Puerto Rico'
      }
    ]
  },
  {
    code: 'PS',
    name: 'Palestine',
    code2: 'PS',
    code3: 'PSE',
    capital: 'Ramallah',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'BTH',
        name: 'Bethlehem'
      },
      {
        code: 'DEB',
        name: 'Deir El Balah'
      },
      {
        code: 'GZA',
        name: 'Gaza'
      },
      {
        code: 'HBN',
        name: 'Hebron'
      },
      {
        code: 'JEM',
        name: 'Jerusalem'
      },
      {
        code: 'JEN',
        name: 'Jenin'
      },
      {
        code: 'JRH',
        name: 'Jericho and Al Aghwar'
      },
      {
        code: 'KYS',
        name: 'Khan Yunis'
      },
      {
        code: 'NBS',
        name: 'Nablus'
      },
      {
        code: 'NGZ',
        name: 'North Gaza'
      },
      {
        code: 'QQA',
        name: 'Qalqilya'
      },
      {
        code: 'RBH',
        name: 'Ramallah'
      },
      {
        code: 'RFH',
        name: 'Rafah'
      },
      {
        code: 'SLT',
        name: 'Salfit'
      },
      {
        code: 'TBS',
        name: 'Tubas'
      },
      {
        code: 'TKM',
        name: 'Tulkarm'
      }
    ]
  },
  {
    code: 'PT',
    name: 'Portugal',
    code2: 'PT',
    code3: 'PRT',
    capital: 'Lisbon',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '01',
        name: 'Aveiro'
      },
      {
        code: '02',
        name: 'Beja'
      },
      {
        code: '03',
        name: 'Braga'
      },
      {
        code: '04',
        name: 'Braganca'
      },
      {
        code: '05',
        name: 'White Castle'
      },
      {
        code: '06',
        name: 'Coimbra'
      },
      {
        code: '07',
        name: 'Evora'
      },
      {
        code: '08',
        name: 'Faro'
      },
      {
        code: '09',
        name: 'Guarda'
      },
      {
        code: '10',
        name: 'Leiria'
      },
      {
        code: '11',
        name: 'Lisbon'
      },
      {
        code: '12',
        name: 'Portalegre'
      },
      {
        code: '13',
        name: 'Porto'
      },
      {
        code: '30',
        name: 'Madeira'
      },
      {
        code: '20',
        name: 'Azores'
      },
      {
        code: '14',
        name: 'Santarem'
      },
      {
        code: '15',
        name: 'Setubal'
      },
      {
        code: '16',
        name: 'Viana do Castelo'
      },
      {
        code: '17',
        name: 'Royal Town'
      },
      {
        code: '18',
        name: 'Viseu'
      }
    ]
  },
  {
    code: 'PY',
    name: 'Paraguay',
    code2: 'PY',
    code3: 'PRY',
    capital: 'Asunción',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: '1',
        name: 'Concepcion'
      },
      {
        code: '2',
        name: 'San Pedro'
      },
      {
        code: '3',
        name: 'Cordillera'
      },
      {
        code: '4',
        name: 'Guaira'
      },
      {
        code: '5',
        name: 'Caaguazu'
      },
      {
        code: '6',
        name: 'Caazapa'
      },
      {
        code: '7',
        name: 'Itapua'
      },
      {
        code: '8',
        name: 'Misiones'
      },
      {
        code: '9',
        name: 'Paraguari'
      },
      {
        code: '10',
        name: 'Alto Parana'
      },
      {
        code: '11',
        name: 'Central'
      },
      {
        code: '12',
        name: 'Neembucu'
      },
      {
        code: '13',
        name: 'Amambay'
      },
      {
        code: '14',
        name: 'Canindeyu'
      },
      {
        code: '15',
        name: 'Presidente Hayes'
      },
      {
        code: '16',
        name: 'Alto Paraguay'
      },
      {
        code: '19',
        name: 'Boqueron'
      },
      {
        code: 'ASU',
        name: 'Asuncion'
      }
    ]
  },
  {
    code: 'QA',
    name: 'Qatar',
    code2: 'QA',
    code3: 'QAT',
    capital: 'Doha',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: 'DA',
        name: 'Doha'
      },
      {
        code: 'KH',
        name: 'Khor'
      },
      {
        code: 'MS',
        name: 'North'
      },
      {
        code: 'RA',
        name: 'Rayyan'
      },
      {
        code: 'SH',
        name: 'Shahaniya'
      },
      {
        code: 'US',
        name: 'Umm Salal'
      },
      {
        code: 'WA',
        name: 'Wakra'
      },
      {
        code: 'ZA',
        name: 'Daayen'
      }
    ]
  },
  {
    code: 'RE',
    name: 'Réunion',
    code2: 'RE',
    code3: 'REU',
    capital: 'Saint-Denis',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: 'RE',
        name: 'Reunion'
      }
    ]
  },
  {
    code: 'RO',
    name: 'Romania',
    code2: 'RO',
    code3: 'ROU',
    capital: 'Bucharest',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: 'AB',
        name: 'Alba'
      },
      {
        code: 'AR',
        name: 'Arad'
      },
      {
        code: 'AG',
        name: 'Argeș'
      },
      {
        code: 'BC',
        name: 'Bacău'
      },
      {
        code: 'BH',
        name: 'Bihor'
      },
      {
        code: 'BN',
        name: 'Bistrița-Năsăud'
      },
      {
        code: 'BT',
        name: 'Botoșani'
      },
      {
        code: 'BV',
        name: 'Brașov'
      },
      {
        code: 'BR',
        name: 'Brăila'
      },
      {
        code: 'B',
        name: 'București'
      },
      {
        code: 'BZ',
        name: 'Buzău'
      },
      {
        code: 'CS',
        name: 'Caraș-Severin'
      },
      {
        code: 'CL',
        name: 'Călărași'
      },
      {
        code: 'CJ',
        name: 'Cluj'
      },
      {
        code: 'CT',
        name: 'Constanța'
      },
      {
        code: 'CV',
        name: 'Covasna'
      },
      {
        code: 'DB',
        name: 'Dâmbovița'
      },
      {
        code: 'DJ',
        name: 'Dolj'
      },
      {
        code: 'GL',
        name: 'Galați'
      },
      {
        code: 'GR',
        name: 'Giurgiu'
      },
      {
        code: 'GJ',
        name: 'Gorj'
      },
      {
        code: 'HR',
        name: 'Harghita'
      },
      {
        code: 'HD',
        name: 'Hunedoara'
      },
      {
        code: 'IL',
        name: 'Ialomița'
      },
      {
        code: 'IS',
        name: 'Iași'
      },
      {
        code: 'IF',
        name: 'Ilfov'
      },
      {
        code: 'MM',
        name: 'Maramureș'
      },
      {
        code: 'MH',
        name: 'Mehedinți'
      },
      {
        code: 'MS',
        name: 'Mureș'
      },
      {
        code: 'NT',
        name: 'Neamț'
      },
      {
        code: 'OT',
        name: 'Olt'
      },
      {
        code: 'PH',
        name: 'Prahova'
      },
      {
        code: 'SM',
        name: 'Satu Mare'
      },
      {
        code: 'SJ',
        name: 'Sălaj'
      },
      {
        code: 'SB',
        name: 'Sibiu'
      },
      {
        code: 'SV',
        name: 'Suceava'
      },
      {
        code: 'TR',
        name: 'Teleorman'
      },
      {
        code: 'TM',
        name: 'Timiș'
      },
      {
        code: 'TL',
        name: 'Tulcea'
      },
      {
        code: 'VS',
        name: 'Vaslui'
      },
      {
        code: 'VL',
        name: 'Vâlcea'
      },
      {
        code: 'VN',
        name: 'Vrancea'
      }
    ]
  },
  {
    code: 'RS',
    name: 'Serbia',
    code2: 'RS',
    code3: 'SRB',
    capital: 'Belgrade',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '00',
        name: 'Belgrade'
      },
      {
        code: '14',
        name: 'Bor'
      },
      {
        code: '11',
        name: 'Braničevo'
      },
      {
        code: '23',
        name: 'Jablanica'
      },
      {
        code: '06',
        name: 'South Bačka'
      },
      {
        code: '04',
        name: 'South Banat'
      },
      {
        code: '09',
        name: 'Kolubara'
      },
      {
        code: '25',
        name: 'Kosovo'
      },
      {
        code: '28',
        name: 'Kosovo-Mitrovica'
      },
      {
        code: '29',
        name: 'Kosovo-Pomoravlje'
      },
      {
        code: '08',
        name: 'Mačva'
      },
      {
        code: '17',
        name: 'Moravica'
      },
      {
        code: '20',
        name: 'Nišava'
      },
      {
        code: '24',
        name: 'Pčinja'
      },
      {
        code: '26',
        name: 'Peć'
      },
      {
        code: '22',
        name: 'Pirot'
      },
      {
        code: '10',
        name: 'Podunavlje'
      },
      {
        code: '13',
        name: 'Pomoravlje'
      },
      {
        code: '27',
        name: 'Prizren'
      },
      {
        code: '19',
        name: 'Rasina'
      },
      {
        code: '18',
        name: 'Raška'
      },
      {
        code: '01',
        name: 'North Bačka'
      },
      {
        code: '03',
        name: 'North Banat'
      },
      {
        code: '02',
        name: 'Central Banat'
      },
      {
        code: '07',
        name: 'Srem'
      },
      {
        code: '12',
        name: 'Šumadija'
      },
      {
        code: '21',
        name: 'Toplica'
      },
      {
        code: '15',
        name: 'Zaječar'
      },
      {
        code: '05',
        name: 'West Bačka'
      }
    ]
  },
  {
    code: 'RU',
    name: 'Russia',
    code2: 'RU',
    code3: 'RUS',
    capital: 'Moscow',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: '16',
        name: 'Zlatibor'
      },
      {
        code: 'AL',
        name: 'Gorno-Altai'
      },
      {
        code: 'ALT',
        name: 'Altai'
      },
      {
        code: 'AMU',
        name: 'Amur'
      },
      {
        code: 'ARK',
        name: 'Arkhangelsk'
      },
      {
        code: 'AST',
        name: 'Astrakhan'
      },
      {
        code: 'BA',
        name: 'Bashkortostan'
      },
      {
        code: 'BEL',
        name: 'Belgorod'
      },
      {
        code: 'BRY',
        name: 'Bryansk'
      },
      {
        code: 'BU',
        name: 'Buryatia'
      },
      {
        code: 'CE',
        name: 'Chechnya'
      },
      {
        code: 'CHE',
        name: 'Chelyabinsk'
      },
      {
        code: 'CHU',
        name: 'Chukotka'
      },
      {
        code: 'CU',
        name: 'Chuvashia'
      },
      {
        code: 'DA',
        name: 'Dagestan'
      },
      {
        code: 'IN',
        name: 'Ingushetia'
      },
      {
        code: 'IRK',
        name: 'Irkutsk'
      },
      {
        code: 'IVA',
        name: 'Ivanovo'
      },
      {
        code: 'KB',
        name: 'Kabardino-Balkaria'
      },
      {
        code: 'KGD',
        name: 'Kaliningrad'
      },
      {
        code: 'KL',
        name: 'Kalmykia'
      },
      {
        code: 'KLU',
        name: 'Kaluga'
      },
      {
        code: 'KAM',
        name: 'Kamchatka'
      },
      {
        code: 'KC',
        name: 'Karachay-Cherkessia'
      },
      {
        code: 'KR',
        name: 'Karelia'
      },
      {
        code: 'KEM',
        name: 'Kemerovo'
      },
      {
        code: 'KHA',
        name: 'Khabarovsk'
      },
      {
        code: 'KK',
        name: 'Khakassia'
      },
      {
        code: 'KHM',
        name: 'Yugoria'
      },
      {
        code: 'KIR',
        name: 'Kirov'
      },
      {
        code: 'KO',
        name: 'Komi'
      },
      {
        code: 'KOS',
        name: 'Kostroma'
      },
      {
        code: 'KDA',
        name: 'Krasnodar'
      },
      {
        code: 'KYA',
        name: 'Krasnoyarsk'
      },
      {
        code: 'KGN',
        name: 'Kurgan'
      },
      {
        code: 'KRS',
        name: 'Kursk'
      },
      {
        code: 'LEN',
        name: 'Leningrad'
      },
      {
        code: 'LIP',
        name: 'Lipetsk'
      },
      {
        code: 'MAG',
        name: 'Magadan'
      },
      {
        code: 'ME',
        name: 'Mari El'
      },
      {
        code: 'MO',
        name: 'Mordovia'
      },
      {
        code: 'MOS',
        name: 'Moscow'
      },
      {
        code: 'MOW',
        name: 'Moscow City'
      },
      {
        code: 'MUR',
        name: 'Murmansk'
      },
      {
        code: 'NEN',
        name: 'Nenetsia'
      },
      {
        code: 'NIZ',
        name: 'Nizhny Novgorod'
      },
      {
        code: 'NGR',
        name: 'Novgorod'
      },
      {
        code: 'NVS',
        name: 'Novosibirsk'
      },
      {
        code: 'OMS',
        name: 'Omsk'
      },
      {
        code: 'ORE',
        name: 'Orenburg'
      },
      {
        code: 'ORL',
        name: 'Oryol'
      },
      {
        code: 'PNZ',
        name: 'Penza'
      },
      {
        code: 'PER',
        name: 'Perm'
      },
      {
        code: 'PRI',
        name: 'Primorye'
      },
      {
        code: 'PSK',
        name: 'Pskov'
      },
      {
        code: 'ROS',
        name: 'Rostov'
      },
      {
        code: 'RYA',
        name: 'Ryazan'
      },
      {
        code: 'SA',
        name: 'Yakutia'
      },
      {
        code: 'SAK',
        name: 'Sakhalin'
      },
      {
        code: 'SAM',
        name: 'Samara'
      },
      {
        code: 'SPE',
        name: 'Saint Petersburg'
      },
      {
        code: 'SAR',
        name: 'Saratov'
      },
      {
        code: 'SE',
        name: 'North Ossetia'
      },
      {
        code: 'SMO',
        name: 'Smolensk'
      },
      {
        code: 'STA',
        name: 'Stavropol'
      },
      {
        code: 'SVE',
        name: 'Sverdlovsk'
      },
      {
        code: 'TAM',
        name: 'Tambov'
      },
      {
        code: 'TA',
        name: 'Tatarstan'
      },
      {
        code: 'TOM',
        name: 'Tomsk'
      },
      {
        code: 'TUL',
        name: 'Tula'
      },
      {
        code: 'TVE',
        name: 'Tver'
      },
      {
        code: 'TYU',
        name: 'Tyumen'
      },
      {
        code: 'TY',
        name: 'Tuva'
      },
      {
        code: 'UD',
        name: 'Udmurtia'
      },
      {
        code: 'ULY',
        name: 'Ulyanovsk'
      },
      {
        code: 'VLA',
        name: 'Vladimir'
      },
      {
        code: 'VGG',
        name: 'Volgograd'
      },
      {
        code: 'VLG',
        name: 'Vologda'
      },
      {
        code: 'VOR',
        name: 'Voronezh'
      },
      {
        code: 'YAN',
        name: 'Yamalia'
      },
      {
        code: 'YAR',
        name: 'Yaroslavl'
      },
      {
        code: 'YEV',
        name: 'Jewish Autonomous Oblast'
      },
      {
        code: 'ZAB',
        name: 'Transbaikalia'
      }
    ]
  },
  {
    code: 'RW',
    name: 'Rwanda',
    code2: 'RW',
    code3: 'RWA',
    capital: 'Kigali',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: '01',
        name: 'City of Kigali'
      },
      {
        code: '02',
        name: 'Eastern'
      },
      {
        code: '03',
        name: 'Northern'
      },
      {
        code: '04',
        name: 'Western'
      },
      {
        code: '05',
        name: 'Southern'
      }
    ]
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    code2: 'SA',
    code3: 'SAU',
    capital: 'Riyadh',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: '01',
        name: 'Riyadh'
      },
      {
        code: '02',
        name: 'Mecca'
      },
      {
        code: '03',
        name: 'Medina'
      },
      {
        code: '04',
        name: 'Eastern'
      },
      {
        code: '05',
        name: 'Qassim'
      },
      {
        code: '06',
        name: "Ha'il"
      },
      {
        code: '07',
        name: 'Tabuk'
      },
      {
        code: '08',
        name: 'Northern Boarders'
      },
      {
        code: '09',
        name: 'Jizan'
      },
      {
        code: '10',
        name: 'Najran'
      },
      {
        code: '11',
        name: 'Baha'
      },
      {
        code: '12',
        name: 'Jouf'
      },
      {
        code: '14',
        name: 'Asir'
      }
    ]
  },
  {
    code: 'SC',
    name: 'Seychelles',
    code2: 'SC',
    code3: 'SYC',
    capital: 'Victoria',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: '01',
        name: 'Anse aux Pins'
      },
      {
        code: '02',
        name: 'Anse Boileau'
      },
      {
        code: '03',
        name: 'Anse Etoile'
      },
      {
        code: '04',
        name: 'Au Cap'
      },
      {
        code: '05',
        name: 'Anse Royale'
      },
      {
        code: '06',
        name: 'Baie Lazare'
      },
      {
        code: '07',
        name: 'Baie Sainte Anne'
      },
      {
        code: '08',
        name: 'Beau Vallon'
      },
      {
        code: '09',
        name: 'Bel Air'
      },
      {
        code: '10',
        name: 'Bel Ombre'
      },
      {
        code: '11',
        name: 'Cascade'
      },
      {
        code: '12',
        name: 'Glacis'
      },
      {
        code: '13',
        name: 'Grand Anse Mahe'
      },
      {
        code: '14',
        name: 'Grand Anse Praslin'
      },
      {
        code: '15',
        name: 'La Digue'
      },
      {
        code: '16',
        name: 'English River'
      },
      {
        code: '17',
        name: 'Mont Buxton'
      },
      {
        code: '18',
        name: 'Mont Fleuri'
      },
      {
        code: '19',
        name: 'Plaisance'
      },
      {
        code: '20',
        name: 'Pointe Larue'
      },
      {
        code: '21',
        name: 'Port Glaud'
      },
      {
        code: '22',
        name: 'Saint Louis'
      },
      {
        code: '23',
        name: 'Takamaka'
      },
      {
        code: '24',
        name: 'Les Mamelles'
      },
      {
        code: '25',
        name: 'Roche Caiman'
      },
      {
        code: '26',
        name: 'Ile Perseverance I'
      },
      {
        code: '27',
        name: 'Ile Perseverance II'
      }
    ]
  },
  {
    code: 'SE',
    name: 'Sweden',
    code2: 'SE',
    code3: 'SWE',
    capital: 'Stockholm',
    region: 'Europe',
    subregion: 'Northern Europe',
    states: [
      {
        code: 'K',
        name: 'Blekinge'
      },
      {
        code: 'W',
        name: 'Dalarna'
      },
      {
        code: 'I',
        name: 'Gotland'
      },
      {
        code: 'X',
        name: 'Gaevleborg'
      },
      {
        code: 'N',
        name: 'Halland'
      },
      {
        code: 'Z',
        name: 'Jamtland'
      },
      {
        code: 'F',
        name: 'Jonkoping'
      },
      {
        code: 'H',
        name: 'Kalmar'
      },
      {
        code: 'G',
        name: 'Kronoberg'
      },
      {
        code: 'BD',
        name: 'Norrbotten'
      },
      {
        code: 'M',
        name: 'Scania'
      },
      {
        code: 'AB',
        name: 'Stockholm'
      },
      {
        code: 'D',
        name: 'Soedermanland'
      },
      {
        code: 'C',
        name: 'Uppsala'
      },
      {
        code: 'S',
        name: 'Varmland'
      },
      {
        code: 'AC',
        name: 'Vasterbotten'
      },
      {
        code: 'Y',
        name: 'Western Northland'
      },
      {
        code: 'U',
        name: 'Vaestmanland'
      },
      {
        code: 'O',
        name: 'Vastra Gotaland'
      },
      {
        code: 'T',
        name: 'Oerbro'
      },
      {
        code: 'E',
        name: 'Ostergotland'
      }
    ]
  },
  {
    code: 'SG',
    name: 'Singapore',
    code2: 'SG',
    code3: 'SGP',
    capital: 'Singapore',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: '01',
        name: 'Central Singapore'
      },
      {
        code: '02',
        name: 'North East'
      },
      {
        code: '03',
        name: 'North West'
      },
      {
        code: '04',
        name: 'South East'
      },
      {
        code: '05',
        name: 'South West'
      }
    ]
  },
  {
    code: 'SI',
    name: 'Slovenia',
    code2: 'SI',
    code3: 'SVN',
    capital: 'Ljubljana',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '001',
        name: 'Ajdovščina'
      },
      {
        code: '213',
        name: 'Ankaran'
      },
      {
        code: '195',
        name: 'Apače'
      },
      {
        code: '002',
        name: 'Beltinci'
      },
      {
        code: '148',
        name: 'Benedikt'
      },
      {
        code: '149',
        name: 'Bistrica ob Sotli'
      },
      {
        code: '003',
        name: 'Bled'
      },
      {
        code: '150',
        name: 'Bloke'
      },
      {
        code: '004',
        name: 'Bohinj'
      },
      {
        code: '005',
        name: 'Borovnica'
      },
      {
        code: '006',
        name: 'Bovec'
      },
      {
        code: '151',
        name: 'Braslovče'
      },
      {
        code: '007',
        name: 'Brda'
      },
      {
        code: '008',
        name: 'Brezovica'
      },
      {
        code: '009',
        name: 'Brežice'
      },
      {
        code: '152',
        name: 'Cankova'
      },
      {
        code: '011',
        name: 'Celje'
      },
      {
        code: '012',
        name: 'Cerklje na Gorenjskem'
      },
      {
        code: '013',
        name: 'Cerknica'
      },
      {
        code: '014',
        name: 'Cerkno'
      },
      {
        code: '153',
        name: 'Cerkvenjak'
      },
      {
        code: '196',
        name: 'Cirkulane'
      },
      {
        code: '015',
        name: 'Črenšovci'
      },
      {
        code: '016',
        name: 'Črna na Koroškem'
      },
      {
        code: '017',
        name: 'Črnomelj'
      },
      {
        code: '018',
        name: 'Destrnik'
      },
      {
        code: '019',
        name: 'Divača'
      },
      {
        code: '154',
        name: 'Dobje'
      },
      {
        code: '020',
        name: 'Dobrepolje'
      },
      {
        code: '155',
        name: 'Dobrna'
      },
      {
        code: '021',
        name: 'Dobrova-Polhov Gradec'
      },
      {
        code: '156',
        name: 'Dobrovnik'
      },
      {
        code: '022',
        name: 'Dol pri Ljubljani'
      },
      {
        code: '157',
        name: 'Dolenjske Toplice'
      },
      {
        code: '023',
        name: 'Domžale'
      },
      {
        code: '024',
        name: 'Dornava'
      },
      {
        code: '025',
        name: 'Dravograd'
      },
      {
        code: '026',
        name: 'Duplek'
      },
      {
        code: '027',
        name: 'Gorenja vas-Poljane'
      },
      {
        code: '028',
        name: 'Gorišnica'
      },
      {
        code: '207',
        name: 'Gorje'
      },
      {
        code: '029',
        name: 'Gornja Radgona'
      },
      {
        code: '030',
        name: 'Gornji Grad'
      },
      {
        code: '031',
        name: 'Gornji Petrovci'
      },
      {
        code: '158',
        name: 'Grad'
      },
      {
        code: '032',
        name: 'Grosuplje'
      },
      {
        code: '159',
        name: 'Hajdina'
      },
      {
        code: '160',
        name: 'Hoče-Slivnica'
      },
      {
        code: '161',
        name: 'Hodoš'
      },
      {
        code: '162',
        name: 'Horjul'
      },
      {
        code: '034',
        name: 'Hrastnik'
      },
      {
        code: '035',
        name: 'Hrpelje-Kozina'
      },
      {
        code: '036',
        name: 'Idrija'
      },
      {
        code: '037',
        name: 'Ig'
      },
      {
        code: '038',
        name: 'Ilirska Bistrica'
      },
      {
        code: '039',
        name: 'Ivančna Gorica'
      },
      {
        code: '040',
        name: 'Izola'
      },
      {
        code: '041',
        name: 'Jesenice'
      },
      {
        code: '163',
        name: 'Jezersko'
      },
      {
        code: '042',
        name: 'Juršinci'
      },
      {
        code: '043',
        name: 'Kamnik'
      },
      {
        code: '044',
        name: 'Kanal ob Soči'
      },
      {
        code: '045',
        name: 'Kidričevo'
      },
      {
        code: '046',
        name: 'Kobarid'
      },
      {
        code: '047',
        name: 'Kobilje'
      },
      {
        code: '048',
        name: 'Kočevje'
      },
      {
        code: '049',
        name: 'Komen'
      },
      {
        code: '164',
        name: 'Komenda'
      },
      {
        code: '050',
        name: 'Koper'
      },
      {
        code: '197',
        name: 'Kostanjevica na Krki'
      },
      {
        code: '165',
        name: 'Kostel'
      },
      {
        code: '051',
        name: 'Kozje'
      },
      {
        code: '052',
        name: 'Kranj'
      },
      {
        code: '053',
        name: 'Kranjska Gora'
      },
      {
        code: '166',
        name: 'Križevci'
      },
      {
        code: '054',
        name: 'Krško'
      },
      {
        code: '055',
        name: 'Kungota'
      },
      {
        code: '056',
        name: 'Kuzma'
      },
      {
        code: '057',
        name: 'Laško'
      },
      {
        code: '058',
        name: 'Lenart'
      },
      {
        code: '059',
        name: 'Lendava'
      },
      {
        code: '060',
        name: 'Litija'
      },
      {
        code: '061',
        name: 'Ljubljana'
      },
      {
        code: '062',
        name: 'Ljubno'
      },
      {
        code: '063',
        name: 'Ljutomer'
      },
      {
        code: '208',
        name: 'Log-Dragomer'
      },
      {
        code: '064',
        name: 'Logatec'
      },
      {
        code: '065',
        name: 'Loška dolina'
      },
      {
        code: '066',
        name: 'Loški Potok'
      },
      {
        code: '167',
        name: 'Lovrenc na Pohorju'
      },
      {
        code: '067',
        name: 'Luče'
      },
      {
        code: '068',
        name: 'Lukovica'
      },
      {
        code: '069',
        name: 'Majšperk'
      },
      {
        code: '198',
        name: 'Makole'
      },
      {
        code: '070',
        name: 'Maribor'
      },
      {
        code: '168',
        name: 'Markovci'
      },
      {
        code: '071',
        name: 'Medvode'
      },
      {
        code: '072',
        name: 'Mengeš'
      },
      {
        code: '073',
        name: 'Metlika'
      },
      {
        code: '074',
        name: 'Mežica'
      },
      {
        code: '169',
        name: 'Miklavž na Dravskem polju'
      },
      {
        code: '075',
        name: 'Miren-Kostanjevica'
      },
      {
        code: '212',
        name: 'Mirna'
      },
      {
        code: '170',
        name: 'Mirna Peč'
      },
      {
        code: '076',
        name: 'Mislinja'
      },
      {
        code: '199',
        name: 'Mokronog-Trebelno'
      },
      {
        code: '077',
        name: 'Moravče'
      },
      {
        code: '078',
        name: 'Moravske Toplice'
      },
      {
        code: '079',
        name: 'Mozirje'
      },
      {
        code: '080',
        name: 'Murska Sobota'
      },
      {
        code: '081',
        name: 'Muta'
      },
      {
        code: '082',
        name: 'Naklo'
      },
      {
        code: '083',
        name: 'Nazarje'
      },
      {
        code: '084',
        name: 'Nova Gorica'
      },
      {
        code: '085',
        name: 'Novo Mesto'
      },
      {
        code: '086',
        name: 'Odranci'
      },
      {
        code: '171',
        name: 'Oplotnica'
      },
      {
        code: '087',
        name: 'Ormož'
      },
      {
        code: '088',
        name: 'Osilnica'
      },
      {
        code: '089',
        name: 'Pesnica'
      },
      {
        code: '090',
        name: 'Piran'
      },
      {
        code: '091',
        name: 'Pivka'
      },
      {
        code: '092',
        name: 'Podčetrtek'
      },
      {
        code: '172',
        name: 'Podlehnik'
      },
      {
        code: '093',
        name: 'Podvelka'
      },
      {
        code: '200',
        name: 'Poljčane'
      },
      {
        code: '173',
        name: 'Polzela'
      },
      {
        code: '094',
        name: 'Postojna'
      },
      {
        code: '174',
        name: 'Prebold'
      },
      {
        code: '095',
        name: 'Preddvor'
      },
      {
        code: '175',
        name: 'Prevalje'
      },
      {
        code: '096',
        name: 'Ptuj'
      },
      {
        code: '097',
        name: 'Puconci'
      },
      {
        code: '098',
        name: 'Rače-Fram'
      },
      {
        code: '099',
        name: 'Radeče'
      },
      {
        code: '100',
        name: 'Radenci'
      },
      {
        code: '101',
        name: 'Radlje ob Dravi'
      },
      {
        code: '102',
        name: 'Radovljica'
      },
      {
        code: '103',
        name: 'Ravne na Koroškem'
      },
      {
        code: '176',
        name: 'Razkrižje'
      },
      {
        code: '209',
        name: 'Rečica ob Savinji'
      },
      {
        code: '201',
        name: 'Renče-Vogrsko'
      },
      {
        code: '104',
        name: 'Ribnica'
      },
      {
        code: '177',
        name: 'Ribnica na Pohorju'
      },
      {
        code: '106',
        name: 'Rogaška Slatina'
      },
      {
        code: '105',
        name: 'Rogašovci'
      },
      {
        code: '107',
        name: 'Rogatec'
      },
      {
        code: '108',
        name: 'Ruše'
      },
      {
        code: '178',
        name: 'Selnica ob Dravi'
      },
      {
        code: '109',
        name: 'Semič'
      },
      {
        code: '110',
        name: 'Sevnica'
      },
      {
        code: '111',
        name: 'Sežana'
      },
      {
        code: '112',
        name: 'Slovenj Gradec'
      },
      {
        code: '113',
        name: 'Slovenska Bistrica'
      },
      {
        code: '114',
        name: 'Slovenske Konjice'
      },
      {
        code: '179',
        name: 'Sodražica'
      },
      {
        code: '180',
        name: 'Solčava'
      },
      {
        code: '202',
        name: 'Središče ob Dravi'
      },
      {
        code: '115',
        name: 'Starše'
      },
      {
        code: '203',
        name: 'Straža'
      },
      {
        code: '181',
        name: 'Sveta Ana'
      },
      {
        code: '204',
        name: 'Sveta Trojica v Slovenskih goricah'
      },
      {
        code: '182',
        name: 'Sveti Andraž v Slovenskih goricah'
      },
      {
        code: '116',
        name: 'Sveti Jurij ob Ščavnici'
      },
      {
        code: '210',
        name: 'Sveti Jurij v Slovenskih goricah'
      },
      {
        code: '205',
        name: 'Sveti Tomaž'
      },
      {
        code: '033',
        name: 'Šalovci'
      },
      {
        code: '183',
        name: 'Šempeter-Vrtojba'
      },
      {
        code: '117',
        name: 'Šenčur'
      },
      {
        code: '118',
        name: 'Šentilj'
      },
      {
        code: '119',
        name: 'Šentjernej'
      },
      {
        code: '120',
        name: 'Šentjur'
      },
      {
        code: '211',
        name: 'Šentrupert'
      },
      {
        code: '121',
        name: 'Škocjan'
      },
      {
        code: '122',
        name: 'Škofja Loka'
      },
      {
        code: '123',
        name: 'Škofljica'
      },
      {
        code: '124',
        name: 'Šmarje pri Jelšah'
      },
      {
        code: '206',
        name: 'Šmarješke Toplice'
      },
      {
        code: '125',
        name: 'Šmartno ob Paki'
      },
      {
        code: '194',
        name: 'Šmartno pri Litiji'
      },
      {
        code: '126',
        name: 'Šoštanj'
      },
      {
        code: '127',
        name: 'Štore'
      },
      {
        code: '184',
        name: 'Tabor'
      },
      {
        code: '010',
        name: 'Tišina'
      },
      {
        code: '128',
        name: 'Tolmin'
      },
      {
        code: '129',
        name: 'Trbovlje'
      },
      {
        code: '130',
        name: 'Trebnje'
      },
      {
        code: '185',
        name: 'Trnovska Vas'
      },
      {
        code: '186',
        name: 'Trzin'
      },
      {
        code: '131',
        name: 'Tržič'
      },
      {
        code: '132',
        name: 'Turnišče'
      },
      {
        code: '133',
        name: 'Velenje'
      },
      {
        code: '187',
        name: 'Velika Polana'
      },
      {
        code: '134',
        name: 'Velike Lašče'
      },
      {
        code: '188',
        name: 'Veržej'
      },
      {
        code: '135',
        name: 'Videm'
      },
      {
        code: '136',
        name: 'Vipava'
      },
      {
        code: '137',
        name: 'Vitanje'
      },
      {
        code: '138',
        name: 'Vodice'
      },
      {
        code: '139',
        name: 'Vojnik'
      },
      {
        code: '189',
        name: 'Vransko'
      },
      {
        code: '140',
        name: 'Vrhnika'
      },
      {
        code: '141',
        name: 'Vuzenica'
      },
      {
        code: '142',
        name: 'Zagorje ob Savi'
      },
      {
        code: '143',
        name: 'Zavrč'
      },
      {
        code: '144',
        name: 'Zreče'
      },
      {
        code: '190',
        name: 'Žalec'
      },
      {
        code: '146',
        name: 'Železniki'
      },
      {
        code: '191',
        name: 'Žetale'
      },
      {
        code: '147',
        name: 'Žiri'
      },
      {
        code: '192',
        name: 'Žirovnica'
      },
      {
        code: '193',
        name: 'Žužemberk'
      }
    ]
  },
  {
    code: 'SK',
    name: 'Slovakia',
    code2: 'SK',
    code3: 'SVK',
    capital: 'Bratislava',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: 'BC',
        name: 'Banska Bystrica'
      },
      {
        code: 'BL',
        name: 'Bratislava'
      },
      {
        code: 'KI',
        name: 'Kosice'
      },
      {
        code: 'NI',
        name: 'Nitra'
      },
      {
        code: 'PV',
        name: 'Presov'
      },
      {
        code: 'TC',
        name: 'Trencin'
      },
      {
        code: 'TA',
        name: 'Trnava'
      },
      {
        code: 'ZI',
        name: 'Zilina'
      }
    ]
  },
  {
    code: 'SM',
    name: 'San Marino',
    code2: 'SM',
    code3: 'SMR',
    capital: 'City of San Marino',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: '01',
        name: 'Acquaviva'
      },
      {
        code: '02',
        name: 'Chiesanuova'
      },
      {
        code: '03',
        name: 'Domagnano'
      },
      {
        code: '04',
        name: 'Faetano'
      },
      {
        code: '05',
        name: 'Fiorentino'
      },
      {
        code: '06',
        name: 'Borgo Maggiore'
      },
      {
        code: '07',
        name: 'San Marino'
      },
      {
        code: '08',
        name: 'Montegiardino'
      },
      {
        code: '09',
        name: 'Serravalle'
      }
    ]
  },
  {
    code: 'SN',
    name: 'Senegal',
    code2: 'SN',
    code3: 'SEN',
    capital: 'Dakar',
    region: 'Africa',
    subregion: 'Western Africa',
    states: [
      {
        code: 'DB',
        name: 'Diourbel'
      },
      {
        code: 'DK',
        name: 'Dakar'
      },
      {
        code: 'FK',
        name: 'Fatick'
      },
      {
        code: 'KA',
        name: 'Kaffrine'
      },
      {
        code: 'KD',
        name: 'Kolda'
      },
      {
        code: 'KE',
        name: 'Kedougou'
      },
      {
        code: 'KL',
        name: 'Kaolack'
      },
      {
        code: 'LG',
        name: 'Louga'
      },
      {
        code: 'MT',
        name: 'Matam'
      },
      {
        code: 'SE',
        name: 'Sedhiou'
      },
      {
        code: 'SL',
        name: 'Saint-Louis'
      },
      {
        code: 'TC',
        name: 'Tambacounda'
      },
      {
        code: 'TH',
        name: 'Thies'
      },
      {
        code: 'ZG',
        name: 'Ziguinchor'
      }
    ]
  },
  {
    code: 'SR',
    name: 'Suriname',
    code2: 'SR',
    code3: 'SUR',
    capital: 'Paramaribo',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'BR',
        name: 'Brokopondo'
      },
      {
        code: 'CM',
        name: 'Commewijne'
      },
      {
        code: 'CR',
        name: 'Coronie'
      },
      {
        code: 'MA',
        name: 'Marowijne'
      },
      {
        code: 'NI',
        name: 'Nickerie'
      },
      {
        code: 'PR',
        name: 'Para'
      },
      {
        code: 'PM',
        name: 'Paramaribo'
      },
      {
        code: 'SA',
        name: 'Saramacca'
      },
      {
        code: 'SI',
        name: 'Sipaliwini'
      },
      {
        code: 'WA',
        name: 'Wanica'
      }
    ]
  },
  {
    code: 'SV',
    name: 'El Salvador',
    code2: 'SV',
    code3: 'SLV',
    capital: 'San Salvador',
    region: 'Americas',
    subregion: 'Central America',
    states: [
      {
        code: 'AH',
        name: 'Ahuachapan'
      },
      {
        code: 'CA',
        name: 'Cabanas'
      },
      {
        code: 'CH',
        name: 'Chalatenango'
      },
      {
        code: 'CU',
        name: 'Cuscatlan'
      },
      {
        code: 'LI',
        name: 'La Libertad'
      },
      {
        code: 'MO',
        name: 'Morazan'
      },
      {
        code: 'PA',
        name: 'La Paz'
      },
      {
        code: 'SA',
        name: 'Santa Ana'
      },
      {
        code: 'SM',
        name: 'San Miguel'
      },
      {
        code: 'SO',
        name: 'Sonsonate'
      },
      {
        code: 'SS',
        name: 'San Salvador'
      },
      {
        code: 'SV',
        name: 'San Vicente'
      },
      {
        code: 'UN',
        name: 'La Union'
      },
      {
        code: 'US',
        name: 'Usulutan'
      }
    ]
  },
  {
    code: 'TC',
    name: 'Turks and Caicos',
    code2: 'TC',
    code3: 'TCA',
    capital: 'Cockburn Town',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'TC',
        name: 'Turks and Caicos'
      }
    ]
  },
  {
    code: 'TH',
    name: 'Thailand',
    code2: 'TH',
    code3: 'THA',
    capital: 'Bangkok',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: '37',
        name: 'Amnat Charoen'
      },
      {
        code: '15',
        name: 'Ang Thong'
      },
      {
        code: '38',
        name: 'Bueng Kan'
      },
      {
        code: '31',
        name: 'Buri Ram'
      },
      {
        code: '24',
        name: 'Chachoengsao'
      },
      {
        code: '18',
        name: 'Chai Nat'
      },
      {
        code: '36',
        name: 'Chaiyaphum'
      },
      {
        code: '22',
        name: 'Chanthaburi'
      },
      {
        code: '50',
        name: 'Chiang Mai'
      },
      {
        code: '57',
        name: 'Chiang Rai'
      },
      {
        code: '20',
        name: 'Chon Buri'
      },
      {
        code: '86',
        name: 'Chumphon'
      },
      {
        code: '46',
        name: 'Kalasin'
      },
      {
        code: '62',
        name: 'Kamphaeng Phet'
      },
      {
        code: '71',
        name: 'Kanchanaburi'
      },
      {
        code: '40',
        name: 'Khon Kaen'
      },
      {
        code: '81',
        name: 'Krabi'
      },
      {
        code: '10',
        name: 'Krung Thep Maha Nakhon'
      },
      {
        code: '52',
        name: 'Lampang'
      },
      {
        code: '51',
        name: 'Lamphun'
      },
      {
        code: '42',
        name: 'Loei'
      },
      {
        code: '16',
        name: 'Lop Buri'
      },
      {
        code: '58',
        name: 'Mae Hong Son'
      },
      {
        code: '44',
        name: 'Maha Sarakham'
      },
      {
        code: '49',
        name: 'Mukdahan'
      },
      {
        code: '26',
        name: 'Nakhon Nayok'
      },
      {
        code: '73',
        name: 'Nakhon Pathom'
      },
      {
        code: '48',
        name: 'Nakhon Phanom'
      },
      {
        code: '30',
        name: 'Nakhon Ratchasima'
      },
      {
        code: '60',
        name: 'Nakhon Sawan'
      },
      {
        code: '80',
        name: 'Nakhon Si Thammarat'
      },
      {
        code: '55',
        name: 'Nan'
      },
      {
        code: '96',
        name: 'Narathiwat'
      },
      {
        code: '39',
        name: 'Nong Bua Lam Phu'
      },
      {
        code: '43',
        name: 'Nong Khai'
      },
      {
        code: '12',
        name: 'Nonthaburi'
      },
      {
        code: '13',
        name: 'Pathum Thani'
      },
      {
        code: '94',
        name: 'Pattani'
      },
      {
        code: '82',
        name: 'Phangnga'
      },
      {
        code: '93',
        name: 'Phatthalung'
      },
      {
        code: 'S',
        name: 'Phatthaya'
      },
      {
        code: '56',
        name: 'Phayao'
      },
      {
        code: '67',
        name: 'Phetchabun'
      },
      {
        code: '76',
        name: 'Phetchaburi'
      },
      {
        code: '66',
        name: 'Phichit'
      },
      {
        code: '65',
        name: 'Phitsanulok'
      },
      {
        code: '14',
        name: 'Phra Nakhon Si Ayutthaya'
      },
      {
        code: '54',
        name: 'Phrae'
      },
      {
        code: '83',
        name: 'Phuket'
      },
      {
        code: '25',
        name: 'Prachin Buri'
      },
      {
        code: '77',
        name: 'Prachuap Khiri Khan'
      },
      {
        code: '85',
        name: 'Ranong'
      },
      {
        code: '70',
        name: 'Ratchaburi'
      },
      {
        code: '21',
        name: 'Rayong'
      },
      {
        code: '45',
        name: 'Roi Et'
      },
      {
        code: '27',
        name: 'Sa Kaeo'
      },
      {
        code: '47',
        name: 'Sakon Nakhon'
      },
      {
        code: '11',
        name: 'Samut Prakan'
      },
      {
        code: '74',
        name: 'Samut Sakhon'
      },
      {
        code: '75',
        name: 'Samut Songkhram'
      },
      {
        code: '19',
        name: 'Saraburi'
      },
      {
        code: '91',
        name: 'Satun'
      },
      {
        code: '33',
        name: 'Si Sa Ket'
      },
      {
        code: '17',
        name: 'Sing Buri'
      },
      {
        code: '90',
        name: 'Songkhla'
      },
      {
        code: '64',
        name: 'Sukhothai'
      },
      {
        code: '72',
        name: 'Suphan Buri'
      },
      {
        code: '84',
        name: 'Surat Thani'
      },
      {
        code: '32',
        name: 'Surin'
      },
      {
        code: '63',
        name: 'Tak'
      },
      {
        code: '92',
        name: 'Trang'
      },
      {
        code: '23',
        name: 'Trat'
      },
      {
        code: '34',
        name: 'Ubon Ratchathani'
      },
      {
        code: '41',
        name: 'Udon Thani'
      },
      {
        code: '61',
        name: 'Uthai Thani'
      },
      {
        code: '53',
        name: 'Uttaradit'
      },
      {
        code: '95',
        name: 'Yala'
      },
      {
        code: '35',
        name: 'Yasothon'
      }
    ]
  },
  {
    code: 'TN',
    name: 'Tunisia',
    code2: 'TN',
    code3: 'TUN',
    capital: 'Tunis',
    region: 'Africa',
    subregion: 'Northern Africa',
    states: [
      {
        code: '11',
        name: 'Tunis'
      },
      {
        code: '12',
        name: "L'Ariana"
      },
      {
        code: '13',
        name: 'Ben Arous'
      },
      {
        code: '14',
        name: 'La Manouba'
      },
      {
        code: '21',
        name: 'Nabeul'
      },
      {
        code: '22',
        name: 'Zaghouan'
      },
      {
        code: '23',
        name: 'Bizerte'
      },
      {
        code: '31',
        name: 'Beja'
      },
      {
        code: '32',
        name: 'Jendouba'
      },
      {
        code: '33',
        name: 'Le Kef'
      },
      {
        code: '34',
        name: 'Siliana'
      },
      {
        code: '41',
        name: 'Kairouan'
      },
      {
        code: '42',
        name: 'Kasserine'
      },
      {
        code: '43',
        name: 'Sidi Bouzid'
      },
      {
        code: '51',
        name: 'Sousse'
      },
      {
        code: '52',
        name: 'Monastir'
      },
      {
        code: '53',
        name: 'Mahdia'
      },
      {
        code: '61',
        name: 'Sfax'
      },
      {
        code: '71',
        name: 'Gafsa'
      },
      {
        code: '72',
        name: 'Tozeur'
      },
      {
        code: '73',
        name: 'Kebili'
      },
      {
        code: '81',
        name: 'Gabes'
      },
      {
        code: '82',
        name: 'Medenine'
      },
      {
        code: '83',
        name: 'Tataouine'
      }
    ]
  },
  {
    code: 'TR',
    name: 'Türkiye',
    code2: 'TR',
    code3: 'TUR',
    capital: 'Ankara',
    region: 'Asia',
    subregion: 'Western Asia',
    states: [
      {
        code: '01',
        name: 'Adana'
      },
      {
        code: '02',
        name: 'Adıyaman'
      },
      {
        code: '03',
        name: 'Afyonkarahisar'
      },
      {
        code: '04',
        name: 'Ağrı'
      },
      {
        code: '68',
        name: 'Aksaray'
      },
      {
        code: '05',
        name: 'Amasya'
      },
      {
        code: '06',
        name: 'Ankara'
      },
      {
        code: '07',
        name: 'Antalya'
      },
      {
        code: '75',
        name: 'Ardahan'
      },
      {
        code: '08',
        name: 'Artvin'
      },
      {
        code: '09',
        name: 'Aydın'
      },
      {
        code: '10',
        name: 'Balıkesir'
      },
      {
        code: '74',
        name: 'Bartın'
      },
      {
        code: '72',
        name: 'Batman'
      },
      {
        code: '69',
        name: 'Bayburt'
      },
      {
        code: '11',
        name: 'Bilecik'
      },
      {
        code: '12',
        name: 'Bingöl'
      },
      {
        code: '13',
        name: 'Bitlis'
      },
      {
        code: '14',
        name: 'Bolu'
      },
      {
        code: '15',
        name: 'Burdur'
      },
      {
        code: '16',
        name: 'Bursa'
      },
      {
        code: '17',
        name: 'Çanakkale'
      },
      {
        code: '18',
        name: 'Çankırı'
      },
      {
        code: '19',
        name: 'Çorum'
      },
      {
        code: '20',
        name: 'Denizli'
      },
      {
        code: '21',
        name: 'Diyarbakır'
      },
      {
        code: '81',
        name: 'Düzce'
      },
      {
        code: '22',
        name: 'Edirne'
      },
      {
        code: '23',
        name: 'Elazığ'
      },
      {
        code: '24',
        name: 'Erzincan'
      },
      {
        code: '25',
        name: 'Erzurum'
      },
      {
        code: '26',
        name: 'Eskişehir'
      },
      {
        code: '27',
        name: 'Gaziantep'
      },
      {
        code: '28',
        name: 'Giresun'
      },
      {
        code: '29',
        name: 'Gümüşhane'
      },
      {
        code: '30',
        name: 'Hakkâri'
      },
      {
        code: '31',
        name: 'Hatay'
      },
      {
        code: '76',
        name: 'Iğdır'
      },
      {
        code: '32',
        name: 'Isparta'
      },
      {
        code: '34',
        name: 'İstanbul'
      },
      {
        code: '35',
        name: 'İzmir'
      },
      {
        code: '46',
        name: 'Kahramanmaraş'
      },
      {
        code: '78',
        name: 'Karabük'
      },
      {
        code: '70',
        name: 'Karaman'
      },
      {
        code: '36',
        name: 'Kars'
      },
      {
        code: '37',
        name: 'Kastamonu'
      },
      {
        code: '38',
        name: 'Kayseri'
      },
      {
        code: '71',
        name: 'Kırıkkale'
      },
      {
        code: '39',
        name: 'Kırklareli'
      },
      {
        code: '40',
        name: 'Kırşehir'
      },
      {
        code: '79',
        name: 'Kilis'
      },
      {
        code: '41',
        name: 'Kocaeli'
      },
      {
        code: '42',
        name: 'Konya'
      },
      {
        code: '43',
        name: 'Kütahya'
      },
      {
        code: '44',
        name: 'Malatya'
      },
      {
        code: '45',
        name: 'Manisa'
      },
      {
        code: '47',
        name: 'Mardin'
      },
      {
        code: '33',
        name: 'Mersin'
      },
      {
        code: '48',
        name: 'Muğla'
      },
      {
        code: '49',
        name: 'Muş'
      },
      {
        code: '50',
        name: 'Nevşehir'
      },
      {
        code: '51',
        name: 'Niğde'
      },
      {
        code: '52',
        name: 'Ordu'
      },
      {
        code: '80',
        name: 'Osmaniye'
      },
      {
        code: '53',
        name: 'Rize'
      },
      {
        code: '54',
        name: 'Sakarya'
      },
      {
        code: '55',
        name: 'Samsun'
      },
      {
        code: '56',
        name: 'Siirt'
      },
      {
        code: '57',
        name: 'Sinop'
      },
      {
        code: '58',
        name: 'Sivas'
      },
      {
        code: '63',
        name: 'Şanlıurfa'
      },
      {
        code: '73',
        name: 'Şırnak'
      },
      {
        code: '59',
        name: 'Tekirdağ'
      },
      {
        code: '60',
        name: 'Tokat'
      },
      {
        code: '61',
        name: 'Trabzon'
      },
      {
        code: '62',
        name: 'Tunceli'
      },
      {
        code: '64',
        name: 'Uşak'
      },
      {
        code: '65',
        name: 'Van'
      },
      {
        code: '77',
        name: 'Yalova'
      },
      {
        code: '66',
        name: 'Yozgat'
      },
      {
        code: '67',
        name: 'Zonguldak'
      }
    ]
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    code2: 'TT',
    code3: 'TTO',
    capital: 'Port of Spain',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'ARI',
        name: 'Arima'
      },
      {
        code: 'CHA',
        name: 'Chaguanas'
      },
      {
        code: 'CTT',
        name: 'Couva-Tabaquite-Talparo'
      },
      {
        code: 'DMN',
        name: 'Diego Martin'
      },
      {
        code: 'MRC',
        name: 'Mayaro-Rio Claro'
      },
      {
        code: 'MED',
        name: 'Penal-Debe'
      },
      {
        code: 'POS',
        name: 'Port of Spain'
      },
      {
        code: 'SFO',
        name: 'San Fernando'
      },
      {
        code: 'SGE',
        name: 'Sangre Grande'
      },
      {
        code: 'SJL',
        name: 'San Juan-Laventille'
      },
      {
        code: 'TOB',
        name: 'Tobago'
      },
      {
        code: 'TUP',
        name: 'Tunapuna-Piarco'
      }
    ]
  },
  {
    code: 'TW',
    name: 'Taiwan',
    code2: 'TW',
    code3: 'TWN',
    capital: 'Taipei',
    region: 'Asia',
    subregion: 'Eastern Asia',
    states: [
      {
        code: 'CHA',
        name: 'Changhua'
      },
      {
        code: 'CYI',
        name: 'Chiayi'
      },
      {
        code: 'CYQ',
        name: 'Chiayi'
      },
      {
        code: 'HSZ',
        name: 'Hsinchu'
      },
      {
        code: 'HSQ',
        name: 'Hsinchu'
      },
      {
        code: 'HUA',
        name: 'Hualien'
      },
      {
        code: 'KHH',
        name: 'Kaohsiung'
      },
      {
        code: 'KEE',
        name: 'Keelung'
      },
      {
        code: 'KIN',
        name: 'Kinmen'
      },
      {
        code: 'LIE',
        name: 'Lienchiang'
      },
      {
        code: 'MIA',
        name: 'Miaoli'
      },
      {
        code: 'NAN',
        name: 'Nantou'
      },
      {
        code: 'NWT',
        name: 'New Taipei'
      },
      {
        code: 'PEN',
        name: 'Penghu'
      },
      {
        code: 'PIF',
        name: 'Pingtung'
      },
      {
        code: 'TXG',
        name: 'Taichung'
      },
      {
        code: 'TNN',
        name: 'Tainan'
      },
      {
        code: 'TPE',
        name: 'Taipei'
      },
      {
        code: 'TTT',
        name: 'Taitung'
      },
      {
        code: 'TAO',
        name: 'Taoyuan'
      },
      {
        code: 'ILA',
        name: 'Yilan'
      },
      {
        code: 'YUN',
        name: 'Yunlin'
      }
    ]
  },
  {
    code: 'UA',
    name: 'Ukraine',
    code2: 'UA',
    code3: 'UKR',
    capital: 'Kiev',
    region: 'Europe',
    subregion: 'Eastern Europe',
    states: [
      {
        code: '05',
        name: 'Vinnytsia'
      },
      {
        code: '07',
        name: 'Volyn'
      },
      {
        code: '09',
        name: 'Luhansk'
      },
      {
        code: '12',
        name: 'Dnipropetrovsk'
      },
      {
        code: '14',
        name: 'Donetsk'
      },
      {
        code: '18',
        name: 'Zhytomyr'
      },
      {
        code: '21',
        name: 'Transcarpathia'
      },
      {
        code: '23',
        name: 'Zaporizhzhia'
      },
      {
        code: '26',
        name: 'Ivano-Frankivsk'
      },
      {
        code: '30',
        name: 'Kyiv City'
      },
      {
        code: '32',
        name: 'Kyiv'
      },
      {
        code: '35',
        name: 'Kirovohrad'
      },
      {
        code: '40',
        name: 'Sevastopol'
      },
      {
        code: '43',
        name: 'Crimea'
      },
      {
        code: '46',
        name: 'Lviv'
      },
      {
        code: '48',
        name: 'Mykolaiv'
      },
      {
        code: '51',
        name: 'Odesa'
      },
      {
        code: '53',
        name: 'Poltava'
      },
      {
        code: '56',
        name: 'Rivne'
      },
      {
        code: '59',
        name: 'Sumy'
      },
      {
        code: '61',
        name: 'Ternopil'
      },
      {
        code: '63',
        name: 'Kharkiv'
      },
      {
        code: '65',
        name: 'Kherson'
      },
      {
        code: '68',
        name: 'Khmelnytskyi'
      },
      {
        code: '71',
        name: 'Cherkasy'
      },
      {
        code: '74',
        name: 'Chernihiv'
      },
      {
        code: '77',
        name: 'Chernivtsi'
      }
    ]
  },
  {
    code: 'UG',
    name: 'Uganda',
    code2: 'UG',
    code3: 'UGA',
    capital: 'Kampala',
    region: 'Africa',
    subregion: 'Eastern Africa',
    states: [
      {
        code: '101',
        name: 'Kalangala'
      },
      {
        code: '102',
        name: 'Kampala'
      },
      {
        code: '103',
        name: 'Kiboga'
      },
      {
        code: '104',
        name: 'Luwero'
      },
      {
        code: '105',
        name: 'Masaka'
      },
      {
        code: '106',
        name: 'Mpigi'
      },
      {
        code: '107',
        name: 'Mubende'
      },
      {
        code: '108',
        name: 'Mukono'
      },
      {
        code: '109',
        name: 'Nakasongola'
      },
      {
        code: '110',
        name: 'Rakai'
      },
      {
        code: '111',
        name: 'Sembabule'
      },
      {
        code: '112',
        name: 'Kayunga'
      },
      {
        code: '113',
        name: 'Wakiso'
      },
      {
        code: '114',
        name: 'Lyantonde'
      },
      {
        code: '115',
        name: 'Mityana'
      },
      {
        code: '116',
        name: 'Nakaseke'
      },
      {
        code: '117',
        name: 'Buikwe'
      },
      {
        code: '118',
        name: 'Bukomansibi'
      },
      {
        code: '119',
        name: 'Butambala'
      },
      {
        code: '120',
        name: 'Buvuma'
      },
      {
        code: '121',
        name: 'Gomba'
      },
      {
        code: '122',
        name: 'Kalungu'
      },
      {
        code: '123',
        name: 'Kyankwanzi'
      },
      {
        code: '124',
        name: 'Lwengo'
      },
      {
        code: '125',
        name: 'Kyotera'
      },
      {
        code: '126',
        name: 'Kasanda'
      },
      {
        code: '201',
        name: 'Bugiri'
      },
      {
        code: '202',
        name: 'Busia'
      },
      {
        code: '203',
        name: 'Iganga'
      },
      {
        code: '204',
        name: 'Jinja'
      },
      {
        code: '205',
        name: 'Kamuli'
      },
      {
        code: '206',
        name: 'Kapchorwa'
      },
      {
        code: '207',
        name: 'Katakwi'
      },
      {
        code: '208',
        name: 'Kumi'
      },
      {
        code: '209',
        name: 'Mbale'
      },
      {
        code: '210',
        name: 'Pallisa'
      },
      {
        code: '211',
        name: 'Soroti'
      },
      {
        code: '212',
        name: 'Tororo'
      },
      {
        code: '213',
        name: 'Kaberamaido'
      },
      {
        code: '214',
        name: 'Mayuge'
      },
      {
        code: '215',
        name: 'Sironko'
      },
      {
        code: '216',
        name: 'Amuria'
      },
      {
        code: '217',
        name: 'Budaka'
      },
      {
        code: '218',
        name: 'Bududa'
      },
      {
        code: '219',
        name: 'Bukedea'
      },
      {
        code: '220',
        name: 'Bukwo'
      },
      {
        code: '221',
        name: 'Butaleja'
      },
      {
        code: '222',
        name: 'Kaliro'
      },
      {
        code: '223',
        name: 'Manafwa'
      },
      {
        code: '224',
        name: 'Namutumba'
      },
      {
        code: '225',
        name: 'Bulambuli'
      },
      {
        code: '226',
        name: 'Buyende'
      },
      {
        code: '227',
        name: 'Kibuku'
      },
      {
        code: '228',
        name: 'Kween'
      },
      {
        code: '229',
        name: 'Luuka'
      },
      {
        code: '230',
        name: 'Namayingo'
      },
      {
        code: '231',
        name: 'Ngora'
      },
      {
        code: '232',
        name: 'Serere'
      },
      {
        code: '233',
        name: 'Butebo'
      },
      {
        code: '234',
        name: 'Namisindwa'
      },
      {
        code: '235',
        name: 'Bugweri'
      },
      {
        code: '236',
        name: 'Kapelebyong'
      },
      {
        code: '237',
        name: 'Kalaki'
      },
      {
        code: '301',
        name: 'Adjumani'
      },
      {
        code: '302',
        name: 'Apac'
      },
      {
        code: '303',
        name: 'Arua'
      },
      {
        code: '304',
        name: 'Gulu'
      },
      {
        code: '305',
        name: 'Kitgum'
      },
      {
        code: '306',
        name: 'Kotido'
      },
      {
        code: '307',
        name: 'Lira'
      },
      {
        code: '308',
        name: 'Moroto'
      },
      {
        code: '309',
        name: 'Moyo'
      },
      {
        code: '310',
        name: 'Nebbi'
      },
      {
        code: '311',
        name: 'Nakapiripirit'
      },
      {
        code: '312',
        name: 'Pader'
      },
      {
        code: '313',
        name: 'Yumbe'
      },
      {
        code: '314',
        name: 'Abim'
      },
      {
        code: '315',
        name: 'Amolatar'
      },
      {
        code: '316',
        name: 'Amuru'
      },
      {
        code: '317',
        name: 'Dokolo'
      },
      {
        code: '318',
        name: 'Kaabong'
      },
      {
        code: '319',
        name: 'Koboko'
      },
      {
        code: '320',
        name: 'Maracha'
      },
      {
        code: '321',
        name: 'Oyam'
      },
      {
        code: '322',
        name: 'Agago'
      },
      {
        code: '323',
        name: 'Alebtong'
      },
      {
        code: '324',
        name: 'Amudat'
      },
      {
        code: '325',
        name: 'Kole'
      },
      {
        code: '326',
        name: 'Lamwo'
      },
      {
        code: '327',
        name: 'Napak'
      },
      {
        code: '328',
        name: 'Nwoya'
      },
      {
        code: '329',
        name: 'Otuke'
      },
      {
        code: '330',
        name: 'Zombo'
      },
      {
        code: '331',
        name: 'Omoro'
      },
      {
        code: '332',
        name: 'Pakwach'
      },
      {
        code: '333',
        name: 'Kwania'
      },
      {
        code: '334',
        name: 'Nabilatuk'
      },
      {
        code: '335',
        name: 'Karenga'
      },
      {
        code: '336',
        name: 'Madi-Okollo'
      },
      {
        code: '337',
        name: 'Obongi'
      },
      {
        code: '401',
        name: 'Bundibugyo'
      },
      {
        code: '402',
        name: 'Bushenyi'
      },
      {
        code: '403',
        name: 'Hoima'
      },
      {
        code: '404',
        name: 'Kabale'
      },
      {
        code: '405',
        name: 'Kabarole'
      },
      {
        code: '406',
        name: 'Kasese'
      },
      {
        code: '407',
        name: 'Kibaale'
      },
      {
        code: '408',
        name: 'Kisoro'
      },
      {
        code: '409',
        name: 'Masindi'
      },
      {
        code: '410',
        name: 'Mbarara'
      },
      {
        code: '411',
        name: 'Ntungamo'
      },
      {
        code: '412',
        name: 'Rukungiri'
      },
      {
        code: '413',
        name: 'Kamwenge'
      },
      {
        code: '414',
        name: 'Kanungu'
      },
      {
        code: '415',
        name: 'Kyenjojo'
      },
      {
        code: '416',
        name: 'Buliisa'
      },
      {
        code: '417',
        name: 'Ibanda'
      },
      {
        code: '418',
        name: 'Isingiro'
      },
      {
        code: '419',
        name: 'Kiruhura'
      },
      {
        code: '420',
        name: 'Buhweju'
      },
      {
        code: '421',
        name: 'Kiryandongo'
      },
      {
        code: '422',
        name: 'Kyegegwa'
      },
      {
        code: '423',
        name: 'Mitooma'
      },
      {
        code: '424',
        name: 'Ntoroko'
      },
      {
        code: '425',
        name: 'Rubirizi'
      },
      {
        code: '426',
        name: 'Sheema'
      },
      {
        code: '427',
        name: 'Kagadi'
      },
      {
        code: '428',
        name: 'Kakumiro'
      },
      {
        code: '429',
        name: 'Rubanda'
      },
      {
        code: '430',
        name: 'Bunyangabu'
      },
      {
        code: '431',
        name: 'Rukiga'
      },
      {
        code: '432',
        name: 'Kikuube'
      },
      {
        code: '433',
        name: 'Kazo'
      },
      {
        code: '434',
        name: 'Kitagwenda'
      },
      {
        code: '435',
        name: 'Rwampara'
      }
    ]
  },
  {
    code: 'US',
    name: 'United States',
    code2: 'US',
    code3: 'USA',
    capital: 'Washington, D.C.',
    region: 'Americas',
    subregion: 'Northern America',
    states: [
      {
        code: 'AL',
        name: 'Alabama'
      },
      {
        code: 'AK',
        name: 'Alaska'
      },
      {
        code: 'AZ',
        name: 'Arizona'
      },
      {
        code: 'AR',
        name: 'Arkansas'
      },
      {
        code: 'CA',
        name: 'California'
      },
      {
        code: 'CO',
        name: 'Colorado'
      },
      {
        code: 'CT',
        name: 'Connecticut'
      },
      {
        code: 'DE',
        name: 'Delaware'
      },
      {
        code: 'FL',
        name: 'Florida'
      },
      {
        code: 'GA',
        name: 'Georgia'
      },
      {
        code: 'HI',
        name: 'Hawaii'
      },
      {
        code: 'ID',
        name: 'Idaho'
      },
      {
        code: 'IL',
        name: 'Illinois'
      },
      {
        code: 'IN',
        name: 'Indiana'
      },
      {
        code: 'IA',
        name: 'Iowa'
      },
      {
        code: 'KS',
        name: 'Kansas'
      },
      {
        code: 'KY',
        name: 'Kentucky'
      },
      {
        code: 'LA',
        name: 'Louisiana'
      },
      {
        code: 'ME',
        name: 'Maine'
      },
      {
        code: 'MD',
        name: 'Maryland'
      },
      {
        code: 'MA',
        name: 'Massachusetts'
      },
      {
        code: 'MI',
        name: 'Michigan'
      },
      {
        code: 'MN',
        name: 'Minnesota'
      },
      {
        code: 'MS',
        name: 'Mississippi'
      },
      {
        code: 'MO',
        name: 'Missouri'
      },
      {
        code: 'MT',
        name: 'Montana'
      },
      {
        code: 'NE',
        name: 'Nebraska'
      },
      {
        code: 'NV',
        name: 'Nevada'
      },
      {
        code: 'NH',
        name: 'New Hampshire'
      },
      {
        code: 'NJ',
        name: 'New Jersey'
      },
      {
        code: 'NM',
        name: 'New Mexico'
      },
      {
        code: 'NY',
        name: 'New York'
      },
      {
        code: 'NC',
        name: 'North Carolina'
      },
      {
        code: 'ND',
        name: 'North Dakota'
      },
      {
        code: 'OH',
        name: 'Ohio'
      },
      {
        code: 'OK',
        name: 'Oklahoma'
      },
      {
        code: 'OR',
        name: 'Oregon'
      },
      {
        code: 'PA',
        name: 'Pennsylvania'
      },
      {
        code: 'RI',
        name: 'Rhode Island'
      },
      {
        code: 'SC',
        name: 'South Carolina'
      },
      {
        code: 'SD',
        name: 'South Dakota'
      },
      {
        code: 'TN',
        name: 'Tennessee'
      },
      {
        code: 'TX',
        name: 'Texas'
      },
      {
        code: 'UT',
        name: 'Utah'
      },
      {
        code: 'VT',
        name: 'Vermont'
      },
      {
        code: 'VA',
        name: 'Virginia'
      },
      {
        code: 'WA',
        name: 'Washington'
      },
      {
        code: 'WV',
        name: 'West Virginia'
      },
      {
        code: 'WI',
        name: 'Wisconsin'
      },
      {
        code: 'WY',
        name: 'Wyoming'
      },
      {
        code: 'DC',
        name: 'District of Columbia'
      }
    ]
  },
  {
    code: 'UY',
    name: 'Uruguay',
    code2: 'UY',
    code3: 'URY',
    capital: 'Montevideo',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'AR',
        name: 'Artigas'
      },
      {
        code: 'CA',
        name: 'Canelones'
      },
      {
        code: 'CL',
        name: 'Cerro Largo'
      },
      {
        code: 'CO',
        name: 'Colonia'
      },
      {
        code: 'DU',
        name: 'Durazno'
      },
      {
        code: 'FD',
        name: 'Florida'
      },
      {
        code: 'FS',
        name: 'Flores'
      },
      {
        code: 'LA',
        name: 'Lavalleja'
      },
      {
        code: 'MA',
        name: 'Maldonado'
      },
      {
        code: 'MO',
        name: 'Montevideo'
      },
      {
        code: 'PA',
        name: 'Paysandu'
      },
      {
        code: 'RN',
        name: 'Rio Negro'
      },
      {
        code: 'RO',
        name: 'Rocha'
      },
      {
        code: 'RV',
        name: 'Rivera'
      },
      {
        code: 'SA',
        name: 'Salto'
      },
      {
        code: 'SJ',
        name: 'San Jose'
      },
      {
        code: 'SO',
        name: 'Soriano'
      },
      {
        code: 'TA',
        name: 'Tacuarembo'
      },
      {
        code: 'TT',
        name: 'Treinta y Tres'
      }
    ]
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    code2: 'UZ',
    code3: 'UZB',
    capital: 'Tashkent',
    region: 'Asia',
    subregion: 'Central Asia',
    states: [
      {
        code: 'AN',
        name: 'Andijan'
      },
      {
        code: 'BU',
        name: 'Bukhara'
      },
      {
        code: 'FA',
        name: 'Fergana'
      },
      {
        code: 'JI',
        name: 'Jizzakh'
      },
      {
        code: 'NG',
        name: 'Namangan'
      },
      {
        code: 'NW',
        name: 'Navoiy'
      },
      {
        code: 'QA',
        name: 'Qashqadaryo'
      },
      {
        code: 'QR',
        name: 'Karakalpakstan'
      },
      {
        code: 'SA',
        name: 'Samarqand'
      },
      {
        code: 'SI',
        name: 'Sirdaryo'
      },
      {
        code: 'SU',
        name: 'Surkhondaryo'
      },
      {
        code: 'TK',
        name: 'Tashkent City'
      },
      {
        code: 'TO',
        name: 'Tashkent'
      },
      {
        code: 'XO',
        name: 'Khorezm'
      }
    ]
  },
  {
    code: 'VA',
    name: 'Vatican City',
    code2: 'VA',
    code3: 'VAT',
    capital: 'Rome',
    region: 'Europe',
    subregion: 'Southern Europe',
    states: [
      {
        code: 'VA',
        name: 'Vatican City'
      }
    ]
  },
  {
    code: 'VE',
    name: 'Venezuela',
    code2: 'VE',
    code3: 'VEN',
    capital: 'Caracas',
    region: 'Americas',
    subregion: 'South America',
    states: [
      {
        code: 'A',
        name: 'Caracas'
      },
      {
        code: 'B',
        name: 'Anzoategui'
      },
      {
        code: 'C',
        name: 'Apure'
      },
      {
        code: 'D',
        name: 'Aragua'
      },
      {
        code: 'E',
        name: 'Barinas'
      },
      {
        code: 'F',
        name: 'Bolivar'
      },
      {
        code: 'G',
        name: 'Carabobo'
      },
      {
        code: 'H',
        name: 'Cojedes'
      },
      {
        code: 'I',
        name: 'Falcon'
      },
      {
        code: 'J',
        name: 'Guarico'
      },
      {
        code: 'K',
        name: 'Lara'
      },
      {
        code: 'L',
        name: 'Merida'
      },
      {
        code: 'M',
        name: 'Miranda'
      },
      {
        code: 'N',
        name: 'Monagas'
      },
      {
        code: 'O',
        name: 'New Sparta'
      },
      {
        code: 'P',
        name: 'Portuguesa'
      },
      {
        code: 'R',
        name: 'Sucre'
      },
      {
        code: 'S',
        name: 'Tachira'
      },
      {
        code: 'T',
        name: 'Trujillo'
      },
      {
        code: 'U',
        name: 'Yaracuy'
      },
      {
        code: 'V',
        name: 'Zulia'
      },
      {
        code: 'W',
        name: 'Federal Dependencies'
      },
      {
        code: 'X',
        name: 'La Guaira'
      },
      {
        code: 'Y',
        name: 'Amacuro Delta'
      },
      {
        code: 'Z',
        name: 'Amazonia'
      }
    ]
  },
  {
    code: 'VG',
    name: 'British Virgin Islands',
    code2: 'VG',
    code3: 'VGB',
    capital: 'Road Town',
    region: 'Americas',
    subregion: 'Caribbean',
    states: [
      {
        code: 'VG',
        name: 'British Virgin Islands'
      }
    ]
  },
  {
    code: 'VN',
    name: 'Vietnam',
    code2: 'VN',
    code3: 'VNM',
    capital: 'Hanoi',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    states: [
      {
        code: '01',
        name: 'Lai Chau'
      },
      {
        code: '02',
        name: 'Lao Cai'
      },
      {
        code: '03',
        name: 'Ha Giang'
      },
      {
        code: '04',
        name: 'Cao Bang'
      },
      {
        code: '05',
        name: 'Son La'
      },
      {
        code: '06',
        name: 'Yen Bai'
      },
      {
        code: '07',
        name: 'Tuyen Quang'
      },
      {
        code: '09',
        name: 'Lang Son'
      },
      {
        code: '13',
        name: 'Quang Ninh'
      },
      {
        code: '14',
        name: 'Haa Binh'
      },
      {
        code: '18',
        name: 'Ninh Binh'
      },
      {
        code: '20',
        name: 'Thai Binh'
      },
      {
        code: '21',
        name: 'Thanh Hoa'
      },
      {
        code: '22',
        name: 'Nghe An'
      },
      {
        code: '23',
        name: 'Ha Tinh'
      },
      {
        code: '24',
        name: 'Quang Binh'
      },
      {
        code: '25',
        name: 'Quang Tri'
      },
      {
        code: '26',
        name: 'Thua Thien-Hue'
      },
      {
        code: '27',
        name: 'Quang Nam'
      },
      {
        code: '28',
        name: 'Kon Tum'
      },
      {
        code: '29',
        name: 'Quang Ngai'
      },
      {
        code: '30',
        name: 'Gia Lai'
      },
      {
        code: '31',
        name: 'Binh Dinh'
      },
      {
        code: '32',
        name: 'Phu Yen'
      },
      {
        code: '33',
        name: 'Dak Lak'
      },
      {
        code: '34',
        name: 'Khanh Hoa'
      },
      {
        code: '35',
        name: 'Lam Dong'
      },
      {
        code: '36',
        name: 'Ninh Thuan'
      },
      {
        code: '37',
        name: 'Tay Ninh'
      },
      {
        code: '39',
        name: 'Dong Nai'
      },
      {
        code: '40',
        name: 'Binh Thuan'
      },
      {
        code: '41',
        name: 'Long An'
      },
      {
        code: '43',
        name: 'Ba Ria - Vung Tau'
      },
      {
        code: '44',
        name: 'An Giang'
      },
      {
        code: '45',
        name: 'Dong Thap'
      },
      {
        code: '46',
        name: 'Tien Giang'
      },
      {
        code: '47',
        name: 'Kien Giang'
      },
      {
        code: '49',
        name: 'Vinh Long'
      },
      {
        code: '50',
        name: 'Ben Tre'
      },
      {
        code: '51',
        name: 'Tra Vinh'
      },
      {
        code: '52',
        name: 'Soc Trang'
      },
      {
        code: '53',
        name: 'Bac Kan'
      },
      {
        code: '54',
        name: 'Bac Giang'
      },
      {
        code: '55',
        name: 'Bac Lieu'
      },
      {
        code: '56',
        name: 'Bac Ninh'
      },
      {
        code: '57',
        name: 'Binh Duong'
      },
      {
        code: '58',
        name: 'Binh Phuoc'
      },
      {
        code: '59',
        name: 'Ca Mau'
      },
      {
        code: '61',
        name: 'Hai Duong'
      },
      {
        code: '63',
        name: 'Ha Nam'
      },
      {
        code: '66',
        name: 'Hung Yen'
      },
      {
        code: '67',
        name: 'Nam Dinh'
      },
      {
        code: '68',
        name: 'Phu Tho'
      },
      {
        code: '69',
        name: 'Thai Nguyen'
      },
      {
        code: '70',
        name: 'Vinh Phuc'
      },
      {
        code: '71',
        name: 'Dien Bien'
      },
      {
        code: '72',
        name: 'Dak Nong'
      },
      {
        code: '73',
        name: 'Hau Giang'
      },
      {
        code: 'CT',
        name: 'Can Tho'
      },
      {
        code: 'DN',
        name: 'Da Nang'
      },
      {
        code: 'HN',
        name: 'Ha Noi'
      },
      {
        code: 'HP',
        name: 'Hai Phong'
      },
      {
        code: 'SG',
        name: 'Ho Chi Minh'
      }
    ]
  },
  {
    code: 'WS',
    name: 'Samoa',
    code2: 'WS',
    code3: 'WSM',
    capital: 'Apia',
    region: 'Oceania',
    subregion: 'Polynesia',
    states: [
      {
        code: 'AA',
        name: "A'ana"
      },
      {
        code: 'AL',
        name: 'Aiga-i-e-Tai'
      },
      {
        code: 'AT',
        name: 'Atua'
      },
      {
        code: 'FA',
        name: "Fa'asaleleaga"
      },
      {
        code: 'GE',
        name: "Gaga'emauga"
      },
      {
        code: 'GI',
        name: 'Gagaifomauga'
      },
      {
        code: 'PA',
        name: 'Palaui'
      },
      {
        code: 'SA',
        name: "Satupa'itea"
      },
      {
        code: 'TU',
        name: 'Tuamasaga'
      },
      {
        code: 'VF',
        name: "Va'a-o-Fonoti"
      },
      {
        code: 'VS',
        name: 'Vaisigano'
      }
    ]
  },
  {
    code: 'ZA',
    name: 'South Africa',
    code2: 'ZA',
    code3: 'ZAF',
    capital: 'Pretoria',
    region: 'Africa',
    subregion: 'Southern Africa',
    states: [
      {
        code: 'EC',
        name: 'Eastern Cape'
      },
      {
        code: 'FS',
        name: 'Free State'
      },
      {
        code: 'GP',
        name: 'Gauteng'
      },
      {
        code: 'KZN',
        name: 'Kwazulu/Natal'
      },
      {
        code: 'LP',
        name: 'Limpopo'
      },
      {
        code: 'MP',
        name: 'Mpumalanga'
      },
      {
        code: 'NW',
        name: 'North-West'
      },
      {
        code: 'NC',
        name: 'Northern Cape'
      },
      {
        code: 'WC',
        name: 'Western Cape'
      }
    ]
  }
];
